
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree05a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree05a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $cf8146e45b39b475$exports = {};
$parcel$extendImportMap({
    "9VN3G": "missing_favicon.209450c9.svg"
});

/**
* Copyright (c) 2025, Leon Sorokin
* All rights reserved. (MIT Licensed)
*
* uPlot.js (μPlot)
* A small, fast chart for time series, lines, areas, ohlc & bars
* https://github.com/leeoniya/uPlot (v1.6.32)
*/ const $3cd00ee63e984772$var$FEAT_TIME = true;
const $3cd00ee63e984772$var$pre = "u-";
const $3cd00ee63e984772$var$UPLOT = "uplot";
const $3cd00ee63e984772$var$ORI_HZ = $3cd00ee63e984772$var$pre + "hz";
const $3cd00ee63e984772$var$ORI_VT = $3cd00ee63e984772$var$pre + "vt";
const $3cd00ee63e984772$var$TITLE = $3cd00ee63e984772$var$pre + "title";
const $3cd00ee63e984772$var$WRAP = $3cd00ee63e984772$var$pre + "wrap";
const $3cd00ee63e984772$var$UNDER = $3cd00ee63e984772$var$pre + "under";
const $3cd00ee63e984772$var$OVER = $3cd00ee63e984772$var$pre + "over";
const $3cd00ee63e984772$var$AXIS = $3cd00ee63e984772$var$pre + "axis";
const $3cd00ee63e984772$var$OFF = $3cd00ee63e984772$var$pre + "off";
const $3cd00ee63e984772$var$SELECT = $3cd00ee63e984772$var$pre + "select";
const $3cd00ee63e984772$var$CURSOR_X = $3cd00ee63e984772$var$pre + "cursor-x";
const $3cd00ee63e984772$var$CURSOR_Y = $3cd00ee63e984772$var$pre + "cursor-y";
const $3cd00ee63e984772$var$CURSOR_PT = $3cd00ee63e984772$var$pre + "cursor-pt";
const $3cd00ee63e984772$var$LEGEND = $3cd00ee63e984772$var$pre + "legend";
const $3cd00ee63e984772$var$LEGEND_LIVE = $3cd00ee63e984772$var$pre + "live";
const $3cd00ee63e984772$var$LEGEND_INLINE = $3cd00ee63e984772$var$pre + "inline";
const $3cd00ee63e984772$var$LEGEND_SERIES = $3cd00ee63e984772$var$pre + "series";
const $3cd00ee63e984772$var$LEGEND_MARKER = $3cd00ee63e984772$var$pre + "marker";
const $3cd00ee63e984772$var$LEGEND_LABEL = $3cd00ee63e984772$var$pre + "label";
const $3cd00ee63e984772$var$LEGEND_VALUE = $3cd00ee63e984772$var$pre + "value";
const $3cd00ee63e984772$var$WIDTH = "width";
const $3cd00ee63e984772$var$HEIGHT = "height";
const $3cd00ee63e984772$var$TOP = "top";
const $3cd00ee63e984772$var$BOTTOM = "bottom";
const $3cd00ee63e984772$var$LEFT = "left";
const $3cd00ee63e984772$var$RIGHT = "right";
const $3cd00ee63e984772$var$hexBlack = "#000";
const $3cd00ee63e984772$var$transparent = $3cd00ee63e984772$var$hexBlack + "0";
const $3cd00ee63e984772$var$mousemove = "mousemove";
const $3cd00ee63e984772$var$mousedown = "mousedown";
const $3cd00ee63e984772$var$mouseup = "mouseup";
const $3cd00ee63e984772$var$mouseenter = "mouseenter";
const $3cd00ee63e984772$var$mouseleave = "mouseleave";
const $3cd00ee63e984772$var$dblclick = "dblclick";
const $3cd00ee63e984772$var$resize = "resize";
const $3cd00ee63e984772$var$scroll = "scroll";
const $3cd00ee63e984772$var$change = "change";
const $3cd00ee63e984772$var$dppxchange = "dppxchange";
const $3cd00ee63e984772$var$LEGEND_DISP = "--";
const $3cd00ee63e984772$var$domEnv = typeof window != 'undefined';
const $3cd00ee63e984772$var$doc = $3cd00ee63e984772$var$domEnv ? document : null;
const $3cd00ee63e984772$var$win = $3cd00ee63e984772$var$domEnv ? window : null;
const $3cd00ee63e984772$var$nav = $3cd00ee63e984772$var$domEnv ? navigator : null;
let $3cd00ee63e984772$var$pxRatio;
//export const canHover = domEnv && !win.matchMedia('(hover: none)').matches;
let $3cd00ee63e984772$var$query;
function $3cd00ee63e984772$var$setPxRatio() {
    let _pxRatio = devicePixelRatio;
    // during print preview, Chrome fires off these dppx queries even without changes
    if ($3cd00ee63e984772$var$pxRatio != _pxRatio) {
        $3cd00ee63e984772$var$pxRatio = _pxRatio;
        $3cd00ee63e984772$var$query && $3cd00ee63e984772$var$off($3cd00ee63e984772$var$change, $3cd00ee63e984772$var$query, $3cd00ee63e984772$var$setPxRatio);
        $3cd00ee63e984772$var$query = matchMedia(`(min-resolution: ${$3cd00ee63e984772$var$pxRatio - 0.001}dppx) and (max-resolution: ${$3cd00ee63e984772$var$pxRatio + 0.001}dppx)`);
        $3cd00ee63e984772$var$on($3cd00ee63e984772$var$change, $3cd00ee63e984772$var$query, $3cd00ee63e984772$var$setPxRatio);
        $3cd00ee63e984772$var$win.dispatchEvent(new CustomEvent($3cd00ee63e984772$var$dppxchange));
    }
}
function $3cd00ee63e984772$var$addClass(el, c) {
    if (c != null) {
        let cl = el.classList;
        !cl.contains(c) && cl.add(c);
    }
}
function $3cd00ee63e984772$var$remClass(el, c) {
    let cl = el.classList;
    cl.contains(c) && cl.remove(c);
}
function $3cd00ee63e984772$var$setStylePx(el, name, value) {
    el.style[name] = value + "px";
}
function $3cd00ee63e984772$var$placeTag(tag, cls, targ, refEl) {
    let el = $3cd00ee63e984772$var$doc.createElement(tag);
    if (cls != null) $3cd00ee63e984772$var$addClass(el, cls);
    if (targ != null) targ.insertBefore(el, refEl);
    return el;
}
function $3cd00ee63e984772$var$placeDiv(cls, targ) {
    return $3cd00ee63e984772$var$placeTag("div", cls, targ);
}
const $3cd00ee63e984772$var$xformCache = new WeakMap();
function $3cd00ee63e984772$var$elTrans(el, xPos, yPos, xMax, yMax) {
    let xform = "translate(" + xPos + "px," + yPos + "px)";
    let xformOld = $3cd00ee63e984772$var$xformCache.get(el);
    if (xform != xformOld) {
        el.style.transform = xform;
        $3cd00ee63e984772$var$xformCache.set(el, xform);
        if (xPos < 0 || yPos < 0 || xPos > xMax || yPos > yMax) $3cd00ee63e984772$var$addClass(el, $3cd00ee63e984772$var$OFF);
        else $3cd00ee63e984772$var$remClass(el, $3cd00ee63e984772$var$OFF);
    }
}
const $3cd00ee63e984772$var$colorCache = new WeakMap();
function $3cd00ee63e984772$var$elColor(el, background, borderColor) {
    let newColor = background + borderColor;
    let oldColor = $3cd00ee63e984772$var$colorCache.get(el);
    if (newColor != oldColor) {
        $3cd00ee63e984772$var$colorCache.set(el, newColor);
        el.style.background = background;
        el.style.borderColor = borderColor;
    }
}
const $3cd00ee63e984772$var$sizeCache = new WeakMap();
function $3cd00ee63e984772$var$elSize(el, newWid, newHgt, centered) {
    let newSize = newWid + "" + newHgt;
    let oldSize = $3cd00ee63e984772$var$sizeCache.get(el);
    if (newSize != oldSize) {
        $3cd00ee63e984772$var$sizeCache.set(el, newSize);
        el.style.height = newHgt + "px";
        el.style.width = newWid + "px";
        el.style.marginLeft = centered ? -newWid / 2 + "px" : 0;
        el.style.marginTop = centered ? -newHgt / 2 + "px" : 0;
    }
}
const $3cd00ee63e984772$var$evOpts = {
    passive: true
};
const $3cd00ee63e984772$var$evOpts2 = {
    ...$3cd00ee63e984772$var$evOpts,
    capture: true
};
function $3cd00ee63e984772$var$on(ev, el, cb, capt) {
    el.addEventListener(ev, cb, capt ? $3cd00ee63e984772$var$evOpts2 : $3cd00ee63e984772$var$evOpts);
}
function $3cd00ee63e984772$var$off(ev, el, cb, capt) {
    el.removeEventListener(ev, cb, $3cd00ee63e984772$var$evOpts);
}
$3cd00ee63e984772$var$domEnv && $3cd00ee63e984772$var$setPxRatio();
// binary search for index of closest value
function $3cd00ee63e984772$var$closestIdx(num, arr, lo, hi) {
    let mid;
    lo = lo || 0;
    hi = hi || arr.length - 1;
    let bitwise = hi <= 2147483647;
    while(hi - lo > 1){
        mid = bitwise ? lo + hi >> 1 : $3cd00ee63e984772$var$floor((lo + hi) / 2);
        if (arr[mid] < num) lo = mid;
        else hi = mid;
    }
    if (num - arr[lo] <= arr[hi] - num) return lo;
    return hi;
}
function $3cd00ee63e984772$var$makeIndexOfs(predicate) {
    let indexOfs = (data, _i0, _i1)=>{
        let i0 = -1;
        let i1 = -1;
        for(let i = _i0; i <= _i1; i++)if (predicate(data[i])) {
            i0 = i;
            break;
        }
        for(let i = _i1; i >= _i0; i--)if (predicate(data[i])) {
            i1 = i;
            break;
        }
        return [
            i0,
            i1
        ];
    };
    return indexOfs;
}
const $3cd00ee63e984772$var$notNullish = (v)=>v != null;
const $3cd00ee63e984772$var$isPositive = (v)=>v != null && v > 0;
const $3cd00ee63e984772$var$nonNullIdxs = $3cd00ee63e984772$var$makeIndexOfs($3cd00ee63e984772$var$notNullish);
const $3cd00ee63e984772$var$positiveIdxs = $3cd00ee63e984772$var$makeIndexOfs($3cd00ee63e984772$var$isPositive);
function $3cd00ee63e984772$var$getMinMax(data, _i0, _i1, sorted = 0, log = false) {
    //	console.log("getMinMax()");
    let getEdgeIdxs = log ? $3cd00ee63e984772$var$positiveIdxs : $3cd00ee63e984772$var$nonNullIdxs;
    let predicate = log ? $3cd00ee63e984772$var$isPositive : $3cd00ee63e984772$var$notNullish;
    [_i0, _i1] = getEdgeIdxs(data, _i0, _i1);
    let _min = data[_i0];
    let _max = data[_i0];
    if (_i0 > -1) {
        if (sorted == 1) {
            _min = data[_i0];
            _max = data[_i1];
        } else if (sorted == -1) {
            _min = data[_i1];
            _max = data[_i0];
        } else for(let i = _i0; i <= _i1; i++){
            let v = data[i];
            if (predicate(v)) {
                if (v < _min) _min = v;
                else if (v > _max) _max = v;
            }
        }
    }
    return [
        _min ?? $3cd00ee63e984772$var$inf,
        _max ?? -$3cd00ee63e984772$var$inf
    ]; // todo: fix to return nulls
}
function $3cd00ee63e984772$var$rangeLog(min, max, base, fullMags) {
    let minSign = $3cd00ee63e984772$var$sign(min);
    let maxSign = $3cd00ee63e984772$var$sign(max);
    if (min == max) {
        if (minSign == -1) {
            min *= base;
            max /= base;
        } else {
            min /= base;
            max *= base;
        }
    }
    let logFn = base == 10 ? $3cd00ee63e984772$var$log10 : $3cd00ee63e984772$var$log2;
    let growMinAbs = minSign == 1 ? $3cd00ee63e984772$var$floor : $3cd00ee63e984772$var$ceil;
    let growMaxAbs = maxSign == 1 ? $3cd00ee63e984772$var$ceil : $3cd00ee63e984772$var$floor;
    let minExp = growMinAbs(logFn($3cd00ee63e984772$var$abs(min)));
    let maxExp = growMaxAbs(logFn($3cd00ee63e984772$var$abs(max)));
    let minIncr = $3cd00ee63e984772$var$pow(base, minExp);
    let maxIncr = $3cd00ee63e984772$var$pow(base, maxExp);
    // fix values like Math.pow(10, -5) === 0.000009999999999999999
    if (base == 10) {
        if (minExp < 0) minIncr = $3cd00ee63e984772$var$roundDec(minIncr, -minExp);
        if (maxExp < 0) maxIncr = $3cd00ee63e984772$var$roundDec(maxIncr, -maxExp);
    }
    if (fullMags || base == 2) {
        min = minIncr * minSign;
        max = maxIncr * maxSign;
    } else {
        min = $3cd00ee63e984772$var$incrRoundDn(min, minIncr);
        max = $3cd00ee63e984772$var$incrRoundUp(max, maxIncr);
    }
    return [
        min,
        max
    ];
}
function $3cd00ee63e984772$var$rangeAsinh(min, max, base, fullMags) {
    let minMax = $3cd00ee63e984772$var$rangeLog(min, max, base, fullMags);
    if (min == 0) minMax[0] = 0;
    if (max == 0) minMax[1] = 0;
    return minMax;
}
const $3cd00ee63e984772$var$rangePad = 0.1;
const $3cd00ee63e984772$var$autoRangePart = {
    mode: 3,
    pad: $3cd00ee63e984772$var$rangePad
};
const $3cd00ee63e984772$var$_eqRangePart = {
    pad: 0,
    soft: null,
    mode: 0
};
const $3cd00ee63e984772$var$_eqRange = {
    min: $3cd00ee63e984772$var$_eqRangePart,
    max: $3cd00ee63e984772$var$_eqRangePart
};
// this ensures that non-temporal/numeric y-axes get multiple-snapped padding added above/below
// TODO: also account for incrs when snapping to ensure top of axis gets a tick & value
function $3cd00ee63e984772$var$rangeNum(_min, _max, mult, extra) {
    if ($3cd00ee63e984772$var$isObj(mult)) return $3cd00ee63e984772$var$_rangeNum(_min, _max, mult);
    $3cd00ee63e984772$var$_eqRangePart.pad = mult;
    $3cd00ee63e984772$var$_eqRangePart.soft = extra ? 0 : null;
    $3cd00ee63e984772$var$_eqRangePart.mode = extra ? 3 : 0;
    return $3cd00ee63e984772$var$_rangeNum(_min, _max, $3cd00ee63e984772$var$_eqRange);
}
// nullish coalesce
function $3cd00ee63e984772$var$ifNull(lh, rh) {
    return lh == null ? rh : lh;
}
// checks if given index range in an array contains a non-null value
// aka a range-bounded Array.some()
function $3cd00ee63e984772$var$hasData(data, idx0, idx1) {
    idx0 = $3cd00ee63e984772$var$ifNull(idx0, 0);
    idx1 = $3cd00ee63e984772$var$ifNull(idx1, data.length - 1);
    while(idx0 <= idx1){
        if (data[idx0] != null) return true;
        idx0++;
    }
    return false;
}
function $3cd00ee63e984772$var$_rangeNum(_min, _max, cfg) {
    let cmin = cfg.min;
    let cmax = cfg.max;
    let padMin = $3cd00ee63e984772$var$ifNull(cmin.pad, 0);
    let padMax = $3cd00ee63e984772$var$ifNull(cmax.pad, 0);
    let hardMin = $3cd00ee63e984772$var$ifNull(cmin.hard, -$3cd00ee63e984772$var$inf);
    let hardMax = $3cd00ee63e984772$var$ifNull(cmax.hard, $3cd00ee63e984772$var$inf);
    let softMin = $3cd00ee63e984772$var$ifNull(cmin.soft, $3cd00ee63e984772$var$inf);
    let softMax = $3cd00ee63e984772$var$ifNull(cmax.soft, -$3cd00ee63e984772$var$inf);
    let softMinMode = $3cd00ee63e984772$var$ifNull(cmin.mode, 0);
    let softMaxMode = $3cd00ee63e984772$var$ifNull(cmax.mode, 0);
    let delta = _max - _min;
    let deltaMag = $3cd00ee63e984772$var$log10(delta);
    let scalarMax = $3cd00ee63e984772$var$max($3cd00ee63e984772$var$abs(_min), $3cd00ee63e984772$var$abs(_max));
    let scalarMag = $3cd00ee63e984772$var$log10(scalarMax);
    let scalarMagDelta = $3cd00ee63e984772$var$abs(scalarMag - deltaMag);
    // this handles situations like 89.7, 89.69999999999999
    // by assuming 0.001x deltas are precision errors
    //	if (delta > 0 && delta < abs(_max) / 1e3)
    //		delta = 0;
    // treat data as flat if delta is less than 1e-24
    // or range is 11+ orders of magnitude below raw values, e.g. 99999999.99999996 - 100000000.00000004
    if (delta < 1e-24 || scalarMagDelta > 10) {
        delta = 0;
        // if soft mode is 2 and all vals are flat at 0, avoid the 0.1 * 1e3 fallback
        // this prevents 0,0,0 from ranging to -100,100 when softMin/softMax are -1,1
        if (_min == 0 || _max == 0) {
            delta = 1e-24;
            if (softMinMode == 2 && softMin != $3cd00ee63e984772$var$inf) padMin = 0;
            if (softMaxMode == 2 && softMax != -$3cd00ee63e984772$var$inf) padMax = 0;
        }
    }
    let nonZeroDelta = delta || scalarMax || 1e3;
    let mag = $3cd00ee63e984772$var$log10(nonZeroDelta);
    let base = $3cd00ee63e984772$var$pow(10, $3cd00ee63e984772$var$floor(mag));
    let _padMin = nonZeroDelta * (delta == 0 ? _min == 0 ? .1 : 1 : padMin);
    let _newMin = $3cd00ee63e984772$var$roundDec($3cd00ee63e984772$var$incrRoundDn(_min - _padMin, base / 10), 24);
    let _softMin = _min >= softMin && (softMinMode == 1 || softMinMode == 3 && _newMin <= softMin || softMinMode == 2 && _newMin >= softMin) ? softMin : $3cd00ee63e984772$var$inf;
    let minLim = $3cd00ee63e984772$var$max(hardMin, _newMin < _softMin && _min >= _softMin ? _softMin : $3cd00ee63e984772$var$min(_softMin, _newMin));
    let _padMax = nonZeroDelta * (delta == 0 ? _max == 0 ? .1 : 1 : padMax);
    let _newMax = $3cd00ee63e984772$var$roundDec($3cd00ee63e984772$var$incrRoundUp(_max + _padMax, base / 10), 24);
    let _softMax = _max <= softMax && (softMaxMode == 1 || softMaxMode == 3 && _newMax >= softMax || softMaxMode == 2 && _newMax <= softMax) ? softMax : -$3cd00ee63e984772$var$inf;
    let maxLim = $3cd00ee63e984772$var$min(hardMax, _newMax > _softMax && _max <= _softMax ? _softMax : $3cd00ee63e984772$var$max(_softMax, _newMax));
    if (minLim == maxLim && minLim == 0) maxLim = 100;
    return [
        minLim,
        maxLim
    ];
}
// alternative: https://stackoverflow.com/a/2254896
const $3cd00ee63e984772$var$numFormatter = new Intl.NumberFormat($3cd00ee63e984772$var$domEnv ? $3cd00ee63e984772$var$nav.language : 'en-US');
const $3cd00ee63e984772$var$fmtNum = (val)=>$3cd00ee63e984772$var$numFormatter.format(val);
const $3cd00ee63e984772$var$M = Math;
const $3cd00ee63e984772$var$PI = $3cd00ee63e984772$var$M.PI;
const $3cd00ee63e984772$var$abs = $3cd00ee63e984772$var$M.abs;
const $3cd00ee63e984772$var$floor = $3cd00ee63e984772$var$M.floor;
const $3cd00ee63e984772$var$round = $3cd00ee63e984772$var$M.round;
const $3cd00ee63e984772$var$ceil = $3cd00ee63e984772$var$M.ceil;
const $3cd00ee63e984772$var$min = $3cd00ee63e984772$var$M.min;
const $3cd00ee63e984772$var$max = $3cd00ee63e984772$var$M.max;
const $3cd00ee63e984772$var$pow = $3cd00ee63e984772$var$M.pow;
const $3cd00ee63e984772$var$sign = $3cd00ee63e984772$var$M.sign;
const $3cd00ee63e984772$var$log10 = $3cd00ee63e984772$var$M.log10;
const $3cd00ee63e984772$var$log2 = $3cd00ee63e984772$var$M.log2;
// TODO: seems like this needs to match asinh impl if the passed v is tweaked?
const $3cd00ee63e984772$var$sinh = (v, linthresh = 1)=>$3cd00ee63e984772$var$M.sinh(v) * linthresh;
const $3cd00ee63e984772$var$asinh = (v, linthresh = 1)=>$3cd00ee63e984772$var$M.asinh(v / linthresh);
const $3cd00ee63e984772$var$inf = Infinity;
function $3cd00ee63e984772$var$numIntDigits(x) {
    return ($3cd00ee63e984772$var$log10((x ^ x >> 31) - (x >> 31)) | 0) + 1;
}
function $3cd00ee63e984772$var$clamp(num, _min, _max) {
    return $3cd00ee63e984772$var$min($3cd00ee63e984772$var$max(num, _min), _max);
}
function $3cd00ee63e984772$var$isFn(v) {
    return typeof v == "function";
}
function $3cd00ee63e984772$var$fnOrSelf(v) {
    return $3cd00ee63e984772$var$isFn(v) ? v : ()=>v;
}
const $3cd00ee63e984772$var$noop = ()=>{};
// note: these identity fns may get deoptimized if reused for different arg types
// a TS version would enforce they stay monotyped and require making variants
const $3cd00ee63e984772$var$retArg0 = (_0)=>_0;
const $3cd00ee63e984772$var$retArg1 = (_0, _1)=>_1;
const $3cd00ee63e984772$var$retNull = (_)=>null;
const $3cd00ee63e984772$var$retTrue = (_)=>true;
const $3cd00ee63e984772$var$retEq = (a, b)=>a == b;
const $3cd00ee63e984772$var$regex6 = /\.\d*?(?=9{6,}|0{6,})/gm;
// e.g. 17999.204999999998 -> 17999.205
const $3cd00ee63e984772$var$fixFloat = (val)=>{
    if ($3cd00ee63e984772$var$isInt(val) || $3cd00ee63e984772$var$fixedDec.has(val)) return val;
    const str = `${val}`;
    const match = str.match($3cd00ee63e984772$var$regex6);
    if (match == null) return val;
    let len = match[0].length - 1;
    // e.g. 1.0000000000000001e-24
    if (str.indexOf('e-') != -1) {
        let [num, exp] = str.split('e');
        return +`${$3cd00ee63e984772$var$fixFloat(num)}e${exp}`;
    }
    return $3cd00ee63e984772$var$roundDec(val, len);
};
function $3cd00ee63e984772$var$incrRound(num, incr) {
    return $3cd00ee63e984772$var$fixFloat($3cd00ee63e984772$var$roundDec($3cd00ee63e984772$var$fixFloat(num / incr)) * incr);
}
function $3cd00ee63e984772$var$incrRoundUp(num, incr) {
    return $3cd00ee63e984772$var$fixFloat($3cd00ee63e984772$var$ceil($3cd00ee63e984772$var$fixFloat(num / incr)) * incr);
}
function $3cd00ee63e984772$var$incrRoundDn(num, incr) {
    return $3cd00ee63e984772$var$fixFloat($3cd00ee63e984772$var$floor($3cd00ee63e984772$var$fixFloat(num / incr)) * incr);
}
// https://stackoverflow.com/a/48764436
// rounds half away from zero
function $3cd00ee63e984772$var$roundDec(val, dec = 0) {
    if ($3cd00ee63e984772$var$isInt(val)) return val;
    //	else if (dec == 0)
    //		return round(val);
    let p = 10 ** dec;
    let n = val * p * (1 + Number.EPSILON);
    return $3cd00ee63e984772$var$round(n) / p;
}
const $3cd00ee63e984772$var$fixedDec = new Map();
function $3cd00ee63e984772$var$guessDec(num) {
    return (("" + num).split(".")[1] || "").length;
}
function $3cd00ee63e984772$var$genIncrs(base, minExp, maxExp, mults) {
    let incrs = [];
    let multDec = mults.map($3cd00ee63e984772$var$guessDec);
    for(let exp = minExp; exp < maxExp; exp++){
        let expa = $3cd00ee63e984772$var$abs(exp);
        let mag = $3cd00ee63e984772$var$roundDec($3cd00ee63e984772$var$pow(base, exp), expa);
        for(let i = 0; i < mults.length; i++){
            let _incr = base == 10 ? +`${mults[i]}e${exp}` : mults[i] * mag;
            let dec = (exp >= 0 ? 0 : expa) + (exp >= multDec[i] ? 0 : multDec[i]);
            let incr = base == 10 ? _incr : $3cd00ee63e984772$var$roundDec(_incr, dec);
            incrs.push(incr);
            $3cd00ee63e984772$var$fixedDec.set(incr, dec);
        }
    }
    return incrs;
}
//export const assign = Object.assign;
const $3cd00ee63e984772$var$EMPTY_OBJ = {};
const $3cd00ee63e984772$var$EMPTY_ARR = [];
const $3cd00ee63e984772$var$nullNullTuple = [
    null,
    null
];
const $3cd00ee63e984772$var$isArr = Array.isArray;
const $3cd00ee63e984772$var$isInt = Number.isInteger;
const $3cd00ee63e984772$var$isUndef = (v)=>v === void 0;
function $3cd00ee63e984772$var$isStr(v) {
    return typeof v == 'string';
}
function $3cd00ee63e984772$var$isObj(v) {
    let is = false;
    if (v != null) {
        let c = v.constructor;
        is = c == null || c == Object;
    }
    return is;
}
function $3cd00ee63e984772$var$fastIsObj(v) {
    return v != null && typeof v == 'object';
}
const $3cd00ee63e984772$var$TypedArray = Object.getPrototypeOf(Uint8Array);
const $3cd00ee63e984772$var$__proto__ = "__proto__";
function $3cd00ee63e984772$var$copy(o, _isObj = $3cd00ee63e984772$var$isObj) {
    let out;
    if ($3cd00ee63e984772$var$isArr(o)) {
        let val = o.find((v)=>v != null);
        if ($3cd00ee63e984772$var$isArr(val) || _isObj(val)) {
            out = Array(o.length);
            for(let i = 0; i < o.length; i++)out[i] = $3cd00ee63e984772$var$copy(o[i], _isObj);
        } else out = o.slice();
    } else if (o instanceof $3cd00ee63e984772$var$TypedArray) out = o.slice();
    else if (_isObj(o)) {
        out = {};
        for(let k in o)if (k != $3cd00ee63e984772$var$__proto__) out[k] = $3cd00ee63e984772$var$copy(o[k], _isObj);
    } else out = o;
    return out;
}
function $3cd00ee63e984772$var$assign(targ) {
    let args = arguments;
    for(let i = 1; i < args.length; i++){
        let src = args[i];
        for(let key in src)if (key != $3cd00ee63e984772$var$__proto__) {
            if ($3cd00ee63e984772$var$isObj(targ[key])) $3cd00ee63e984772$var$assign(targ[key], $3cd00ee63e984772$var$copy(src[key]));
            else targ[key] = $3cd00ee63e984772$var$copy(src[key]);
        }
    }
    return targ;
}
// nullModes
const $3cd00ee63e984772$var$NULL_REMOVE = 0; // nulls are converted to undefined (e.g. for spanGaps: true)
const $3cd00ee63e984772$var$NULL_RETAIN = 1; // nulls are retained, with alignment artifacts set to undefined (default)
const $3cd00ee63e984772$var$NULL_EXPAND = 2; // nulls are expanded to include any adjacent alignment artifacts
// sets undefined values to nulls when adjacent to existing nulls (minesweeper)
function $3cd00ee63e984772$var$nullExpand(yVals, nullIdxs, alignedLen) {
    for(let i = 0, xi, lastNullIdx = -1; i < nullIdxs.length; i++){
        let nullIdx = nullIdxs[i];
        if (nullIdx > lastNullIdx) {
            xi = nullIdx - 1;
            while(xi >= 0 && yVals[xi] == null)yVals[xi--] = null;
            xi = nullIdx + 1;
            while(xi < alignedLen && yVals[xi] == null)yVals[lastNullIdx = xi++] = null;
        }
    }
}
// nullModes is a tables-matched array indicating how to treat nulls in each series
// output is sorted ASC on the joined field (table[0]) and duplicate join values are collapsed
function $3cd00ee63e984772$var$join(tables, nullModes) {
    if ($3cd00ee63e984772$var$allHeadersSame(tables)) {
        //	console.log('cheap join!');
        let table = tables[0].slice();
        for(let i = 1; i < tables.length; i++)table.push(...tables[i].slice(1));
        if (!$3cd00ee63e984772$var$isAsc(table[0])) table = $3cd00ee63e984772$var$sortCols(table);
        return table;
    }
    let xVals = new Set();
    for(let ti = 0; ti < tables.length; ti++){
        let t = tables[ti];
        let xs = t[0];
        let len = xs.length;
        for(let i = 0; i < len; i++)xVals.add(xs[i]);
    }
    let data = [
        Array.from(xVals).sort((a, b)=>a - b)
    ];
    let alignedLen = data[0].length;
    let xIdxs = new Map();
    for(let i = 0; i < alignedLen; i++)xIdxs.set(data[0][i], i);
    for(let ti = 0; ti < tables.length; ti++){
        let t = tables[ti];
        let xs = t[0];
        for(let si = 1; si < t.length; si++){
            let ys = t[si];
            let yVals = Array(alignedLen).fill(undefined);
            let nullMode = nullModes ? nullModes[ti][si] : $3cd00ee63e984772$var$NULL_RETAIN;
            let nullIdxs = [];
            for(let i = 0; i < ys.length; i++){
                let yVal = ys[i];
                let alignedIdx = xIdxs.get(xs[i]);
                if (yVal === null) {
                    if (nullMode != $3cd00ee63e984772$var$NULL_REMOVE) {
                        yVals[alignedIdx] = yVal;
                        if (nullMode == $3cd00ee63e984772$var$NULL_EXPAND) nullIdxs.push(alignedIdx);
                    }
                } else yVals[alignedIdx] = yVal;
            }
            $3cd00ee63e984772$var$nullExpand(yVals, nullIdxs, alignedLen);
            data.push(yVals);
        }
    }
    return data;
}
const $3cd00ee63e984772$var$microTask = typeof queueMicrotask == "undefined" ? (fn)=>Promise.resolve().then(fn) : queueMicrotask;
// TODO: https://github.com/dy/sort-ids (~2x faster for 1e5+ arrays)
function $3cd00ee63e984772$var$sortCols(table) {
    let head = table[0];
    let rlen = head.length;
    let idxs = Array(rlen);
    for(let i = 0; i < idxs.length; i++)idxs[i] = i;
    idxs.sort((i0, i1)=>head[i0] - head[i1]);
    let table2 = [];
    for(let i = 0; i < table.length; i++){
        let row = table[i];
        let row2 = Array(rlen);
        for(let j = 0; j < rlen; j++)row2[j] = row[idxs[j]];
        table2.push(row2);
    }
    return table2;
}
// test if we can do cheap join (all join fields same)
function $3cd00ee63e984772$var$allHeadersSame(tables) {
    let vals0 = tables[0][0];
    let len0 = vals0.length;
    for(let i = 1; i < tables.length; i++){
        let vals1 = tables[i][0];
        if (vals1.length != len0) return false;
        if (vals1 != vals0) for(let j = 0; j < len0; j++){
            if (vals1[j] != vals0[j]) return false;
        }
    }
    return true;
}
function $3cd00ee63e984772$var$isAsc(vals, samples = 100) {
    const len = vals.length;
    // empty or single value
    if (len <= 1) return true;
    // skip leading & trailing nullish
    let firstIdx = 0;
    let lastIdx = len - 1;
    while(firstIdx <= lastIdx && vals[firstIdx] == null)firstIdx++;
    while(lastIdx >= firstIdx && vals[lastIdx] == null)lastIdx--;
    // all nullish or one value surrounded by nullish
    if (lastIdx <= firstIdx) return true;
    const stride = $3cd00ee63e984772$var$max(1, $3cd00ee63e984772$var$floor((lastIdx - firstIdx + 1) / samples));
    for(let prevVal = vals[firstIdx], i = firstIdx + stride; i <= lastIdx; i += stride){
        const v = vals[i];
        if (v != null) {
            if (v <= prevVal) return false;
            prevVal = v;
        }
    }
    return true;
}
const $3cd00ee63e984772$var$months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $3cd00ee63e984772$var$days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
function $3cd00ee63e984772$var$slice3(str) {
    return str.slice(0, 3);
}
const $3cd00ee63e984772$var$days3 = $3cd00ee63e984772$var$days.map($3cd00ee63e984772$var$slice3);
const $3cd00ee63e984772$var$months3 = $3cd00ee63e984772$var$months.map($3cd00ee63e984772$var$slice3);
const $3cd00ee63e984772$var$engNames = {
    MMMM: $3cd00ee63e984772$var$months,
    MMM: $3cd00ee63e984772$var$months3,
    WWWW: $3cd00ee63e984772$var$days,
    WWW: $3cd00ee63e984772$var$days3
};
function $3cd00ee63e984772$var$zeroPad2(int) {
    return (int < 10 ? '0' : '') + int;
}
function $3cd00ee63e984772$var$zeroPad3(int) {
    return (int < 10 ? '00' : int < 100 ? '0' : '') + int;
}
/*
function suffix(int) {
	let mod10 = int % 10;

	return int + (
		mod10 == 1 && int != 11 ? "st" :
		mod10 == 2 && int != 12 ? "nd" :
		mod10 == 3 && int != 13 ? "rd" : "th"
	);
}
*/ const $3cd00ee63e984772$var$subs = {
    // 2019
    YYYY: (d)=>d.getFullYear(),
    // 19
    YY: (d)=>(d.getFullYear() + '').slice(2),
    // July
    MMMM: (d, names)=>names.MMMM[d.getMonth()],
    // Jul
    MMM: (d, names)=>names.MMM[d.getMonth()],
    // 07
    MM: (d)=>$3cd00ee63e984772$var$zeroPad2(d.getMonth() + 1),
    // 7
    M: (d)=>d.getMonth() + 1,
    // 09
    DD: (d)=>$3cd00ee63e984772$var$zeroPad2(d.getDate()),
    // 9
    D: (d)=>d.getDate(),
    // Monday
    WWWW: (d, names)=>names.WWWW[d.getDay()],
    // Mon
    WWW: (d, names)=>names.WWW[d.getDay()],
    // 03
    HH: (d)=>$3cd00ee63e984772$var$zeroPad2(d.getHours()),
    // 3
    H: (d)=>d.getHours(),
    // 9 (12hr, unpadded)
    h: (d)=>{
        let h = d.getHours();
        return h == 0 ? 12 : h > 12 ? h - 12 : h;
    },
    // AM
    AA: (d)=>d.getHours() >= 12 ? 'PM' : 'AM',
    // am
    aa: (d)=>d.getHours() >= 12 ? 'pm' : 'am',
    // a
    a: (d)=>d.getHours() >= 12 ? 'p' : 'a',
    // 09
    mm: (d)=>$3cd00ee63e984772$var$zeroPad2(d.getMinutes()),
    // 9
    m: (d)=>d.getMinutes(),
    // 09
    ss: (d)=>$3cd00ee63e984772$var$zeroPad2(d.getSeconds()),
    // 9
    s: (d)=>d.getSeconds(),
    // 374
    fff: (d)=>$3cd00ee63e984772$var$zeroPad3(d.getMilliseconds())
};
function $3cd00ee63e984772$var$fmtDate(tpl, names) {
    names = names || $3cd00ee63e984772$var$engNames;
    let parts = [];
    let R = /\{([a-z]+)\}|[^{]+/gi, m;
    while(m = R.exec(tpl))parts.push(m[0][0] == '{' ? $3cd00ee63e984772$var$subs[m[1]] : m[0]);
    return (d)=>{
        let out = '';
        for(let i = 0; i < parts.length; i++)out += typeof parts[i] == "string" ? parts[i] : parts[i](d, names);
        return out;
    };
}
const $3cd00ee63e984772$var$localTz = new Intl.DateTimeFormat().resolvedOptions().timeZone;
// https://stackoverflow.com/questions/15141762/how-to-initialize-a-javascript-date-to-a-particular-time-zone/53652131#53652131
function $3cd00ee63e984772$var$tzDate(date, tz) {
    let date2;
    // perf optimization
    if (tz == 'UTC' || tz == 'Etc/UTC') date2 = new Date(+date + date.getTimezoneOffset() * 6e4);
    else if (tz == $3cd00ee63e984772$var$localTz) date2 = date;
    else {
        date2 = new Date(date.toLocaleString('en-US', {
            timeZone: tz
        }));
        date2.setMilliseconds(date.getMilliseconds());
    }
    return date2;
}
//export const series = [];
// default formatters:
const $3cd00ee63e984772$var$onlyWhole = (v)=>v % 1 == 0;
const $3cd00ee63e984772$var$allMults = [
    1,
    2,
    2.5,
    5
];
// ...0.01, 0.02, 0.025, 0.05, 0.1, 0.2, 0.25, 0.5
const $3cd00ee63e984772$var$decIncrs = $3cd00ee63e984772$var$genIncrs(10, -32, 0, $3cd00ee63e984772$var$allMults);
// 1, 2, 2.5, 5, 10, 20, 25, 50...
const $3cd00ee63e984772$var$oneIncrs = $3cd00ee63e984772$var$genIncrs(10, 0, 32, $3cd00ee63e984772$var$allMults);
// 1, 2,      5, 10, 20, 25, 50...
const $3cd00ee63e984772$var$wholeIncrs = $3cd00ee63e984772$var$oneIncrs.filter($3cd00ee63e984772$var$onlyWhole);
const $3cd00ee63e984772$var$numIncrs = $3cd00ee63e984772$var$decIncrs.concat($3cd00ee63e984772$var$oneIncrs);
const $3cd00ee63e984772$var$NL = "\n";
const $3cd00ee63e984772$var$yyyy = "{YYYY}";
const $3cd00ee63e984772$var$NLyyyy = $3cd00ee63e984772$var$NL + $3cd00ee63e984772$var$yyyy;
const $3cd00ee63e984772$var$md = "{M}/{D}";
const $3cd00ee63e984772$var$NLmd = $3cd00ee63e984772$var$NL + $3cd00ee63e984772$var$md;
const $3cd00ee63e984772$var$NLmdyy = $3cd00ee63e984772$var$NLmd + "/{YY}";
const $3cd00ee63e984772$var$aa = "{aa}";
const $3cd00ee63e984772$var$hmm = "{h}:{mm}";
const $3cd00ee63e984772$var$hmmaa = $3cd00ee63e984772$var$hmm + $3cd00ee63e984772$var$aa;
const $3cd00ee63e984772$var$NLhmmaa = $3cd00ee63e984772$var$NL + $3cd00ee63e984772$var$hmmaa;
const $3cd00ee63e984772$var$ss = ":{ss}";
const $3cd00ee63e984772$var$_ = null;
function $3cd00ee63e984772$var$genTimeStuffs(ms) {
    let s = ms * 1e3, m = s * 60, h = m * 60, d = h * 24, mo = d * 30, y = d * 365;
    // min of 1e-3 prevents setting a temporal x ticks too small since Date objects cannot advance ticks smaller than 1ms
    let subSecIncrs = ms == 1 ? $3cd00ee63e984772$var$genIncrs(10, 0, 3, $3cd00ee63e984772$var$allMults).filter($3cd00ee63e984772$var$onlyWhole) : $3cd00ee63e984772$var$genIncrs(10, -3, 0, $3cd00ee63e984772$var$allMults);
    let timeIncrs = subSecIncrs.concat([
        // minute divisors (# of secs)
        s,
        s * 5,
        s * 10,
        s * 15,
        s * 30,
        // hour divisors (# of mins)
        m,
        m * 5,
        m * 10,
        m * 15,
        m * 30,
        // day divisors (# of hrs)
        h,
        h * 2,
        h * 3,
        h * 4,
        h * 6,
        h * 8,
        h * 12,
        // month divisors TODO: need more?
        d,
        d * 2,
        d * 3,
        d * 4,
        d * 5,
        d * 6,
        d * 7,
        d * 8,
        d * 9,
        d * 10,
        d * 15,
        // year divisors (# months, approx)
        mo,
        mo * 2,
        mo * 3,
        mo * 4,
        mo * 6,
        // century divisors
        y,
        y * 2,
        y * 5,
        y * 10,
        y * 25,
        y * 50,
        y * 100
    ]);
    // [0]:   minimum num secs in the tick incr
    // [1]:   default tick format
    // [2-7]: rollover tick formats
    // [8]:   mode: 0: replace [1] -> [2-7], 1: concat [1] + [2-7]
    const _timeAxisStamps = [
        //   tick incr    default          year                    month   day                   hour    min       sec   mode
        [
            y,
            $3cd00ee63e984772$var$yyyy,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            1
        ],
        [
            d * 28,
            "{MMM}",
            $3cd00ee63e984772$var$NLyyyy,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            1
        ],
        [
            d,
            $3cd00ee63e984772$var$md,
            $3cd00ee63e984772$var$NLyyyy,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            1
        ],
        [
            h,
            "{h}" + $3cd00ee63e984772$var$aa,
            $3cd00ee63e984772$var$NLmdyy,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$NLmd,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            1
        ],
        [
            m,
            $3cd00ee63e984772$var$hmmaa,
            $3cd00ee63e984772$var$NLmdyy,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$NLmd,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$_,
            1
        ],
        [
            s,
            $3cd00ee63e984772$var$ss,
            $3cd00ee63e984772$var$NLmdyy + " " + $3cd00ee63e984772$var$hmmaa,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$NLmd + " " + $3cd00ee63e984772$var$hmmaa,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$NLhmmaa,
            $3cd00ee63e984772$var$_,
            1
        ],
        [
            ms,
            $3cd00ee63e984772$var$ss + ".{fff}",
            $3cd00ee63e984772$var$NLmdyy + " " + $3cd00ee63e984772$var$hmmaa,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$NLmd + " " + $3cd00ee63e984772$var$hmmaa,
            $3cd00ee63e984772$var$_,
            $3cd00ee63e984772$var$NLhmmaa,
            $3cd00ee63e984772$var$_,
            1
        ]
    ];
    // the ensures that axis ticks, values & grid are aligned to logical temporal breakpoints and not an arbitrary timestamp
    // https://www.timeanddate.com/time/dst/
    // https://www.timeanddate.com/time/dst/2019.html
    // https://www.epochconverter.com/timezones
    function timeAxisSplits(tzDate) {
        return (self, axisIdx, scaleMin, scaleMax, foundIncr, foundSpace)=>{
            let splits = [];
            let isYr = foundIncr >= y;
            let isMo = foundIncr >= mo && foundIncr < y;
            // get the timezone-adjusted date
            let minDate = tzDate(scaleMin);
            let minDateTs = $3cd00ee63e984772$var$roundDec(minDate * ms, 3);
            // get ts of 12am (this lands us at or before the original scaleMin)
            let minMin = $3cd00ee63e984772$var$mkDate(minDate.getFullYear(), isYr ? 0 : minDate.getMonth(), isMo || isYr ? 1 : minDate.getDate());
            let minMinTs = $3cd00ee63e984772$var$roundDec(minMin * ms, 3);
            if (isMo || isYr) {
                let moIncr = isMo ? foundIncr / mo : 0;
                let yrIncr = isYr ? foundIncr / y : 0;
                //	let tzOffset = scaleMin - minDateTs;		// needed?
                let split = minDateTs == minMinTs ? minDateTs : $3cd00ee63e984772$var$roundDec($3cd00ee63e984772$var$mkDate(minMin.getFullYear() + yrIncr, minMin.getMonth() + moIncr, 1) * ms, 3);
                let splitDate = new Date($3cd00ee63e984772$var$round(split / ms));
                let baseYear = splitDate.getFullYear();
                let baseMonth = splitDate.getMonth();
                for(let i = 0; split <= scaleMax; i++){
                    let next = $3cd00ee63e984772$var$mkDate(baseYear + yrIncr * i, baseMonth + moIncr * i, 1);
                    let offs = next - tzDate($3cd00ee63e984772$var$roundDec(next * ms, 3));
                    split = $3cd00ee63e984772$var$roundDec((+next + offs) * ms, 3);
                    if (split <= scaleMax) splits.push(split);
                }
            } else {
                let incr0 = foundIncr >= d ? d : foundIncr;
                let tzOffset = $3cd00ee63e984772$var$floor(scaleMin) - $3cd00ee63e984772$var$floor(minDateTs);
                let split = minMinTs + tzOffset + $3cd00ee63e984772$var$incrRoundUp(minDateTs - minMinTs, incr0);
                splits.push(split);
                let date0 = tzDate(split);
                let prevHour = date0.getHours() + date0.getMinutes() / m + date0.getSeconds() / h;
                let incrHours = foundIncr / h;
                let minSpace = self.axes[axisIdx]._space;
                let pctSpace = foundSpace / minSpace;
                while(true){
                    split = $3cd00ee63e984772$var$roundDec(split + foundIncr, ms == 1 ? 0 : 3);
                    if (split > scaleMax) break;
                    if (incrHours > 1) {
                        let expectedHour = $3cd00ee63e984772$var$floor($3cd00ee63e984772$var$roundDec(prevHour + incrHours, 6)) % 24;
                        let splitDate = tzDate(split);
                        let actualHour = splitDate.getHours();
                        let dstShift = actualHour - expectedHour;
                        if (dstShift > 1) dstShift = -1;
                        split -= dstShift * h;
                        prevHour = (prevHour + incrHours) % 24;
                        // add a tick only if it's further than 70% of the min allowed label spacing
                        let prevSplit = splits[splits.length - 1];
                        let pctIncr = $3cd00ee63e984772$var$roundDec((split - prevSplit) / foundIncr, 3);
                        if (pctIncr * pctSpace >= .7) splits.push(split);
                    } else splits.push(split);
                }
            }
            return splits;
        };
    }
    return [
        timeIncrs,
        _timeAxisStamps,
        timeAxisSplits
    ];
}
const [$3cd00ee63e984772$var$timeIncrsMs, $3cd00ee63e984772$var$_timeAxisStampsMs, $3cd00ee63e984772$var$timeAxisSplitsMs] = $3cd00ee63e984772$var$genTimeStuffs(1);
const [$3cd00ee63e984772$var$timeIncrsS, $3cd00ee63e984772$var$_timeAxisStampsS, $3cd00ee63e984772$var$timeAxisSplitsS] = $3cd00ee63e984772$var$genTimeStuffs(1e-3);
// base 2
$3cd00ee63e984772$var$genIncrs(2, -53, 53, [
    1
]);
/*
console.log({
	decIncrs,
	oneIncrs,
	wholeIncrs,
	numIncrs,
	timeIncrs,
	fixedDec,
});
*/ function $3cd00ee63e984772$var$timeAxisStamps(stampCfg, fmtDate) {
    return stampCfg.map((s)=>s.map((v, i)=>i == 0 || i == 8 || v == null ? v : fmtDate(i == 1 || s[8] == 0 ? v : s[1] + v)));
}
// TODO: will need to accept spaces[] and pull incr into the loop when grid will be non-uniform, eg for log scales.
// currently we ignore this for months since they're *nearly* uniform and the added complexity is not worth it
function $3cd00ee63e984772$var$timeAxisVals(tzDate, stamps) {
    return (self, splits, axisIdx, foundSpace, foundIncr)=>{
        let s = stamps.find((s)=>foundIncr >= s[0]) || stamps[stamps.length - 1];
        // these track boundaries when a full label is needed again
        let prevYear;
        let prevMnth;
        let prevDate;
        let prevHour;
        let prevMins;
        let prevSecs;
        return splits.map((split)=>{
            let date = tzDate(split);
            let newYear = date.getFullYear();
            let newMnth = date.getMonth();
            let newDate = date.getDate();
            let newHour = date.getHours();
            let newMins = date.getMinutes();
            let newSecs = date.getSeconds();
            let stamp = newYear != prevYear && s[2] || newMnth != prevMnth && s[3] || newDate != prevDate && s[4] || newHour != prevHour && s[5] || newMins != prevMins && s[6] || newSecs != prevSecs && s[7] || s[1];
            prevYear = newYear;
            prevMnth = newMnth;
            prevDate = newDate;
            prevHour = newHour;
            prevMins = newMins;
            prevSecs = newSecs;
            return stamp(date);
        });
    };
}
// for when axis.values is defined as a static fmtDate template string
function $3cd00ee63e984772$var$timeAxisVal(tzDate, dateTpl) {
    let stamp = $3cd00ee63e984772$var$fmtDate(dateTpl);
    return (self, splits, axisIdx, foundSpace, foundIncr)=>splits.map((split)=>stamp(tzDate(split)));
}
function $3cd00ee63e984772$var$mkDate(y, m, d) {
    return new Date(y, m, d);
}
function $3cd00ee63e984772$var$timeSeriesStamp(stampCfg, fmtDate) {
    return fmtDate(stampCfg);
}
const $3cd00ee63e984772$var$_timeSeriesStamp = '{YYYY}-{MM}-{DD} {h}:{mm}{aa}';
function $3cd00ee63e984772$var$timeSeriesVal(tzDate, stamp) {
    return (self, val, seriesIdx, dataIdx)=>dataIdx == null ? $3cd00ee63e984772$var$LEGEND_DISP : stamp(tzDate(val));
}
function $3cd00ee63e984772$var$legendStroke(self, seriesIdx) {
    let s = self.series[seriesIdx];
    return s.width ? s.stroke(self, seriesIdx) : s.points.width ? s.points.stroke(self, seriesIdx) : null;
}
function $3cd00ee63e984772$var$legendFill(self, seriesIdx) {
    return self.series[seriesIdx].fill(self, seriesIdx);
}
const $3cd00ee63e984772$var$legendOpts = {
    show: true,
    live: true,
    isolate: false,
    mount: $3cd00ee63e984772$var$noop,
    markers: {
        show: true,
        width: 2,
        stroke: $3cd00ee63e984772$var$legendStroke,
        fill: $3cd00ee63e984772$var$legendFill,
        dash: "solid"
    },
    idx: null,
    idxs: null,
    values: []
};
function $3cd00ee63e984772$var$cursorPointShow(self, si) {
    let o = self.cursor.points;
    let pt = $3cd00ee63e984772$var$placeDiv();
    let size = o.size(self, si);
    $3cd00ee63e984772$var$setStylePx(pt, $3cd00ee63e984772$var$WIDTH, size);
    $3cd00ee63e984772$var$setStylePx(pt, $3cd00ee63e984772$var$HEIGHT, size);
    let mar = size / -2;
    $3cd00ee63e984772$var$setStylePx(pt, "marginLeft", mar);
    $3cd00ee63e984772$var$setStylePx(pt, "marginTop", mar);
    let width = o.width(self, si, size);
    width && $3cd00ee63e984772$var$setStylePx(pt, "borderWidth", width);
    return pt;
}
function $3cd00ee63e984772$var$cursorPointFill(self, si) {
    let sp = self.series[si].points;
    return sp._fill || sp._stroke;
}
function $3cd00ee63e984772$var$cursorPointStroke(self, si) {
    let sp = self.series[si].points;
    return sp._stroke || sp._fill;
}
function $3cd00ee63e984772$var$cursorPointSize(self, si) {
    let sp = self.series[si].points;
    return sp.size;
}
const $3cd00ee63e984772$var$moveTuple = [
    0,
    0
];
function $3cd00ee63e984772$var$cursorMove(self, mouseLeft1, mouseTop1) {
    $3cd00ee63e984772$var$moveTuple[0] = mouseLeft1;
    $3cd00ee63e984772$var$moveTuple[1] = mouseTop1;
    return $3cd00ee63e984772$var$moveTuple;
}
function $3cd00ee63e984772$var$filtBtn0(self, targ, handle, onlyTarg = true) {
    return (e)=>{
        e.button == 0 && (!onlyTarg || e.target == targ) && handle(e);
    };
}
function $3cd00ee63e984772$var$filtTarg(self, targ, handle, onlyTarg = true) {
    return (e)=>{
        (!onlyTarg || e.target == targ) && handle(e);
    };
}
const $3cd00ee63e984772$var$cursorOpts = {
    show: true,
    x: true,
    y: true,
    lock: false,
    move: $3cd00ee63e984772$var$cursorMove,
    points: {
        one: false,
        show: $3cd00ee63e984772$var$cursorPointShow,
        size: $3cd00ee63e984772$var$cursorPointSize,
        width: 0,
        stroke: $3cd00ee63e984772$var$cursorPointStroke,
        fill: $3cd00ee63e984772$var$cursorPointFill
    },
    bind: {
        mousedown: $3cd00ee63e984772$var$filtBtn0,
        mouseup: $3cd00ee63e984772$var$filtBtn0,
        click: $3cd00ee63e984772$var$filtBtn0,
        dblclick: $3cd00ee63e984772$var$filtBtn0,
        mousemove: $3cd00ee63e984772$var$filtTarg,
        mouseleave: $3cd00ee63e984772$var$filtTarg,
        mouseenter: $3cd00ee63e984772$var$filtTarg
    },
    drag: {
        setScale: true,
        x: true,
        y: false,
        dist: 0,
        uni: null,
        click: (self, e)=>{
            //	e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        },
        _x: false,
        _y: false
    },
    focus: {
        dist: (self, seriesIdx, dataIdx, valPos, curPos)=>valPos - curPos,
        prox: -1,
        bias: 0
    },
    hover: {
        skip: [
            void 0
        ],
        prox: null,
        bias: 0
    },
    left: -10,
    top: -10,
    idx: null,
    dataIdx: null,
    idxs: null,
    event: null
};
const $3cd00ee63e984772$var$axisLines = {
    show: true,
    stroke: "rgba(0,0,0,0.07)",
    width: 2
};
const $3cd00ee63e984772$var$grid = $3cd00ee63e984772$var$assign({}, $3cd00ee63e984772$var$axisLines, {
    filter: $3cd00ee63e984772$var$retArg1
});
const $3cd00ee63e984772$var$ticks = $3cd00ee63e984772$var$assign({}, $3cd00ee63e984772$var$grid, {
    size: 10
});
const $3cd00ee63e984772$var$border = $3cd00ee63e984772$var$assign({}, $3cd00ee63e984772$var$axisLines, {
    show: false
});
const $3cd00ee63e984772$var$font = '12px system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
const $3cd00ee63e984772$var$labelFont = "bold " + $3cd00ee63e984772$var$font;
const $3cd00ee63e984772$var$lineGap = 1.5; // font-size multiplier
const $3cd00ee63e984772$var$xAxisOpts = {
    show: true,
    scale: "x",
    stroke: $3cd00ee63e984772$var$hexBlack,
    space: 50,
    gap: 5,
    alignTo: 1,
    size: 50,
    labelGap: 0,
    labelSize: 30,
    labelFont: $3cd00ee63e984772$var$labelFont,
    side: 2,
    grid: //	class: "x-vals",
    //	incrs: timeIncrs,
    //	values: timeVals,
    //	filter: retArg1,
    $3cd00ee63e984772$var$grid,
    ticks: $3cd00ee63e984772$var$ticks,
    border: $3cd00ee63e984772$var$border,
    font: $3cd00ee63e984772$var$font,
    lineGap: $3cd00ee63e984772$var$lineGap,
    rotate: 0
};
const $3cd00ee63e984772$var$numSeriesLabel = "Value";
const $3cd00ee63e984772$var$timeSeriesLabel = "Time";
const $3cd00ee63e984772$var$xSeriesOpts = {
    show: true,
    scale: "x",
    auto: false,
    sorted: 1,
    //	label: "Time",
    //	value: v => stamp(new Date(v * 1e3)),
    // internal caches
    min: $3cd00ee63e984772$var$inf,
    max: -$3cd00ee63e984772$var$inf,
    idxs: []
};
function $3cd00ee63e984772$var$numAxisVals(self, splits, axisIdx, foundSpace, foundIncr) {
    return splits.map((v)=>v == null ? "" : $3cd00ee63e984772$var$fmtNum(v));
}
function $3cd00ee63e984772$var$numAxisSplits(self, axisIdx, scaleMin, scaleMax, foundIncr, foundSpace, forceMin) {
    let splits = [];
    let numDec = $3cd00ee63e984772$var$fixedDec.get(foundIncr) || 0;
    scaleMin = forceMin ? scaleMin : $3cd00ee63e984772$var$roundDec($3cd00ee63e984772$var$incrRoundUp(scaleMin, foundIncr), numDec);
    for(let val = scaleMin; val <= scaleMax; val = $3cd00ee63e984772$var$roundDec(val + foundIncr, numDec))splits.push(Object.is(val, -0) ? 0 : val); // coalesces -0
    return splits;
}
// this doesnt work for sin, which needs to come off from 0 independently in pos and neg dirs
function $3cd00ee63e984772$var$logAxisSplits(self, axisIdx, scaleMin, scaleMax, foundIncr, foundSpace, forceMin) {
    const splits = [];
    const logBase = self.scales[self.axes[axisIdx].scale].log;
    const logFn = logBase == 10 ? $3cd00ee63e984772$var$log10 : $3cd00ee63e984772$var$log2;
    const exp = $3cd00ee63e984772$var$floor(logFn(scaleMin));
    foundIncr = $3cd00ee63e984772$var$pow(logBase, exp);
    // boo: 10 ** -24 === 1.0000000000000001e-24
    // this grabs the proper 1e-24 one
    if (logBase == 10) foundIncr = $3cd00ee63e984772$var$numIncrs[$3cd00ee63e984772$var$closestIdx(foundIncr, $3cd00ee63e984772$var$numIncrs)];
    let split = scaleMin;
    let nextMagIncr = foundIncr * logBase;
    if (logBase == 10) nextMagIncr = $3cd00ee63e984772$var$numIncrs[$3cd00ee63e984772$var$closestIdx(nextMagIncr, $3cd00ee63e984772$var$numIncrs)];
    do {
        splits.push(split);
        split = split + foundIncr;
        if (logBase == 10 && !$3cd00ee63e984772$var$fixedDec.has(split)) split = $3cd00ee63e984772$var$roundDec(split, $3cd00ee63e984772$var$fixedDec.get(foundIncr));
        if (split >= nextMagIncr) {
            foundIncr = split;
            nextMagIncr = foundIncr * logBase;
            if (logBase == 10) nextMagIncr = $3cd00ee63e984772$var$numIncrs[$3cd00ee63e984772$var$closestIdx(nextMagIncr, $3cd00ee63e984772$var$numIncrs)];
        }
    }while (split <= scaleMax);
    return splits;
}
function $3cd00ee63e984772$var$asinhAxisSplits(self, axisIdx, scaleMin, scaleMax, foundIncr, foundSpace, forceMin) {
    let sc = self.scales[self.axes[axisIdx].scale];
    let linthresh = sc.asinh;
    let posSplits = scaleMax > linthresh ? $3cd00ee63e984772$var$logAxisSplits(self, axisIdx, $3cd00ee63e984772$var$max(linthresh, scaleMin), scaleMax, foundIncr) : [
        linthresh
    ];
    let zero = scaleMax >= 0 && scaleMin <= 0 ? [
        0
    ] : [];
    let negSplits = scaleMin < -linthresh ? $3cd00ee63e984772$var$logAxisSplits(self, axisIdx, $3cd00ee63e984772$var$max(linthresh, -scaleMax), -scaleMin, foundIncr) : [
        linthresh
    ];
    return negSplits.reverse().map((v)=>-v).concat(zero, posSplits);
}
const $3cd00ee63e984772$var$RE_ALL = /./;
const $3cd00ee63e984772$var$RE_12357 = /[12357]/;
const $3cd00ee63e984772$var$RE_125 = /[125]/;
const $3cd00ee63e984772$var$RE_1 = /1/;
const $3cd00ee63e984772$var$_filt = (splits, distr, re, keepMod)=>splits.map((v, i)=>distr == 4 && v == 0 || i % keepMod == 0 && re.test(v.toExponential()[v < 0 ? 1 : 0]) ? v : null);
function $3cd00ee63e984772$var$log10AxisValsFilt(self, splits, axisIdx, foundSpace, foundIncr) {
    let axis = self.axes[axisIdx];
    let scaleKey = axis.scale;
    let sc = self.scales[scaleKey];
    //	if (sc.distr == 3 && sc.log == 2)
    //		return splits;
    let valToPos = self.valToPos;
    let minSpace = axis._space;
    let _10 = valToPos(10, scaleKey);
    let re = valToPos(9, scaleKey) - _10 >= minSpace ? $3cd00ee63e984772$var$RE_ALL : valToPos(7, scaleKey) - _10 >= minSpace ? $3cd00ee63e984772$var$RE_12357 : valToPos(5, scaleKey) - _10 >= minSpace ? $3cd00ee63e984772$var$RE_125 : $3cd00ee63e984772$var$RE_1;
    if (re == $3cd00ee63e984772$var$RE_1) {
        let magSpace = $3cd00ee63e984772$var$abs(valToPos(1, scaleKey) - _10);
        if (magSpace < minSpace) return $3cd00ee63e984772$var$_filt(splits.slice().reverse(), sc.distr, re, $3cd00ee63e984772$var$ceil(minSpace / magSpace)).reverse(); // max->min skip
    }
    return $3cd00ee63e984772$var$_filt(splits, sc.distr, re, 1);
}
function $3cd00ee63e984772$var$log2AxisValsFilt(self, splits, axisIdx, foundSpace, foundIncr) {
    let axis = self.axes[axisIdx];
    let scaleKey = axis.scale;
    let minSpace = axis._space;
    let valToPos = self.valToPos;
    let magSpace = $3cd00ee63e984772$var$abs(valToPos(1, scaleKey) - valToPos(2, scaleKey));
    if (magSpace < minSpace) return $3cd00ee63e984772$var$_filt(splits.slice().reverse(), 3, $3cd00ee63e984772$var$RE_ALL, $3cd00ee63e984772$var$ceil(minSpace / magSpace)).reverse(); // max->min skip
    return splits;
}
function $3cd00ee63e984772$var$numSeriesVal(self, val, seriesIdx, dataIdx) {
    return dataIdx == null ? $3cd00ee63e984772$var$LEGEND_DISP : val == null ? "" : $3cd00ee63e984772$var$fmtNum(val);
}
const $3cd00ee63e984772$var$yAxisOpts = {
    show: true,
    scale: "y",
    stroke: $3cd00ee63e984772$var$hexBlack,
    space: 30,
    gap: 5,
    alignTo: 1,
    size: 50,
    labelGap: 0,
    labelSize: 30,
    labelFont: $3cd00ee63e984772$var$labelFont,
    side: 3,
    grid: //	class: "y-vals",
    //	incrs: numIncrs,
    //	values: (vals, space) => vals,
    //	filter: retArg1,
    $3cd00ee63e984772$var$grid,
    ticks: $3cd00ee63e984772$var$ticks,
    border: $3cd00ee63e984772$var$border,
    font: $3cd00ee63e984772$var$font,
    lineGap: $3cd00ee63e984772$var$lineGap,
    rotate: 0
};
// takes stroke width
function $3cd00ee63e984772$var$ptDia(width, mult) {
    let dia = 3 + (width || 1) * 2;
    return $3cd00ee63e984772$var$roundDec(dia * mult, 3);
}
function $3cd00ee63e984772$var$seriesPointsShow(self, si) {
    let { scale: scale, idxs: idxs } = self.series[0];
    let xData = self._data[0];
    let p0 = self.valToPos(xData[idxs[0]], scale, true);
    let p1 = self.valToPos(xData[idxs[1]], scale, true);
    let dim = $3cd00ee63e984772$var$abs(p1 - p0);
    let s = self.series[si];
    //	const dia = ptDia(s.width, pxRatio);
    let maxPts = dim / (s.points.space * $3cd00ee63e984772$var$pxRatio);
    return idxs[1] - idxs[0] <= maxPts;
}
const $3cd00ee63e984772$var$facet = {
    scale: null,
    auto: true,
    sorted: 0,
    // internal caches
    min: $3cd00ee63e984772$var$inf,
    max: -$3cd00ee63e984772$var$inf
};
const $3cd00ee63e984772$var$gaps = (self, seriesIdx, idx0, idx1, nullGaps)=>nullGaps;
const $3cd00ee63e984772$var$xySeriesOpts = {
    show: true,
    auto: true,
    sorted: 0,
    gaps: $3cd00ee63e984772$var$gaps,
    alpha: 1,
    facets: [
        $3cd00ee63e984772$var$assign({}, $3cd00ee63e984772$var$facet, {
            scale: 'x'
        }),
        $3cd00ee63e984772$var$assign({}, $3cd00ee63e984772$var$facet, {
            scale: 'y'
        })
    ]
};
const $3cd00ee63e984772$var$ySeriesOpts = {
    scale: "y",
    auto: true,
    sorted: 0,
    show: true,
    spanGaps: false,
    gaps: $3cd00ee63e984772$var$gaps,
    alpha: 1,
    points: {
        show: $3cd00ee63e984772$var$seriesPointsShow,
        filter: null
    },
    //	label: "Value",
    //	value: v => v,
    values: null,
    // internal caches
    min: $3cd00ee63e984772$var$inf,
    max: -$3cd00ee63e984772$var$inf,
    idxs: [],
    path: null,
    clip: null
};
function $3cd00ee63e984772$var$clampScale(self, val, scaleMin, scaleMax, scaleKey) {
    /*
	if (val < 0) {
		let cssHgt = self.bbox.height / pxRatio;
		let absPos = self.valToPos(abs(val), scaleKey);
		let fromBtm = cssHgt - absPos;
		return self.posToVal(cssHgt + fromBtm, scaleKey);
	}
*/ return scaleMin / 10;
}
const $3cd00ee63e984772$var$xScaleOpts = {
    time: $3cd00ee63e984772$var$FEAT_TIME,
    auto: true,
    distr: 1,
    log: 10,
    asinh: 1,
    min: null,
    max: null,
    dir: 1,
    ori: 0
};
const $3cd00ee63e984772$var$yScaleOpts = $3cd00ee63e984772$var$assign({}, $3cd00ee63e984772$var$xScaleOpts, {
    time: false,
    ori: 1
});
const $3cd00ee63e984772$var$syncs = {};
function $3cd00ee63e984772$var$_sync(key, opts) {
    let s = $3cd00ee63e984772$var$syncs[key];
    if (!s) {
        s = {
            key: key,
            plots: [],
            sub (plot) {
                s.plots.push(plot);
            },
            unsub (plot) {
                s.plots = s.plots.filter((c)=>c != plot);
            },
            pub (type, self, x, y, w, h, i) {
                for(let j = 0; j < s.plots.length; j++)s.plots[j] != self && s.plots[j].pub(type, self, x, y, w, h, i);
            }
        };
        if (key != null) $3cd00ee63e984772$var$syncs[key] = s;
    }
    return s;
}
const $3cd00ee63e984772$var$BAND_CLIP_FILL = 1;
const $3cd00ee63e984772$var$BAND_CLIP_STROKE = 2;
function $3cd00ee63e984772$var$orient(u, seriesIdx, cb) {
    const mode = u.mode;
    const series = u.series[seriesIdx];
    const data = mode == 2 ? u._data[seriesIdx] : u._data;
    const scales = u.scales;
    const bbox = u.bbox;
    let dx = data[0], dy = mode == 2 ? data[1] : data[seriesIdx], sx = mode == 2 ? scales[series.facets[0].scale] : scales[u.series[0].scale], sy = mode == 2 ? scales[series.facets[1].scale] : scales[series.scale], l = bbox.left, t = bbox.top, w = bbox.width, h = bbox.height, H = u.valToPosH, V = u.valToPosV;
    return sx.ori == 0 ? cb(series, dx, dy, sx, sy, H, V, l, t, w, h, $3cd00ee63e984772$var$moveToH, $3cd00ee63e984772$var$lineToH, $3cd00ee63e984772$var$rectH, $3cd00ee63e984772$var$arcH, $3cd00ee63e984772$var$bezierCurveToH) : cb(series, dx, dy, sx, sy, V, H, t, l, h, w, $3cd00ee63e984772$var$moveToV, $3cd00ee63e984772$var$lineToV, $3cd00ee63e984772$var$rectV, $3cd00ee63e984772$var$arcV, $3cd00ee63e984772$var$bezierCurveToV);
}
function $3cd00ee63e984772$var$bandFillClipDirs(self, seriesIdx) {
    let fillDir = 0;
    // 2 bits, -1 | 1
    let clipDirs = 0;
    let bands = $3cd00ee63e984772$var$ifNull(self.bands, $3cd00ee63e984772$var$EMPTY_ARR);
    for(let i = 0; i < bands.length; i++){
        let b = bands[i];
        // is a "from" band edge
        if (b.series[0] == seriesIdx) fillDir = b.dir;
        else if (b.series[1] == seriesIdx) {
            if (b.dir == 1) clipDirs |= 1;
            else clipDirs |= 2;
        }
    }
    return [
        fillDir,
        clipDirs == 1 ? -1 : clipDirs == 2 ? 1 : clipDirs == 3 ? 2 : 0 // neither
    ];
}
function $3cd00ee63e984772$var$seriesFillTo(self, seriesIdx, dataMin, dataMax, bandFillDir) {
    let mode = self.mode;
    let series = self.series[seriesIdx];
    let scaleKey = mode == 2 ? series.facets[1].scale : series.scale;
    let scale = self.scales[scaleKey];
    return bandFillDir == -1 ? scale.min : bandFillDir == 1 ? scale.max : scale.distr == 3 ? scale.dir == 1 ? scale.min : scale.max : 0;
}
// creates inverted band clip path (from stroke path -> yMax || yMin)
// clipDir is always inverse of fillDir
// default clip dir is upwards (1), since default band fill is downwards/fillBelowTo (-1) (highIdx -> lowIdx)
function $3cd00ee63e984772$var$clipBandLine(self, seriesIdx, idx0, idx1, strokePath, clipDir) {
    return $3cd00ee63e984772$var$orient(self, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
        let pxRound = series.pxRound;
        const dir = scaleX.dir * (scaleX.ori == 0 ? 1 : -1);
        const lineTo = scaleX.ori == 0 ? $3cd00ee63e984772$var$lineToH : $3cd00ee63e984772$var$lineToV;
        let frIdx, toIdx;
        if (dir == 1) {
            frIdx = idx0;
            toIdx = idx1;
        } else {
            frIdx = idx1;
            toIdx = idx0;
        }
        // path start
        let x0 = pxRound(valToPosX(dataX[frIdx], scaleX, xDim, xOff));
        let y0 = pxRound(valToPosY(dataY[frIdx], scaleY, yDim, yOff));
        // path end x
        let x1 = pxRound(valToPosX(dataX[toIdx], scaleX, xDim, xOff));
        // upper or lower y limit
        let yLimit = pxRound(valToPosY(clipDir == 1 ? scaleY.max : scaleY.min, scaleY, yDim, yOff));
        let clip = new Path2D(strokePath);
        lineTo(clip, x1, yLimit);
        lineTo(clip, x0, yLimit);
        lineTo(clip, x0, y0);
        return clip;
    });
}
function $3cd00ee63e984772$var$clipGaps(gaps, ori, plotLft, plotTop, plotWid, plotHgt) {
    let clip = null;
    // create clip path (invert gaps and non-gaps)
    if (gaps.length > 0) {
        clip = new Path2D();
        const rect = ori == 0 ? $3cd00ee63e984772$var$rectH : $3cd00ee63e984772$var$rectV;
        let prevGapEnd = plotLft;
        for(let i = 0; i < gaps.length; i++){
            let g = gaps[i];
            if (g[1] > g[0]) {
                let w = g[0] - prevGapEnd;
                w > 0 && rect(clip, prevGapEnd, plotTop, w, plotTop + plotHgt);
                prevGapEnd = g[1];
            }
        }
        let w = plotLft + plotWid - prevGapEnd;
        // hack to ensure we expand the clip enough to avoid cutting off strokes at edges
        let maxStrokeWidth = 10;
        w > 0 && rect(clip, prevGapEnd, plotTop - maxStrokeWidth / 2, w, plotTop + plotHgt + maxStrokeWidth);
    }
    return clip;
}
function $3cd00ee63e984772$var$addGap(gaps, fromX, toX) {
    let prevGap = gaps[gaps.length - 1];
    if (prevGap && prevGap[0] == fromX) prevGap[1] = toX;
    else gaps.push([
        fromX,
        toX
    ]);
}
function $3cd00ee63e984772$var$findGaps(xs, ys, idx0, idx1, dir, pixelForX, align) {
    let gaps = [];
    let len = xs.length;
    for(let i = dir == 1 ? idx0 : idx1; i >= idx0 && i <= idx1; i += dir){
        let yVal = ys[i];
        if (yVal === null) {
            let fr = i, to = i;
            if (dir == 1) while(++i <= idx1 && ys[i] === null)to = i;
            else while(--i >= idx0 && ys[i] === null)to = i;
            let frPx = pixelForX(xs[fr]);
            let toPx = to == fr ? frPx : pixelForX(xs[to]);
            // if value adjacent to edge null is same pixel, then it's partially
            // filled and gap should start at next pixel
            let fri2 = fr - dir;
            let frPx2 = align <= 0 && fri2 >= 0 && fri2 < len ? pixelForX(xs[fri2]) : frPx;
            //	if (frPx2 == frPx)
            //		frPx++;
            //	else
            frPx = frPx2;
            let toi2 = to + dir;
            let toPx2 = align >= 0 && toi2 >= 0 && toi2 < len ? pixelForX(xs[toi2]) : toPx;
            //	if (toPx2 == toPx)
            //		toPx--;
            //	else
            toPx = toPx2;
            if (toPx >= frPx) gaps.push([
                frPx,
                toPx
            ]); // addGap
        }
    }
    return gaps;
}
function $3cd00ee63e984772$var$pxRoundGen(pxAlign) {
    return pxAlign == 0 ? $3cd00ee63e984772$var$retArg0 : pxAlign == 1 ? $3cd00ee63e984772$var$round : (v)=>$3cd00ee63e984772$var$incrRound(v, pxAlign);
}
/*
// inefficient linear interpolation that does bi-directinal scans on each call
export function costlyLerp(i, idx0, idx1, _dirX, dataY) {
	let prevNonNull = nonNullIdx(dataY, _dirX == 1 ? idx0 : idx1, i, -_dirX);
	let nextNonNull = nonNullIdx(dataY, i, _dirX == 1 ? idx1 : idx0,  _dirX);

	let prevVal = dataY[prevNonNull];
	let nextVal = dataY[nextNonNull];

	return prevVal + (i - prevNonNull) / (nextNonNull - prevNonNull) * (nextVal - prevVal);
}
*/ function $3cd00ee63e984772$var$rect(ori) {
    let moveTo = ori == 0 ? $3cd00ee63e984772$var$moveToH : $3cd00ee63e984772$var$moveToV;
    let arcTo = ori == 0 ? (p, x1, y1, x2, y2, r)=>{
        p.arcTo(x1, y1, x2, y2, r);
    } : (p, y1, x1, y2, x2, r)=>{
        p.arcTo(x1, y1, x2, y2, r);
    };
    let rect = ori == 0 ? (p, x, y, w, h)=>{
        p.rect(x, y, w, h);
    } : (p, y, x, h, w)=>{
        p.rect(x, y, w, h);
    };
    // TODO (pending better browser support): https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/roundRect
    return (p, x, y, w, h, endRad = 0, baseRad = 0)=>{
        if (endRad == 0 && baseRad == 0) rect(p, x, y, w, h);
        else {
            endRad = $3cd00ee63e984772$var$min(endRad, w / 2, h / 2);
            baseRad = $3cd00ee63e984772$var$min(baseRad, w / 2, h / 2);
            // adapted from https://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-using-html-canvas/7838871#7838871
            moveTo(p, x + endRad, y);
            arcTo(p, x + w, y, x + w, y + h, endRad);
            arcTo(p, x + w, y + h, x, y + h, baseRad);
            arcTo(p, x, y + h, x, y, baseRad);
            arcTo(p, x, y, x + w, y, endRad);
            p.closePath();
        }
    };
}
// orientation-inverting canvas functions
const $3cd00ee63e984772$var$moveToH = (p, x, y)=>{
    p.moveTo(x, y);
};
const $3cd00ee63e984772$var$moveToV = (p, y, x)=>{
    p.moveTo(x, y);
};
const $3cd00ee63e984772$var$lineToH = (p, x, y)=>{
    p.lineTo(x, y);
};
const $3cd00ee63e984772$var$lineToV = (p, y, x)=>{
    p.lineTo(x, y);
};
const $3cd00ee63e984772$var$rectH = $3cd00ee63e984772$var$rect(0);
const $3cd00ee63e984772$var$rectV = $3cd00ee63e984772$var$rect(1);
const $3cd00ee63e984772$var$arcH = (p, x, y, r, startAngle, endAngle)=>{
    p.arc(x, y, r, startAngle, endAngle);
};
const $3cd00ee63e984772$var$arcV = (p, y, x, r, startAngle, endAngle)=>{
    p.arc(x, y, r, startAngle, endAngle);
};
const $3cd00ee63e984772$var$bezierCurveToH = (p, bp1x, bp1y, bp2x, bp2y, p2x, p2y)=>{
    p.bezierCurveTo(bp1x, bp1y, bp2x, bp2y, p2x, p2y);
};
const $3cd00ee63e984772$var$bezierCurveToV = (p, bp1y, bp1x, bp2y, bp2x, p2y, p2x)=>{
    p.bezierCurveTo(bp1x, bp1y, bp2x, bp2y, p2x, p2y);
};
// TODO: drawWrap(seriesIdx, drawPoints) (save, restore, translate, clip)
function $3cd00ee63e984772$var$points(opts) {
    return (u, seriesIdx, idx0, idx1, filtIdxs)=>{
        //	log("drawPoints()", arguments);
        return $3cd00ee63e984772$var$orient(u, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
            let { pxRound: pxRound, points: points } = series;
            let moveTo, arc;
            if (scaleX.ori == 0) {
                moveTo = $3cd00ee63e984772$var$moveToH;
                arc = $3cd00ee63e984772$var$arcH;
            } else {
                moveTo = $3cd00ee63e984772$var$moveToV;
                arc = $3cd00ee63e984772$var$arcV;
            }
            const width = $3cd00ee63e984772$var$roundDec(points.width * $3cd00ee63e984772$var$pxRatio, 3);
            let rad = (points.size - points.width) / 2 * $3cd00ee63e984772$var$pxRatio;
            let dia = $3cd00ee63e984772$var$roundDec(rad * 2, 3);
            let fill = new Path2D();
            let clip = new Path2D();
            let { left: lft, top: top, width: wid, height: hgt } = u.bbox;
            $3cd00ee63e984772$var$rectH(clip, lft - dia, top - dia, wid + dia * 2, hgt + dia * 2);
            const drawPoint = (pi)=>{
                if (dataY[pi] != null) {
                    let x = pxRound(valToPosX(dataX[pi], scaleX, xDim, xOff));
                    let y = pxRound(valToPosY(dataY[pi], scaleY, yDim, yOff));
                    moveTo(fill, x + rad, y);
                    arc(fill, x, y, rad, 0, $3cd00ee63e984772$var$PI * 2);
                }
            };
            if (filtIdxs) filtIdxs.forEach(drawPoint);
            else for(let pi = idx0; pi <= idx1; pi++)drawPoint(pi);
            return {
                stroke: width > 0 ? fill : null,
                fill: fill,
                clip: clip,
                flags: $3cd00ee63e984772$var$BAND_CLIP_FILL | $3cd00ee63e984772$var$BAND_CLIP_STROKE
            };
        });
    };
}
function $3cd00ee63e984772$var$_drawAcc(lineTo) {
    return (stroke, accX, minY, maxY, inY, outY)=>{
        if (minY != maxY) {
            if (inY != minY && outY != minY) lineTo(stroke, accX, minY);
            if (inY != maxY && outY != maxY) lineTo(stroke, accX, maxY);
            lineTo(stroke, accX, outY);
        }
    };
}
const $3cd00ee63e984772$var$drawAccH = $3cd00ee63e984772$var$_drawAcc($3cd00ee63e984772$var$lineToH);
const $3cd00ee63e984772$var$drawAccV = $3cd00ee63e984772$var$_drawAcc($3cd00ee63e984772$var$lineToV);
function $3cd00ee63e984772$var$linear(opts) {
    const alignGaps = $3cd00ee63e984772$var$ifNull(opts?.alignGaps, 0);
    return (u, seriesIdx, idx0, idx1)=>{
        return $3cd00ee63e984772$var$orient(u, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
            [idx0, idx1] = $3cd00ee63e984772$var$nonNullIdxs(dataY, idx0, idx1);
            let pxRound = series.pxRound;
            let pixelForX = (val)=>pxRound(valToPosX(val, scaleX, xDim, xOff));
            let pixelForY = (val)=>pxRound(valToPosY(val, scaleY, yDim, yOff));
            let lineTo, drawAcc;
            if (scaleX.ori == 0) {
                lineTo = $3cd00ee63e984772$var$lineToH;
                drawAcc = $3cd00ee63e984772$var$drawAccH;
            } else {
                lineTo = $3cd00ee63e984772$var$lineToV;
                drawAcc = $3cd00ee63e984772$var$drawAccV;
            }
            const dir = scaleX.dir * (scaleX.ori == 0 ? 1 : -1);
            const _paths = {
                stroke: new Path2D(),
                fill: null,
                clip: null,
                band: null,
                gaps: null,
                flags: $3cd00ee63e984772$var$BAND_CLIP_FILL
            };
            const stroke = _paths.stroke;
            let hasGap = false;
            // decimate when number of points >= 4x available pixels
            const decimate = idx1 - idx0 >= xDim * 4;
            if (decimate) {
                let xForPixel = (pos)=>u.posToVal(pos, scaleX.key, true);
                let minY = null, maxY = null, inY, outY, drawnAtX;
                let accX = pixelForX(dataX[dir == 1 ? idx0 : idx1]);
                let idx0px = pixelForX(dataX[idx0]);
                let idx1px = pixelForX(dataX[idx1]);
                // tracks limit of current x bucket to avoid having to get x pixel for every x value
                let nextAccXVal = xForPixel(dir == 1 ? idx0px + 1 : idx1px - 1);
                for(let i = dir == 1 ? idx0 : idx1; i >= idx0 && i <= idx1; i += dir){
                    let xVal = dataX[i];
                    let reuseAccX = dir == 1 ? xVal < nextAccXVal : xVal > nextAccXVal;
                    let x = reuseAccX ? accX : pixelForX(xVal);
                    let yVal = dataY[i];
                    if (x == accX) {
                        if (yVal != null) {
                            outY = yVal;
                            if (minY == null) {
                                lineTo(stroke, x, pixelForY(outY));
                                inY = minY = maxY = outY;
                            } else {
                                if (outY < minY) minY = outY;
                                else if (outY > maxY) maxY = outY;
                            }
                        } else if (yVal === null) hasGap = true;
                    } else {
                        if (minY != null) drawAcc(stroke, accX, pixelForY(minY), pixelForY(maxY), pixelForY(inY), pixelForY(outY));
                        if (yVal != null) {
                            outY = yVal;
                            lineTo(stroke, x, pixelForY(outY));
                            minY = maxY = inY = outY;
                        } else {
                            minY = maxY = null;
                            if (yVal === null) hasGap = true;
                        }
                        accX = x;
                        nextAccXVal = xForPixel(accX + dir);
                    }
                }
                if (minY != null && minY != maxY && drawnAtX != accX) drawAcc(stroke, accX, pixelForY(minY), pixelForY(maxY), pixelForY(inY), pixelForY(outY));
            } else for(let i = dir == 1 ? idx0 : idx1; i >= idx0 && i <= idx1; i += dir){
                let yVal = dataY[i];
                if (yVal === null) hasGap = true;
                else if (yVal != null) lineTo(stroke, pixelForX(dataX[i]), pixelForY(yVal));
            }
            let [bandFillDir, bandClipDir] = $3cd00ee63e984772$var$bandFillClipDirs(u, seriesIdx);
            if (series.fill != null || bandFillDir != 0) {
                let fill = _paths.fill = new Path2D(stroke);
                let fillToVal = series.fillTo(u, seriesIdx, series.min, series.max, bandFillDir);
                let fillToY = pixelForY(fillToVal);
                let frX = pixelForX(dataX[idx0]);
                let toX = pixelForX(dataX[idx1]);
                if (dir == -1) [toX, frX] = [
                    frX,
                    toX
                ];
                lineTo(fill, toX, fillToY);
                lineTo(fill, frX, fillToY);
            }
            if (!series.spanGaps) {
                //	console.time('gaps');
                let gaps = [];
                hasGap && gaps.push(...$3cd00ee63e984772$var$findGaps(dataX, dataY, idx0, idx1, dir, pixelForX, alignGaps));
                //	console.timeEnd('gaps');
                //	console.log('gaps', JSON.stringify(gaps));
                _paths.gaps = gaps = series.gaps(u, seriesIdx, idx0, idx1, gaps);
                _paths.clip = $3cd00ee63e984772$var$clipGaps(gaps, scaleX.ori, xOff, yOff, xDim, yDim);
            }
            if (bandClipDir != 0) _paths.band = bandClipDir == 2 ? [
                $3cd00ee63e984772$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, -1),
                $3cd00ee63e984772$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, 1)
            ] : $3cd00ee63e984772$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, bandClipDir);
            return _paths;
        });
    };
}
// BUG: align: -1 behaves like align: 1 when scale.dir: -1
function $3cd00ee63e984772$var$stepped(opts) {
    const align = $3cd00ee63e984772$var$ifNull(opts.align, 1);
    // whether to draw ascenders/descenders at null/gap bondaries
    const ascDesc = $3cd00ee63e984772$var$ifNull(opts.ascDesc, false);
    const alignGaps = $3cd00ee63e984772$var$ifNull(opts.alignGaps, 0);
    const extend = $3cd00ee63e984772$var$ifNull(opts.extend, false);
    return (u, seriesIdx, idx0, idx1)=>{
        return $3cd00ee63e984772$var$orient(u, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
            [idx0, idx1] = $3cd00ee63e984772$var$nonNullIdxs(dataY, idx0, idx1);
            let pxRound = series.pxRound;
            let { left: left, width: width } = u.bbox;
            let pixelForX = (val)=>pxRound(valToPosX(val, scaleX, xDim, xOff));
            let pixelForY = (val)=>pxRound(valToPosY(val, scaleY, yDim, yOff));
            let lineTo = scaleX.ori == 0 ? $3cd00ee63e984772$var$lineToH : $3cd00ee63e984772$var$lineToV;
            const _paths = {
                stroke: new Path2D(),
                fill: null,
                clip: null,
                band: null,
                gaps: null,
                flags: $3cd00ee63e984772$var$BAND_CLIP_FILL
            };
            const stroke = _paths.stroke;
            const dir = scaleX.dir * (scaleX.ori == 0 ? 1 : -1);
            let prevYPos = pixelForY(dataY[dir == 1 ? idx0 : idx1]);
            let firstXPos = pixelForX(dataX[dir == 1 ? idx0 : idx1]);
            let prevXPos = firstXPos;
            let firstXPosExt = firstXPos;
            if (extend && align == -1) {
                firstXPosExt = left;
                lineTo(stroke, firstXPosExt, prevYPos);
            }
            lineTo(stroke, firstXPos, prevYPos);
            for(let i = dir == 1 ? idx0 : idx1; i >= idx0 && i <= idx1; i += dir){
                let yVal1 = dataY[i];
                if (yVal1 == null) continue;
                let x1 = pixelForX(dataX[i]);
                let y1 = pixelForY(yVal1);
                if (align == 1) lineTo(stroke, x1, prevYPos);
                else lineTo(stroke, prevXPos, y1);
                lineTo(stroke, x1, y1);
                prevYPos = y1;
                prevXPos = x1;
            }
            let prevXPosExt = prevXPos;
            if (extend && align == 1) {
                prevXPosExt = left + width;
                lineTo(stroke, prevXPosExt, prevYPos);
            }
            let [bandFillDir, bandClipDir] = $3cd00ee63e984772$var$bandFillClipDirs(u, seriesIdx);
            if (series.fill != null || bandFillDir != 0) {
                let fill = _paths.fill = new Path2D(stroke);
                let fillTo = series.fillTo(u, seriesIdx, series.min, series.max, bandFillDir);
                let fillToY = pixelForY(fillTo);
                lineTo(fill, prevXPosExt, fillToY);
                lineTo(fill, firstXPosExt, fillToY);
            }
            if (!series.spanGaps) {
                //	console.time('gaps');
                let gaps = [];
                gaps.push(...$3cd00ee63e984772$var$findGaps(dataX, dataY, idx0, idx1, dir, pixelForX, alignGaps));
                //	console.timeEnd('gaps');
                //	console.log('gaps', JSON.stringify(gaps));
                // expand/contract clips for ascenders/descenders
                let halfStroke = series.width * $3cd00ee63e984772$var$pxRatio / 2;
                let startsOffset = ascDesc || align == 1 ? halfStroke : -halfStroke;
                let endsOffset = ascDesc || align == -1 ? -halfStroke : halfStroke;
                gaps.forEach((g)=>{
                    g[0] += startsOffset;
                    g[1] += endsOffset;
                });
                _paths.gaps = gaps = series.gaps(u, seriesIdx, idx0, idx1, gaps);
                _paths.clip = $3cd00ee63e984772$var$clipGaps(gaps, scaleX.ori, xOff, yOff, xDim, yDim);
            }
            if (bandClipDir != 0) _paths.band = bandClipDir == 2 ? [
                $3cd00ee63e984772$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, -1),
                $3cd00ee63e984772$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, 1)
            ] : $3cd00ee63e984772$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, bandClipDir);
            return _paths;
        });
    };
}
function $3cd00ee63e984772$var$findColWidth(dataX, dataY, valToPosX, scaleX, xDim, xOff, colWid = $3cd00ee63e984772$var$inf) {
    if (dataX.length > 1) {
        // prior index with non-undefined y data
        let prevIdx = null;
        // scan full dataset for smallest adjacent delta
        // will not work properly for non-linear x scales, since does not do expensive valToPosX calcs till end
        for(let i = 0, minDelta = Infinity; i < dataX.length; i++)if (dataY[i] !== undefined) {
            if (prevIdx != null) {
                let delta = $3cd00ee63e984772$var$abs(dataX[i] - dataX[prevIdx]);
                if (delta < minDelta) {
                    minDelta = delta;
                    colWid = $3cd00ee63e984772$var$abs(valToPosX(dataX[i], scaleX, xDim, xOff) - valToPosX(dataX[prevIdx], scaleX, xDim, xOff));
                }
            }
            prevIdx = i;
        }
    }
    return colWid;
}
function $3cd00ee63e984772$var$bars(opts) {
    opts = opts || $3cd00ee63e984772$var$EMPTY_OBJ;
    const size = $3cd00ee63e984772$var$ifNull(opts.size, [
        0.6,
        $3cd00ee63e984772$var$inf,
        1
    ]);
    const align = opts.align || 0;
    const _extraGap = opts.gap || 0;
    let ro = opts.radius;
    ro = // [valueRadius, baselineRadius]
    ro == null ? [
        0,
        0
    ] : typeof ro == 'number' ? [
        ro,
        0
    ] : ro;
    const radiusFn = $3cd00ee63e984772$var$fnOrSelf(ro);
    const gapFactor = 1 - size[0];
    const _maxWidth = $3cd00ee63e984772$var$ifNull(size[1], $3cd00ee63e984772$var$inf);
    const _minWidth = $3cd00ee63e984772$var$ifNull(size[2], 1);
    const disp = $3cd00ee63e984772$var$ifNull(opts.disp, $3cd00ee63e984772$var$EMPTY_OBJ);
    const _each = $3cd00ee63e984772$var$ifNull(opts.each, (_)=>{});
    const { fill: dispFills, stroke: dispStrokes } = disp;
    return (u, seriesIdx, idx0, idx1)=>{
        return $3cd00ee63e984772$var$orient(u, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
            let pxRound = series.pxRound;
            let _align = align;
            let extraGap = _extraGap * $3cd00ee63e984772$var$pxRatio;
            let maxWidth = _maxWidth * $3cd00ee63e984772$var$pxRatio;
            let minWidth = _minWidth * $3cd00ee63e984772$var$pxRatio;
            let valRadius, baseRadius;
            if (scaleX.ori == 0) [valRadius, baseRadius] = radiusFn(u, seriesIdx);
            else [baseRadius, valRadius] = radiusFn(u, seriesIdx);
            const _dirX = scaleX.dir * (scaleX.ori == 0 ? 1 : -1);
            //	const _dirY = scaleY.dir * (scaleY.ori == 1 ? 1 : -1);
            let rect = scaleX.ori == 0 ? $3cd00ee63e984772$var$rectH : $3cd00ee63e984772$var$rectV;
            let each = scaleX.ori == 0 ? _each : (u, seriesIdx, i, top, lft, hgt, wid)=>{
                _each(u, seriesIdx, i, lft, top, wid, hgt);
            };
            // band where this series is the "from" edge
            let band = $3cd00ee63e984772$var$ifNull(u.bands, $3cd00ee63e984772$var$EMPTY_ARR).find((b)=>b.series[0] == seriesIdx);
            let fillDir = band != null ? band.dir : 0;
            let fillTo = series.fillTo(u, seriesIdx, series.min, series.max, fillDir);
            let fillToY = pxRound(valToPosY(fillTo, scaleY, yDim, yOff));
            // barWid is to center of stroke
            let xShift, barWid, fullGap, colWid = xDim;
            let strokeWidth = pxRound(series.width * $3cd00ee63e984772$var$pxRatio);
            let multiPath = false;
            let fillColors = null;
            let fillPaths = null;
            let strokeColors = null;
            let strokePaths = null;
            if (dispFills != null && (strokeWidth == 0 || dispStrokes != null)) {
                multiPath = true;
                fillColors = dispFills.values(u, seriesIdx, idx0, idx1);
                fillPaths = new Map();
                new Set(fillColors).forEach((color)=>{
                    if (color != null) fillPaths.set(color, new Path2D());
                });
                if (strokeWidth > 0) {
                    strokeColors = dispStrokes.values(u, seriesIdx, idx0, idx1);
                    strokePaths = new Map();
                    new Set(strokeColors).forEach((color)=>{
                        if (color != null) strokePaths.set(color, new Path2D());
                    });
                }
            }
            let { x0: x0, size: size } = disp;
            if (x0 != null && size != null) {
                _align = 1;
                dataX = x0.values(u, seriesIdx, idx0, idx1);
                if (x0.unit == 2) dataX = dataX.map((pct)=>u.posToVal(xOff + pct * xDim, scaleX.key, true));
                // assumes uniform sizes, for now
                let sizes = size.values(u, seriesIdx, idx0, idx1);
                if (size.unit == 2) barWid = sizes[0] * xDim;
                else barWid = valToPosX(sizes[0], scaleX, xDim, xOff) - valToPosX(0, scaleX, xDim, xOff); // assumes linear scale (delta from 0)
                colWid = $3cd00ee63e984772$var$findColWidth(dataX, dataY, valToPosX, scaleX, xDim, xOff, colWid);
                let gapWid = colWid - barWid;
                fullGap = gapWid + extraGap;
            } else {
                colWid = $3cd00ee63e984772$var$findColWidth(dataX, dataY, valToPosX, scaleX, xDim, xOff, colWid);
                let gapWid = colWid * gapFactor;
                fullGap = gapWid + extraGap;
                barWid = colWid - fullGap;
            }
            if (fullGap < 1) fullGap = 0;
            if (strokeWidth >= barWid / 2) strokeWidth = 0;
            // for small gaps, disable pixel snapping since gap inconsistencies become noticible and annoying
            if (fullGap < 5) pxRound = $3cd00ee63e984772$var$retArg0;
            let insetStroke = fullGap > 0;
            let rawBarWid = colWid - fullGap - (insetStroke ? strokeWidth : 0);
            barWid = pxRound($3cd00ee63e984772$var$clamp(rawBarWid, minWidth, maxWidth));
            xShift = (_align == 0 ? barWid / 2 : _align == _dirX ? 0 : barWid) - _align * _dirX * ((_align == 0 ? extraGap / 2 : 0) + (insetStroke ? strokeWidth / 2 : 0));
            const _paths = {
                stroke: null,
                fill: null,
                clip: null,
                band: null,
                gaps: null,
                flags: 0
            }; // disp, geom
            const stroke = multiPath ? null : new Path2D();
            let dataY0 = null;
            if (band != null) dataY0 = u.data[band.series[1]];
            else {
                let { y0: y0, y1: y1 } = disp;
                if (y0 != null && y1 != null) {
                    dataY = y1.values(u, seriesIdx, idx0, idx1);
                    dataY0 = y0.values(u, seriesIdx, idx0, idx1);
                }
            }
            let radVal = valRadius * barWid;
            let radBase = baseRadius * barWid;
            for(let i = _dirX == 1 ? idx0 : idx1; i >= idx0 && i <= idx1; i += _dirX){
                let yVal = dataY[i];
                if (yVal == null) continue;
                if (dataY0 != null) {
                    let yVal0 = dataY0[i] ?? 0;
                    if (yVal - yVal0 == 0) continue;
                    fillToY = valToPosY(yVal0, scaleY, yDim, yOff);
                }
                let xVal = scaleX.distr != 2 || disp != null ? dataX[i] : i;
                // TODO: all xPos can be pre-computed once for all series in aligned set
                let xPos = valToPosX(xVal, scaleX, xDim, xOff);
                let yPos = valToPosY($3cd00ee63e984772$var$ifNull(yVal, fillTo), scaleY, yDim, yOff);
                let lft = pxRound(xPos - xShift);
                let btm = pxRound($3cd00ee63e984772$var$max(yPos, fillToY));
                let top = pxRound($3cd00ee63e984772$var$min(yPos, fillToY));
                // this includes the stroke
                let barHgt = btm - top;
                if (yVal != null) {
                    let rv = yVal < 0 ? radBase : radVal;
                    let rb = yVal < 0 ? radVal : radBase;
                    if (multiPath) {
                        if (strokeWidth > 0 && strokeColors[i] != null) rect(strokePaths.get(strokeColors[i]), lft, top + $3cd00ee63e984772$var$floor(strokeWidth / 2), barWid, $3cd00ee63e984772$var$max(0, barHgt - strokeWidth), rv, rb);
                        if (fillColors[i] != null) rect(fillPaths.get(fillColors[i]), lft, top + $3cd00ee63e984772$var$floor(strokeWidth / 2), barWid, $3cd00ee63e984772$var$max(0, barHgt - strokeWidth), rv, rb);
                    } else rect(stroke, lft, top + $3cd00ee63e984772$var$floor(strokeWidth / 2), barWid, $3cd00ee63e984772$var$max(0, barHgt - strokeWidth), rv, rb);
                    each(u, seriesIdx, i, lft - strokeWidth / 2, top, barWid + strokeWidth, barHgt);
                }
            }
            if (strokeWidth > 0) _paths.stroke = multiPath ? strokePaths : stroke;
            else if (!multiPath) {
                _paths._fill = series.width == 0 ? series._fill : series._stroke ?? series._fill;
                _paths.width = 0;
            }
            _paths.fill = multiPath ? fillPaths : stroke;
            return _paths;
        });
    };
}
function $3cd00ee63e984772$var$splineInterp(interp, opts) {
    const alignGaps = $3cd00ee63e984772$var$ifNull(opts?.alignGaps, 0);
    return (u, seriesIdx, idx0, idx1)=>{
        return $3cd00ee63e984772$var$orient(u, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
            [idx0, idx1] = $3cd00ee63e984772$var$nonNullIdxs(dataY, idx0, idx1);
            let pxRound = series.pxRound;
            let pixelForX = (val)=>pxRound(valToPosX(val, scaleX, xDim, xOff));
            let pixelForY = (val)=>pxRound(valToPosY(val, scaleY, yDim, yOff));
            let moveTo, bezierCurveTo, lineTo;
            if (scaleX.ori == 0) {
                moveTo = $3cd00ee63e984772$var$moveToH;
                lineTo = $3cd00ee63e984772$var$lineToH;
                bezierCurveTo = $3cd00ee63e984772$var$bezierCurveToH;
            } else {
                moveTo = $3cd00ee63e984772$var$moveToV;
                lineTo = $3cd00ee63e984772$var$lineToV;
                bezierCurveTo = $3cd00ee63e984772$var$bezierCurveToV;
            }
            const dir = scaleX.dir * (scaleX.ori == 0 ? 1 : -1);
            let firstXPos = pixelForX(dataX[dir == 1 ? idx0 : idx1]);
            let prevXPos = firstXPos;
            let xCoords = [];
            let yCoords = [];
            for(let i = dir == 1 ? idx0 : idx1; i >= idx0 && i <= idx1; i += dir){
                let yVal = dataY[i];
                if (yVal != null) {
                    let xVal = dataX[i];
                    let xPos = pixelForX(xVal);
                    xCoords.push(prevXPos = xPos);
                    yCoords.push(pixelForY(dataY[i]));
                }
            }
            const _paths = {
                stroke: interp(xCoords, yCoords, moveTo, lineTo, bezierCurveTo, pxRound),
                fill: null,
                clip: null,
                band: null,
                gaps: null,
                flags: $3cd00ee63e984772$var$BAND_CLIP_FILL
            };
            const stroke = _paths.stroke;
            let [bandFillDir, bandClipDir] = $3cd00ee63e984772$var$bandFillClipDirs(u, seriesIdx);
            if (series.fill != null || bandFillDir != 0) {
                let fill = _paths.fill = new Path2D(stroke);
                let fillTo = series.fillTo(u, seriesIdx, series.min, series.max, bandFillDir);
                let fillToY = pixelForY(fillTo);
                lineTo(fill, prevXPos, fillToY);
                lineTo(fill, firstXPos, fillToY);
            }
            if (!series.spanGaps) {
                //	console.time('gaps');
                let gaps = [];
                gaps.push(...$3cd00ee63e984772$var$findGaps(dataX, dataY, idx0, idx1, dir, pixelForX, alignGaps));
                //	console.timeEnd('gaps');
                //	console.log('gaps', JSON.stringify(gaps));
                _paths.gaps = gaps = series.gaps(u, seriesIdx, idx0, idx1, gaps);
                _paths.clip = $3cd00ee63e984772$var$clipGaps(gaps, scaleX.ori, xOff, yOff, xDim, yDim);
            }
            if (bandClipDir != 0) _paths.band = bandClipDir == 2 ? [
                $3cd00ee63e984772$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, -1),
                $3cd00ee63e984772$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, 1)
            ] : $3cd00ee63e984772$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, bandClipDir);
            return _paths;
        //  if FEAT_PATHS: false in rollup.config.js
        //	u.ctx.save();
        //	u.ctx.beginPath();
        //	u.ctx.rect(u.bbox.left, u.bbox.top, u.bbox.width, u.bbox.height);
        //	u.ctx.clip();
        //	u.ctx.strokeStyle = u.series[sidx].stroke;
        //	u.ctx.stroke(stroke);
        //	u.ctx.fillStyle = u.series[sidx].fill;
        //	u.ctx.fill(fill);
        //	u.ctx.restore();
        //	return null;
        });
    };
}
function $3cd00ee63e984772$var$monotoneCubic(opts) {
    return $3cd00ee63e984772$var$splineInterp($3cd00ee63e984772$var$_monotoneCubic, opts);
}
// Monotone Cubic Spline interpolation, adapted from the Chartist.js implementation:
// https://github.com/gionkunz/chartist-js/blob/e7e78201bffe9609915e5e53cfafa29a5d6c49f9/src/scripts/interpolation.js#L240-L369
function $3cd00ee63e984772$var$_monotoneCubic(xs, ys, moveTo, lineTo, bezierCurveTo, pxRound) {
    const n = xs.length;
    if (n < 2) return null;
    const path = new Path2D();
    moveTo(path, xs[0], ys[0]);
    if (n == 2) lineTo(path, xs[1], ys[1]);
    else {
        let ms = Array(n), ds = Array(n - 1), dys = Array(n - 1), dxs = Array(n - 1);
        // calc deltas and derivative
        for(let i = 0; i < n - 1; i++){
            dys[i] = ys[i + 1] - ys[i];
            dxs[i] = xs[i + 1] - xs[i];
            ds[i] = dys[i] / dxs[i];
        }
        // determine desired slope (m) at each point using Fritsch-Carlson method
        // http://math.stackexchange.com/questions/45218/implementation-of-monotone-cubic-interpolation
        ms[0] = ds[0];
        for(let i = 1; i < n - 1; i++)if (ds[i] === 0 || ds[i - 1] === 0 || ds[i - 1] > 0 !== ds[i] > 0) ms[i] = 0;
        else {
            ms[i] = 3 * (dxs[i - 1] + dxs[i]) / ((2 * dxs[i] + dxs[i - 1]) / ds[i - 1] + (dxs[i] + 2 * dxs[i - 1]) / ds[i]);
            if (!isFinite(ms[i])) ms[i] = 0;
        }
        ms[n - 1] = ds[n - 2];
        for(let i = 0; i < n - 1; i++)bezierCurveTo(path, xs[i] + dxs[i] / 3, ys[i] + ms[i] * dxs[i] / 3, xs[i + 1] - dxs[i] / 3, ys[i + 1] - ms[i + 1] * dxs[i] / 3, xs[i + 1], ys[i + 1]);
    }
    return path;
}
const $3cd00ee63e984772$var$cursorPlots = new Set();
function $3cd00ee63e984772$var$invalidateRects() {
    for (let u of $3cd00ee63e984772$var$cursorPlots)u.syncRect(true);
}
if ($3cd00ee63e984772$var$domEnv) {
    $3cd00ee63e984772$var$on($3cd00ee63e984772$var$resize, $3cd00ee63e984772$var$win, $3cd00ee63e984772$var$invalidateRects);
    $3cd00ee63e984772$var$on($3cd00ee63e984772$var$scroll, $3cd00ee63e984772$var$win, $3cd00ee63e984772$var$invalidateRects, true);
    $3cd00ee63e984772$var$on($3cd00ee63e984772$var$dppxchange, $3cd00ee63e984772$var$win, ()=>{
        $3cd00ee63e984772$export$2e2bcd8739ae039.pxRatio = $3cd00ee63e984772$var$pxRatio;
    });
}
const $3cd00ee63e984772$var$linearPath = $3cd00ee63e984772$var$linear();
const $3cd00ee63e984772$var$pointsPath = $3cd00ee63e984772$var$points();
function $3cd00ee63e984772$var$setDefaults(d, xo, yo, initY) {
    let d2 = initY ? [
        d[0],
        d[1]
    ].concat(d.slice(2)) : [
        d[0]
    ].concat(d.slice(1));
    return d2.map((o, i)=>$3cd00ee63e984772$var$setDefault(o, i, xo, yo));
}
function $3cd00ee63e984772$var$setDefaults2(d, xyo) {
    return d.map((o, i)=>i == 0 ? {} : $3cd00ee63e984772$var$assign({}, xyo, o)); // todo: assign() will not merge facet arrays
}
function $3cd00ee63e984772$var$setDefault(o, i, xo, yo) {
    return $3cd00ee63e984772$var$assign({}, i == 0 ? xo : yo, o);
}
function $3cd00ee63e984772$var$snapNumX(self, dataMin, dataMax) {
    return dataMin == null ? $3cd00ee63e984772$var$nullNullTuple : [
        dataMin,
        dataMax
    ];
}
const $3cd00ee63e984772$var$snapTimeX = $3cd00ee63e984772$var$snapNumX;
// this ensures that non-temporal/numeric y-axes get multiple-snapped padding added above/below
// TODO: also account for incrs when snapping to ensure top of axis gets a tick & value
function $3cd00ee63e984772$var$snapNumY(self, dataMin, dataMax) {
    return dataMin == null ? $3cd00ee63e984772$var$nullNullTuple : $3cd00ee63e984772$var$rangeNum(dataMin, dataMax, $3cd00ee63e984772$var$rangePad, true);
}
function $3cd00ee63e984772$var$snapLogY(self, dataMin, dataMax, scale) {
    return dataMin == null ? $3cd00ee63e984772$var$nullNullTuple : $3cd00ee63e984772$var$rangeLog(dataMin, dataMax, self.scales[scale].log, false);
}
const $3cd00ee63e984772$var$snapLogX = $3cd00ee63e984772$var$snapLogY;
function $3cd00ee63e984772$var$snapAsinhY(self, dataMin, dataMax, scale) {
    return dataMin == null ? $3cd00ee63e984772$var$nullNullTuple : $3cd00ee63e984772$var$rangeAsinh(dataMin, dataMax, self.scales[scale].log, false);
}
const $3cd00ee63e984772$var$snapAsinhX = $3cd00ee63e984772$var$snapAsinhY;
// dim is logical (getClientBoundingRect) pixels, not canvas pixels
function $3cd00ee63e984772$var$findIncr(minVal, maxVal, incrs, dim, minSpace) {
    let intDigits = $3cd00ee63e984772$var$max($3cd00ee63e984772$var$numIntDigits(minVal), $3cd00ee63e984772$var$numIntDigits(maxVal));
    let delta = maxVal - minVal;
    let incrIdx = $3cd00ee63e984772$var$closestIdx(minSpace / dim * delta, incrs);
    do {
        let foundIncr = incrs[incrIdx];
        let foundSpace = dim * foundIncr / delta;
        if (foundSpace >= minSpace && intDigits + (foundIncr < 5 ? $3cd00ee63e984772$var$fixedDec.get(foundIncr) : 0) <= 17) return [
            foundIncr,
            foundSpace
        ];
    }while (++incrIdx < incrs.length);
    return [
        0,
        0
    ];
}
function $3cd00ee63e984772$var$pxRatioFont(font) {
    let fontSize, fontSizeCss;
    font = font.replace(/(\d+)px/, (m, p1)=>(fontSize = $3cd00ee63e984772$var$round((fontSizeCss = +p1) * $3cd00ee63e984772$var$pxRatio)) + 'px');
    return [
        font,
        fontSize,
        fontSizeCss
    ];
}
function $3cd00ee63e984772$var$syncFontSize(axis) {
    if (axis.show) [
        axis.font,
        axis.labelFont
    ].forEach((f)=>{
        let size = $3cd00ee63e984772$var$roundDec(f[2] * $3cd00ee63e984772$var$pxRatio, 1);
        f[0] = f[0].replace(/[0-9.]+px/, size + 'px');
        f[1] = size;
    });
}
function $3cd00ee63e984772$export$2e2bcd8739ae039(opts, data, then) {
    const self = {
        mode: $3cd00ee63e984772$var$ifNull(opts.mode, 1)
    };
    const mode = self.mode;
    function getHPos(val, scale, dim, off) {
        let pct = scale.valToPct(val);
        return off + dim * (scale.dir == -1 ? 1 - pct : pct);
    }
    function getVPos(val, scale, dim, off) {
        let pct = scale.valToPct(val);
        return off + dim * (scale.dir == -1 ? pct : 1 - pct);
    }
    function getPos(val, scale, dim, off) {
        return scale.ori == 0 ? getHPos(val, scale, dim, off) : getVPos(val, scale, dim, off);
    }
    self.valToPosH = getHPos;
    self.valToPosV = getVPos;
    let ready = false;
    self.status = 0;
    const root = self.root = $3cd00ee63e984772$var$placeDiv($3cd00ee63e984772$var$UPLOT);
    if (opts.id != null) root.id = opts.id;
    $3cd00ee63e984772$var$addClass(root, opts.class);
    if (opts.title) {
        let title = $3cd00ee63e984772$var$placeDiv($3cd00ee63e984772$var$TITLE, root);
        title.textContent = opts.title;
    }
    const can = $3cd00ee63e984772$var$placeTag("canvas");
    const ctx = self.ctx = can.getContext("2d");
    const wrap = $3cd00ee63e984772$var$placeDiv($3cd00ee63e984772$var$WRAP, root);
    $3cd00ee63e984772$var$on("click", wrap, (e)=>{
        if (e.target === over) {
            let didDrag = mouseLeft1 != mouseLeft0 || mouseTop1 != mouseTop0;
            didDrag && drag.click(self, e);
        }
    }, true);
    const under = self.under = $3cd00ee63e984772$var$placeDiv($3cd00ee63e984772$var$UNDER, wrap);
    wrap.appendChild(can);
    const over = self.over = $3cd00ee63e984772$var$placeDiv($3cd00ee63e984772$var$OVER, wrap);
    opts = $3cd00ee63e984772$var$copy(opts);
    const pxAlign = +$3cd00ee63e984772$var$ifNull(opts.pxAlign, 1);
    const pxRound = $3cd00ee63e984772$var$pxRoundGen(pxAlign);
    (opts.plugins || []).forEach((p)=>{
        if (p.opts) opts = p.opts(self, opts) || opts;
    });
    const ms = opts.ms || 1e-3;
    const series = self.series = mode == 1 ? $3cd00ee63e984772$var$setDefaults(opts.series || [], $3cd00ee63e984772$var$xSeriesOpts, $3cd00ee63e984772$var$ySeriesOpts, false) : $3cd00ee63e984772$var$setDefaults2(opts.series || [
        null
    ], $3cd00ee63e984772$var$xySeriesOpts);
    const axes = self.axes = $3cd00ee63e984772$var$setDefaults(opts.axes || [], $3cd00ee63e984772$var$xAxisOpts, $3cd00ee63e984772$var$yAxisOpts, true);
    const scales = self.scales = {};
    const bands = self.bands = opts.bands || [];
    bands.forEach((b)=>{
        b.fill = $3cd00ee63e984772$var$fnOrSelf(b.fill || null);
        b.dir = $3cd00ee63e984772$var$ifNull(b.dir, -1);
    });
    const xScaleKey = mode == 2 ? series[1].facets[0].scale : series[0].scale;
    const drawOrderMap = {
        axes: drawAxesGrid,
        series: drawSeries
    };
    const drawOrder = (opts.drawOrder || [
        "axes",
        "series"
    ]).map((key)=>drawOrderMap[key]);
    function initValToPct(sc) {
        const getVal = sc.distr == 3 ? (val)=>$3cd00ee63e984772$var$log10(val > 0 ? val : sc.clamp(self, val, sc.min, sc.max, sc.key)) : sc.distr == 4 ? (val)=>$3cd00ee63e984772$var$asinh(val, sc.asinh) : sc.distr == 100 ? (val)=>sc.fwd(val) : (val)=>val;
        return (val)=>{
            let _val = getVal(val);
            let { _min: _min, _max: _max } = sc;
            let delta = _max - _min;
            return (_val - _min) / delta;
        };
    }
    function initScale(scaleKey) {
        let sc = scales[scaleKey];
        if (sc == null) {
            let scaleOpts = (opts.scales || $3cd00ee63e984772$var$EMPTY_OBJ)[scaleKey] || $3cd00ee63e984772$var$EMPTY_OBJ;
            if (scaleOpts.from != null) {
                // ensure parent is initialized
                initScale(scaleOpts.from);
                // dependent scales inherit
                let sc = $3cd00ee63e984772$var$assign({}, scales[scaleOpts.from], scaleOpts, {
                    key: scaleKey
                });
                sc.valToPct = initValToPct(sc);
                scales[scaleKey] = sc;
            } else {
                sc = scales[scaleKey] = $3cd00ee63e984772$var$assign({}, scaleKey == xScaleKey ? $3cd00ee63e984772$var$xScaleOpts : $3cd00ee63e984772$var$yScaleOpts, scaleOpts);
                sc.key = scaleKey;
                let isTime = sc.time;
                let rn = sc.range;
                let rangeIsArr = $3cd00ee63e984772$var$isArr(rn);
                if (scaleKey != xScaleKey || mode == 2 && !isTime) {
                    // if range array has null limits, it should be auto
                    if (rangeIsArr && (rn[0] == null || rn[1] == null)) {
                        rn = {
                            min: rn[0] == null ? $3cd00ee63e984772$var$autoRangePart : {
                                mode: 1,
                                hard: rn[0],
                                soft: rn[0]
                            },
                            max: rn[1] == null ? $3cd00ee63e984772$var$autoRangePart : {
                                mode: 1,
                                hard: rn[1],
                                soft: rn[1]
                            }
                        };
                        rangeIsArr = false;
                    }
                    if (!rangeIsArr && $3cd00ee63e984772$var$isObj(rn)) {
                        let cfg = rn;
                        // this is similar to snapNumY
                        rn = (self, dataMin, dataMax)=>dataMin == null ? $3cd00ee63e984772$var$nullNullTuple : $3cd00ee63e984772$var$rangeNum(dataMin, dataMax, cfg);
                    }
                }
                sc.range = $3cd00ee63e984772$var$fnOrSelf(rn || (isTime ? $3cd00ee63e984772$var$snapTimeX : scaleKey == xScaleKey ? sc.distr == 3 ? $3cd00ee63e984772$var$snapLogX : sc.distr == 4 ? $3cd00ee63e984772$var$snapAsinhX : $3cd00ee63e984772$var$snapNumX : sc.distr == 3 ? $3cd00ee63e984772$var$snapLogY : sc.distr == 4 ? $3cd00ee63e984772$var$snapAsinhY : $3cd00ee63e984772$var$snapNumY));
                sc.auto = $3cd00ee63e984772$var$fnOrSelf(rangeIsArr ? false : sc.auto);
                sc.clamp = $3cd00ee63e984772$var$fnOrSelf(sc.clamp || $3cd00ee63e984772$var$clampScale);
                // caches for expensive ops like asinh() & log()
                sc._min = sc._max = null;
                sc.valToPct = initValToPct(sc);
            }
        }
    }
    initScale("x");
    initScale("y");
    // TODO: init scales from facets in mode: 2
    if (mode == 1) series.forEach((s)=>{
        initScale(s.scale);
    });
    axes.forEach((a)=>{
        initScale(a.scale);
    });
    for(let k in opts.scales)initScale(k);
    const scaleX = scales[xScaleKey];
    const xScaleDistr = scaleX.distr;
    let valToPosX, valToPosY;
    if (scaleX.ori == 0) {
        $3cd00ee63e984772$var$addClass(root, $3cd00ee63e984772$var$ORI_HZ);
        valToPosX = getHPos;
        valToPosY = getVPos;
    /*
		updOriDims = () => {
			xDimCan = plotWid;
			xOffCan = plotLft;
			yDimCan = plotHgt;
			yOffCan = plotTop;

			xDimCss = plotWidCss;
			xOffCss = plotLftCss;
			yDimCss = plotHgtCss;
			yOffCss = plotTopCss;
		};
		*/ } else {
        $3cd00ee63e984772$var$addClass(root, $3cd00ee63e984772$var$ORI_VT);
        valToPosX = getVPos;
        valToPosY = getHPos;
    /*
		updOriDims = () => {
			xDimCan = plotHgt;
			xOffCan = plotTop;
			yDimCan = plotWid;
			yOffCan = plotLft;

			xDimCss = plotHgtCss;
			xOffCss = plotTopCss;
			yDimCss = plotWidCss;
			yOffCss = plotLftCss;
		};
		*/ }
    const pendScales = {};
    // explicitly-set initial scales
    for(let k in scales){
        let sc = scales[k];
        if (sc.min != null || sc.max != null) {
            pendScales[k] = {
                min: sc.min,
                max: sc.max
            };
            sc.min = sc.max = null;
        }
    }
    //	self.tz = opts.tz || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const _tzDate = opts.tzDate || ((ts)=>new Date($3cd00ee63e984772$var$round(ts / ms)));
    const _fmtDate = opts.fmtDate || $3cd00ee63e984772$var$fmtDate;
    const _timeAxisSplits = ms == 1 ? $3cd00ee63e984772$var$timeAxisSplitsMs(_tzDate) : $3cd00ee63e984772$var$timeAxisSplitsS(_tzDate);
    const _timeAxisVals = $3cd00ee63e984772$var$timeAxisVals(_tzDate, $3cd00ee63e984772$var$timeAxisStamps(ms == 1 ? $3cd00ee63e984772$var$_timeAxisStampsMs : $3cd00ee63e984772$var$_timeAxisStampsS, _fmtDate));
    const _timeSeriesVal = $3cd00ee63e984772$var$timeSeriesVal(_tzDate, $3cd00ee63e984772$var$timeSeriesStamp($3cd00ee63e984772$var$_timeSeriesStamp, _fmtDate));
    const activeIdxs = [];
    const legend = self.legend = $3cd00ee63e984772$var$assign({}, $3cd00ee63e984772$var$legendOpts, opts.legend);
    const cursor = self.cursor = $3cd00ee63e984772$var$assign({}, $3cd00ee63e984772$var$cursorOpts, {
        drag: {
            y: mode == 2
        }
    }, opts.cursor);
    const showLegend = legend.show;
    const showCursor = cursor.show;
    const markers = legend.markers;
    legend.idxs = activeIdxs;
    markers.width = $3cd00ee63e984772$var$fnOrSelf(markers.width);
    markers.dash = $3cd00ee63e984772$var$fnOrSelf(markers.dash);
    markers.stroke = $3cd00ee63e984772$var$fnOrSelf(markers.stroke);
    markers.fill = $3cd00ee63e984772$var$fnOrSelf(markers.fill);
    let legendTable;
    let legendHead;
    let legendBody;
    let legendRows = [];
    let legendCells = [];
    let legendCols;
    let multiValLegend = false;
    let NULL_LEGEND_VALUES = {};
    if (legend.live) {
        const getMultiVals = series[1] ? series[1].values : null;
        multiValLegend = getMultiVals != null;
        legendCols = multiValLegend ? getMultiVals(self, 1, 0) : {
            _: 0
        };
        for(let k in legendCols)NULL_LEGEND_VALUES[k] = $3cd00ee63e984772$var$LEGEND_DISP;
    }
    if (showLegend) {
        legendTable = $3cd00ee63e984772$var$placeTag("table", $3cd00ee63e984772$var$LEGEND, root);
        legendBody = $3cd00ee63e984772$var$placeTag("tbody", null, legendTable);
        // allows legend to be moved out of root
        legend.mount(self, legendTable);
        if (multiValLegend) {
            legendHead = $3cd00ee63e984772$var$placeTag("thead", null, legendTable, legendBody);
            let head = $3cd00ee63e984772$var$placeTag("tr", null, legendHead);
            $3cd00ee63e984772$var$placeTag("th", null, head);
            for(var key in legendCols)$3cd00ee63e984772$var$placeTag("th", $3cd00ee63e984772$var$LEGEND_LABEL, head).textContent = key;
        } else {
            $3cd00ee63e984772$var$addClass(legendTable, $3cd00ee63e984772$var$LEGEND_INLINE);
            legend.live && $3cd00ee63e984772$var$addClass(legendTable, $3cd00ee63e984772$var$LEGEND_LIVE);
        }
    }
    const son = {
        show: true
    };
    const soff = {
        show: false
    };
    function initLegendRow(s, i) {
        if (i == 0 && (multiValLegend || !legend.live || mode == 2)) return $3cd00ee63e984772$var$nullNullTuple;
        let cells = [];
        let row = $3cd00ee63e984772$var$placeTag("tr", $3cd00ee63e984772$var$LEGEND_SERIES, legendBody, legendBody.childNodes[i]);
        $3cd00ee63e984772$var$addClass(row, s.class);
        if (!s.show) $3cd00ee63e984772$var$addClass(row, $3cd00ee63e984772$var$OFF);
        let label = $3cd00ee63e984772$var$placeTag("th", null, row);
        if (markers.show) {
            let indic = $3cd00ee63e984772$var$placeDiv($3cd00ee63e984772$var$LEGEND_MARKER, label);
            if (i > 0) {
                let width = markers.width(self, i);
                if (width) indic.style.border = width + "px " + markers.dash(self, i) + " " + markers.stroke(self, i);
                indic.style.background = markers.fill(self, i);
            }
        }
        let text = $3cd00ee63e984772$var$placeDiv($3cd00ee63e984772$var$LEGEND_LABEL, label);
        if (s.label instanceof HTMLElement) text.appendChild(s.label);
        else text.textContent = s.label;
        if (i > 0) {
            if (!markers.show) text.style.color = s.width > 0 ? markers.stroke(self, i) : markers.fill(self, i);
            onMouse("click", label, (e)=>{
                if (cursor._lock) return;
                setCursorEvent(e);
                let seriesIdx = series.indexOf(s);
                if ((e.ctrlKey || e.metaKey) != legend.isolate) {
                    // if any other series is shown, isolate this one. else show all
                    let isolate = series.some((s, i)=>i > 0 && i != seriesIdx && s.show);
                    series.forEach((s, i)=>{
                        i > 0 && setSeries(i, isolate ? i == seriesIdx ? son : soff : son, true, syncOpts.setSeries);
                    });
                } else setSeries(seriesIdx, {
                    show: !s.show
                }, true, syncOpts.setSeries);
            }, false);
            if (cursorFocus) onMouse($3cd00ee63e984772$var$mouseenter, label, (e)=>{
                if (cursor._lock) return;
                setCursorEvent(e);
                setSeries(series.indexOf(s), FOCUS_TRUE, true, syncOpts.setSeries);
            }, false);
        }
        for(var key in legendCols){
            let v = $3cd00ee63e984772$var$placeTag("td", $3cd00ee63e984772$var$LEGEND_VALUE, row);
            v.textContent = "--";
            cells.push(v);
        }
        return [
            row,
            cells
        ];
    }
    const mouseListeners = new Map();
    function onMouse(ev, targ, fn, onlyTarg = true) {
        const targListeners = mouseListeners.get(targ) || {};
        const listener = cursor.bind[ev](self, targ, fn, onlyTarg);
        if (listener) {
            $3cd00ee63e984772$var$on(ev, targ, targListeners[ev] = listener);
            mouseListeners.set(targ, targListeners);
        }
    }
    function offMouse(ev, targ, fn) {
        const targListeners = mouseListeners.get(targ) || {};
        for(let k in targListeners)if (ev == null || k == ev) {
            $3cd00ee63e984772$var$off(k, targ, targListeners[k]);
            delete targListeners[k];
        }
        if (ev == null) mouseListeners.delete(targ);
    }
    let fullWidCss = 0;
    let fullHgtCss = 0;
    let plotWidCss = 0;
    let plotHgtCss = 0;
    // plot margins to account for axes
    let plotLftCss = 0;
    let plotTopCss = 0;
    // previous values for diffing
    let _plotLftCss = plotLftCss;
    let _plotTopCss = plotTopCss;
    let _plotWidCss = plotWidCss;
    let _plotHgtCss = plotHgtCss;
    let plotLft = 0;
    let plotTop = 0;
    let plotWid = 0;
    let plotHgt = 0;
    self.bbox = {};
    let shouldSetScales = false;
    let shouldSetSize = false;
    let shouldConvergeSize = false;
    let shouldSetCursor = false;
    let shouldSetSelect = false;
    let shouldSetLegend = false;
    function _setSize(width, height, force) {
        if (force || width != self.width || height != self.height) calcSize(width, height);
        resetYSeries(false);
        shouldConvergeSize = true;
        shouldSetSize = true;
        commit();
    }
    function calcSize(width, height) {
        //	log("calcSize()", arguments);
        self.width = fullWidCss = plotWidCss = width;
        self.height = fullHgtCss = plotHgtCss = height;
        plotLftCss = plotTopCss = 0;
        calcPlotRect();
        calcAxesRects();
        let bb = self.bbox;
        plotLft = bb.left = $3cd00ee63e984772$var$incrRound(plotLftCss * $3cd00ee63e984772$var$pxRatio, 0.5);
        plotTop = bb.top = $3cd00ee63e984772$var$incrRound(plotTopCss * $3cd00ee63e984772$var$pxRatio, 0.5);
        plotWid = bb.width = $3cd00ee63e984772$var$incrRound(plotWidCss * $3cd00ee63e984772$var$pxRatio, 0.5);
        plotHgt = bb.height = $3cd00ee63e984772$var$incrRound(plotHgtCss * $3cd00ee63e984772$var$pxRatio, 0.5);
    //	updOriDims();
    }
    // ensures size calc convergence
    const CYCLE_LIMIT = 3;
    function convergeSize() {
        let converged = false;
        let cycleNum = 0;
        while(!converged){
            cycleNum++;
            let axesConverged = axesCalc(cycleNum);
            let paddingConverged = paddingCalc(cycleNum);
            converged = cycleNum == CYCLE_LIMIT || axesConverged && paddingConverged;
            if (!converged) {
                calcSize(self.width, self.height);
                shouldSetSize = true;
            }
        }
    }
    function setSize({ width: width, height: height }) {
        _setSize(width, height);
    }
    self.setSize = setSize;
    // accumulate axis offsets, reduce canvas width
    function calcPlotRect() {
        // easements for edge labels
        let hasTopAxis = false;
        let hasBtmAxis = false;
        let hasRgtAxis = false;
        let hasLftAxis = false;
        axes.forEach((axis, i)=>{
            if (axis.show && axis._show) {
                let { side: side, _size: _size } = axis;
                let isVt = side % 2;
                let labelSize = axis.label != null ? axis.labelSize : 0;
                let fullSize = _size + labelSize;
                if (fullSize > 0) {
                    if (isVt) {
                        plotWidCss -= fullSize;
                        if (side == 3) {
                            plotLftCss += fullSize;
                            hasLftAxis = true;
                        } else hasRgtAxis = true;
                    } else {
                        plotHgtCss -= fullSize;
                        if (side == 0) {
                            plotTopCss += fullSize;
                            hasTopAxis = true;
                        } else hasBtmAxis = true;
                    }
                }
            }
        });
        sidesWithAxes[0] = hasTopAxis;
        sidesWithAxes[1] = hasRgtAxis;
        sidesWithAxes[2] = hasBtmAxis;
        sidesWithAxes[3] = hasLftAxis;
        // hz padding
        plotWidCss -= _padding[1] + _padding[3];
        plotLftCss += _padding[3];
        // vt padding
        plotHgtCss -= _padding[2] + _padding[0];
        plotTopCss += _padding[0];
    }
    function calcAxesRects() {
        // will accum +
        let off1 = plotLftCss + plotWidCss;
        let off2 = plotTopCss + plotHgtCss;
        // will accum -
        let off3 = plotLftCss;
        let off0 = plotTopCss;
        function incrOffset(side, size) {
            switch(side){
                case 1:
                    off1 += size;
                    return off1 - size;
                case 2:
                    off2 += size;
                    return off2 - size;
                case 3:
                    off3 -= size;
                    return off3 + size;
                case 0:
                    off0 -= size;
                    return off0 + size;
            }
        }
        axes.forEach((axis, i)=>{
            if (axis.show && axis._show) {
                let side = axis.side;
                axis._pos = incrOffset(side, axis._size);
                if (axis.label != null) axis._lpos = incrOffset(side, axis.labelSize);
            }
        });
    }
    if (cursor.dataIdx == null) {
        let hov = cursor.hover;
        let skip = hov.skip = new Set(hov.skip ?? []);
        skip.add(void 0); // alignment artifacts
        let prox = hov.prox = $3cd00ee63e984772$var$fnOrSelf(hov.prox);
        let bias = hov.bias ??= 0;
        // TODO: only scan between in-view idxs (i0, i1)
        cursor.dataIdx = (self, seriesIdx, cursorIdx, valAtPosX)=>{
            if (seriesIdx == 0) return cursorIdx;
            let idx2 = cursorIdx;
            let _prox = prox(self, seriesIdx, cursorIdx, valAtPosX) ?? $3cd00ee63e984772$var$inf;
            let withProx = _prox >= 0 && _prox < $3cd00ee63e984772$var$inf;
            let xDim = scaleX.ori == 0 ? plotWidCss : plotHgtCss;
            let cursorLft = cursor.left;
            let xValues = data[0];
            let yValues = data[seriesIdx];
            if (skip.has(yValues[cursorIdx])) {
                idx2 = null;
                let nonNullLft = null, nonNullRgt = null, j;
                if (bias == 0 || bias == -1) {
                    j = cursorIdx;
                    while(nonNullLft == null && j-- > 0)if (!skip.has(yValues[j])) nonNullLft = j;
                }
                if (bias == 0 || bias == 1) {
                    j = cursorIdx;
                    while(nonNullRgt == null && j++ < yValues.length)if (!skip.has(yValues[j])) nonNullRgt = j;
                }
                if (nonNullLft != null || nonNullRgt != null) {
                    if (withProx) {
                        let lftPos = nonNullLft == null ? -Infinity : valToPosX(xValues[nonNullLft], scaleX, xDim, 0);
                        let rgtPos = nonNullRgt == null ? Infinity : valToPosX(xValues[nonNullRgt], scaleX, xDim, 0);
                        let lftDelta = cursorLft - lftPos;
                        let rgtDelta = rgtPos - cursorLft;
                        if (lftDelta <= rgtDelta) {
                            if (lftDelta <= _prox) idx2 = nonNullLft;
                        } else if (rgtDelta <= _prox) idx2 = nonNullRgt;
                    } else idx2 = nonNullRgt == null ? nonNullLft : nonNullLft == null ? nonNullRgt : cursorIdx - nonNullLft <= nonNullRgt - cursorIdx ? nonNullLft : nonNullRgt;
                }
            } else if (withProx) {
                let dist = $3cd00ee63e984772$var$abs(cursorLft - valToPosX(xValues[cursorIdx], scaleX, xDim, 0));
                if (dist > _prox) idx2 = null;
            }
            return idx2;
        };
    }
    const setCursorEvent = (e)=>{
        cursor.event = e;
    };
    cursor.idxs = activeIdxs;
    cursor._lock = false;
    let points = cursor.points;
    points.show = $3cd00ee63e984772$var$fnOrSelf(points.show);
    points.size = $3cd00ee63e984772$var$fnOrSelf(points.size);
    points.stroke = $3cd00ee63e984772$var$fnOrSelf(points.stroke);
    points.width = $3cd00ee63e984772$var$fnOrSelf(points.width);
    points.fill = $3cd00ee63e984772$var$fnOrSelf(points.fill);
    const focus = self.focus = $3cd00ee63e984772$var$assign({}, opts.focus || {
        alpha: 0.3
    }, cursor.focus);
    const cursorFocus = focus.prox >= 0;
    const cursorOnePt = cursorFocus && points.one;
    // series-intersection markers
    let cursorPts = [];
    // position caches in CSS pixels
    let cursorPtsLft = [];
    let cursorPtsTop = [];
    function initCursorPt(s, si) {
        let pt = points.show(self, si);
        if (pt instanceof HTMLElement) {
            $3cd00ee63e984772$var$addClass(pt, $3cd00ee63e984772$var$CURSOR_PT);
            $3cd00ee63e984772$var$addClass(pt, s.class);
            $3cd00ee63e984772$var$elTrans(pt, -10, -10, plotWidCss, plotHgtCss);
            over.insertBefore(pt, cursorPts[si]);
            return pt;
        }
    }
    function initSeries(s, i) {
        if (mode == 1 || i > 0) {
            let isTime = mode == 1 && scales[s.scale].time;
            let sv = s.value;
            s.value = isTime ? $3cd00ee63e984772$var$isStr(sv) ? $3cd00ee63e984772$var$timeSeriesVal(_tzDate, $3cd00ee63e984772$var$timeSeriesStamp(sv, _fmtDate)) : sv || _timeSeriesVal : sv || $3cd00ee63e984772$var$numSeriesVal;
            s.label = s.label || (isTime ? $3cd00ee63e984772$var$timeSeriesLabel : $3cd00ee63e984772$var$numSeriesLabel);
        }
        if (cursorOnePt || i > 0) {
            s.width = s.width == null ? 1 : s.width;
            s.paths = s.paths || $3cd00ee63e984772$var$linearPath || $3cd00ee63e984772$var$retNull;
            s.fillTo = $3cd00ee63e984772$var$fnOrSelf(s.fillTo || $3cd00ee63e984772$var$seriesFillTo);
            s.pxAlign = +$3cd00ee63e984772$var$ifNull(s.pxAlign, pxAlign);
            s.pxRound = $3cd00ee63e984772$var$pxRoundGen(s.pxAlign);
            s.stroke = $3cd00ee63e984772$var$fnOrSelf(s.stroke || null);
            s.fill = $3cd00ee63e984772$var$fnOrSelf(s.fill || null);
            s._stroke = s._fill = s._paths = s._focus = null;
            let _ptDia = $3cd00ee63e984772$var$ptDia($3cd00ee63e984772$var$max(1, s.width), 1);
            let points = s.points = $3cd00ee63e984772$var$assign({}, {
                size: _ptDia,
                width: $3cd00ee63e984772$var$max(1, _ptDia * .2),
                stroke: s.stroke,
                space: _ptDia * 2,
                paths: $3cd00ee63e984772$var$pointsPath,
                _stroke: null,
                _fill: null
            }, s.points);
            points.show = $3cd00ee63e984772$var$fnOrSelf(points.show);
            points.filter = $3cd00ee63e984772$var$fnOrSelf(points.filter);
            points.fill = $3cd00ee63e984772$var$fnOrSelf(points.fill);
            points.stroke = $3cd00ee63e984772$var$fnOrSelf(points.stroke);
            points.paths = $3cd00ee63e984772$var$fnOrSelf(points.paths);
            points.pxAlign = s.pxAlign;
        }
        if (showLegend) {
            let rowCells = initLegendRow(s, i);
            legendRows.splice(i, 0, rowCells[0]);
            legendCells.splice(i, 0, rowCells[1]);
            legend.values.push(null); // NULL_LEGEND_VALS not yet avil here :(
        }
        if (showCursor) {
            activeIdxs.splice(i, 0, null);
            let pt = null;
            if (cursorOnePt) {
                if (i == 0) pt = initCursorPt(s, i);
            } else if (i > 0) pt = initCursorPt(s, i);
            cursorPts.splice(i, 0, pt);
            cursorPtsLft.splice(i, 0, 0);
            cursorPtsTop.splice(i, 0, 0);
        }
        fire("addSeries", i);
    }
    function addSeries(opts, si) {
        si = si == null ? series.length : si;
        opts = mode == 1 ? $3cd00ee63e984772$var$setDefault(opts, si, $3cd00ee63e984772$var$xSeriesOpts, $3cd00ee63e984772$var$ySeriesOpts) : $3cd00ee63e984772$var$setDefault(opts, si, {}, $3cd00ee63e984772$var$xySeriesOpts);
        series.splice(si, 0, opts);
        initSeries(series[si], si);
    }
    self.addSeries = addSeries;
    function delSeries(i) {
        series.splice(i, 1);
        if (showLegend) {
            legend.values.splice(i, 1);
            legendCells.splice(i, 1);
            let tr = legendRows.splice(i, 1)[0];
            offMouse(null, tr.firstChild);
            tr.remove();
        }
        if (showCursor) {
            activeIdxs.splice(i, 1);
            cursorPts.splice(i, 1)[0].remove();
            cursorPtsLft.splice(i, 1);
            cursorPtsTop.splice(i, 1);
        }
        // TODO: de-init no-longer-needed scales?
        fire("delSeries", i);
    }
    self.delSeries = delSeries;
    const sidesWithAxes = [
        false,
        false,
        false,
        false
    ];
    function initAxis(axis, i) {
        axis._show = axis.show;
        if (axis.show) {
            let isVt = axis.side % 2;
            let sc = scales[axis.scale];
            // this can occur if all series specify non-default scales
            if (sc == null) {
                axis.scale = isVt ? series[1].scale : xScaleKey;
                sc = scales[axis.scale];
            }
            // also set defaults for incrs & values based on axis distr
            let isTime = sc.time;
            axis.size = $3cd00ee63e984772$var$fnOrSelf(axis.size);
            axis.space = $3cd00ee63e984772$var$fnOrSelf(axis.space);
            axis.rotate = $3cd00ee63e984772$var$fnOrSelf(axis.rotate);
            if ($3cd00ee63e984772$var$isArr(axis.incrs)) axis.incrs.forEach((incr)=>{
                !$3cd00ee63e984772$var$fixedDec.has(incr) && $3cd00ee63e984772$var$fixedDec.set(incr, $3cd00ee63e984772$var$guessDec(incr));
            });
            axis.incrs = $3cd00ee63e984772$var$fnOrSelf(axis.incrs || (sc.distr == 2 ? $3cd00ee63e984772$var$wholeIncrs : isTime ? ms == 1 ? $3cd00ee63e984772$var$timeIncrsMs : $3cd00ee63e984772$var$timeIncrsS : $3cd00ee63e984772$var$numIncrs));
            axis.splits = $3cd00ee63e984772$var$fnOrSelf(axis.splits || (isTime && sc.distr == 1 ? _timeAxisSplits : sc.distr == 3 ? $3cd00ee63e984772$var$logAxisSplits : sc.distr == 4 ? $3cd00ee63e984772$var$asinhAxisSplits : $3cd00ee63e984772$var$numAxisSplits));
            axis.stroke = $3cd00ee63e984772$var$fnOrSelf(axis.stroke);
            axis.grid.stroke = $3cd00ee63e984772$var$fnOrSelf(axis.grid.stroke);
            axis.ticks.stroke = $3cd00ee63e984772$var$fnOrSelf(axis.ticks.stroke);
            axis.border.stroke = $3cd00ee63e984772$var$fnOrSelf(axis.border.stroke);
            let av = axis.values;
            axis.values = // static array of tick values
            $3cd00ee63e984772$var$isArr(av) && !$3cd00ee63e984772$var$isArr(av[0]) ? $3cd00ee63e984772$var$fnOrSelf(av) : // temporal
            isTime ? // config array of fmtDate string tpls
            $3cd00ee63e984772$var$isArr(av) ? $3cd00ee63e984772$var$timeAxisVals(_tzDate, $3cd00ee63e984772$var$timeAxisStamps(av, _fmtDate)) : // fmtDate string tpl
            $3cd00ee63e984772$var$isStr(av) ? $3cd00ee63e984772$var$timeAxisVal(_tzDate, av) : av || _timeAxisVals : av || $3cd00ee63e984772$var$numAxisVals;
            axis.filter = $3cd00ee63e984772$var$fnOrSelf(axis.filter || (sc.distr >= 3 && sc.log == 10 ? $3cd00ee63e984772$var$log10AxisValsFilt : sc.distr == 3 && sc.log == 2 ? $3cd00ee63e984772$var$log2AxisValsFilt : $3cd00ee63e984772$var$retArg1));
            axis.font = $3cd00ee63e984772$var$pxRatioFont(axis.font);
            axis.labelFont = $3cd00ee63e984772$var$pxRatioFont(axis.labelFont);
            axis._size = axis.size(self, null, i, 0);
            axis._space = axis._rotate = axis._incrs = axis._found = axis._splits = axis._values = null;
            if (axis._size > 0) {
                sidesWithAxes[i] = true;
                axis._el = $3cd00ee63e984772$var$placeDiv($3cd00ee63e984772$var$AXIS, wrap);
            }
        // debug
        //	axis._el.style.background = "#"  + Math.floor(Math.random()*16777215).toString(16) + '80';
        }
    }
    function autoPadSide(self, side, sidesWithAxes, cycleNum) {
        let [hasTopAxis, hasRgtAxis, hasBtmAxis, hasLftAxis] = sidesWithAxes;
        let ori = side % 2;
        let size = 0;
        if (ori == 0 && (hasLftAxis || hasRgtAxis)) size = side == 0 && !hasTopAxis || side == 2 && !hasBtmAxis ? $3cd00ee63e984772$var$round($3cd00ee63e984772$var$xAxisOpts.size / 3) : 0;
        if (ori == 1 && (hasTopAxis || hasBtmAxis)) size = side == 1 && !hasRgtAxis || side == 3 && !hasLftAxis ? $3cd00ee63e984772$var$round($3cd00ee63e984772$var$yAxisOpts.size / 2) : 0;
        return size;
    }
    const padding = self.padding = (opts.padding || [
        autoPadSide,
        autoPadSide,
        autoPadSide,
        autoPadSide
    ]).map((p)=>$3cd00ee63e984772$var$fnOrSelf($3cd00ee63e984772$var$ifNull(p, autoPadSide)));
    const _padding = self._padding = padding.map((p, i)=>p(self, i, sidesWithAxes, 0));
    let dataLen;
    // rendered data window
    let i0 = null;
    let i1 = null;
    const idxs = mode == 1 ? series[0].idxs : null;
    let data0 = null;
    let viaAutoScaleX = false;
    function setData(_data, _resetScales) {
        data = _data == null ? [] : _data;
        self.data = self._data = data;
        if (mode == 2) {
            dataLen = 0;
            for(let i = 1; i < series.length; i++)dataLen += data[i][0].length;
        } else {
            if (data.length == 0) self.data = self._data = data = [
                []
            ];
            data0 = data[0];
            dataLen = data0.length;
            let scaleData = data;
            if (xScaleDistr == 2) {
                scaleData = data.slice();
                let _data0 = scaleData[0] = Array(dataLen);
                for(let i = 0; i < dataLen; i++)_data0[i] = i;
            }
            self._data = data = scaleData;
        }
        resetYSeries(true);
        fire("setData");
        // forces x axis tick values to re-generate when neither x scale nor y scale changes
        // in ordinal mode, scale range is by index, so will not change if new data has same length, but tick values are from data
        if (xScaleDistr == 2) shouldConvergeSize = true;
        if (_resetScales !== false) {
            let xsc = scaleX;
            if (xsc.auto(self, viaAutoScaleX)) autoScaleX();
            else _setScale(xScaleKey, xsc.min, xsc.max);
            shouldSetCursor = shouldSetCursor || cursor.left >= 0;
            shouldSetLegend = true;
            commit();
        }
    }
    self.setData = setData;
    function autoScaleX() {
        viaAutoScaleX = true;
        let _min, _max;
        if (mode == 1) {
            if (dataLen > 0) {
                i0 = idxs[0] = 0;
                i1 = idxs[1] = dataLen - 1;
                _min = data[0][i0];
                _max = data[0][i1];
                if (xScaleDistr == 2) {
                    _min = i0;
                    _max = i1;
                } else if (_min == _max) {
                    if (xScaleDistr == 3) [_min, _max] = $3cd00ee63e984772$var$rangeLog(_min, _min, scaleX.log, false);
                    else if (xScaleDistr == 4) [_min, _max] = $3cd00ee63e984772$var$rangeAsinh(_min, _min, scaleX.log, false);
                    else if (scaleX.time) _max = _min + $3cd00ee63e984772$var$round(86400 / ms);
                    else [_min, _max] = $3cd00ee63e984772$var$rangeNum(_min, _max, $3cd00ee63e984772$var$rangePad, true);
                }
            } else {
                i0 = idxs[0] = _min = null;
                i1 = idxs[1] = _max = null;
            }
        }
        _setScale(xScaleKey, _min, _max);
    }
    let ctxStroke, ctxFill, ctxWidth, ctxDash, ctxJoin, ctxCap, ctxFont, ctxAlign, ctxBaseline;
    let ctxAlpha;
    function setCtxStyle(stroke, width, dash, cap, fill, join) {
        stroke ??= $3cd00ee63e984772$var$transparent;
        dash ??= $3cd00ee63e984772$var$EMPTY_ARR;
        cap ??= "butt"; // (‿|‿)
        fill ??= $3cd00ee63e984772$var$transparent;
        join ??= "round";
        if (stroke != ctxStroke) ctx.strokeStyle = ctxStroke = stroke;
        if (fill != ctxFill) ctx.fillStyle = ctxFill = fill;
        if (width != ctxWidth) ctx.lineWidth = ctxWidth = width;
        if (join != ctxJoin) ctx.lineJoin = ctxJoin = join;
        if (cap != ctxCap) ctx.lineCap = ctxCap = cap;
        if (dash != ctxDash) ctx.setLineDash(ctxDash = dash);
    }
    function setFontStyle(font, fill, align, baseline) {
        if (fill != ctxFill) ctx.fillStyle = ctxFill = fill;
        if (font != ctxFont) ctx.font = ctxFont = font;
        if (align != ctxAlign) ctx.textAlign = ctxAlign = align;
        if (baseline != ctxBaseline) ctx.textBaseline = ctxBaseline = baseline;
    }
    function accScale(wsc, psc, facet, data, sorted = 0) {
        if (data.length > 0 && wsc.auto(self, viaAutoScaleX) && (psc == null || psc.min == null)) {
            let _i0 = $3cd00ee63e984772$var$ifNull(i0, 0);
            let _i1 = $3cd00ee63e984772$var$ifNull(i1, data.length - 1);
            // only run getMinMax() for invalidated series data, else reuse
            let minMax = facet.min == null ? $3cd00ee63e984772$var$getMinMax(data, _i0, _i1, sorted, wsc.distr == 3) : [
                facet.min,
                facet.max
            ];
            // initial min/max
            wsc.min = $3cd00ee63e984772$var$min(wsc.min, facet.min = minMax[0]);
            wsc.max = $3cd00ee63e984772$var$max(wsc.max, facet.max = minMax[1]);
        }
    }
    const AUTOSCALE = {
        min: null,
        max: null
    };
    function setScales() {
        //	log("setScales()", arguments);
        // implicitly add auto scales, and unranged scales
        for(let k in scales){
            let sc = scales[k];
            if (pendScales[k] == null && // scales that have never been set (on init)
            (sc.min == null || // or auto scales when the x scale was explicitly set
            pendScales[xScaleKey] != null && sc.auto(self, viaAutoScaleX))) pendScales[k] = AUTOSCALE;
        }
        // implicitly add dependent scales
        for(let k in scales){
            let sc = scales[k];
            if (pendScales[k] == null && sc.from != null && pendScales[sc.from] != null) pendScales[k] = AUTOSCALE;
        }
        // explicitly setting the x-scale invalidates everything (acts as redraw)
        if (pendScales[xScaleKey] != null) resetYSeries(true); // TODO: only reset series on auto scales?
        let wipScales = {};
        for(let k in pendScales){
            let psc = pendScales[k];
            if (psc != null) {
                let wsc = wipScales[k] = $3cd00ee63e984772$var$copy(scales[k], $3cd00ee63e984772$var$fastIsObj);
                if (psc.min != null) $3cd00ee63e984772$var$assign(wsc, psc);
                else if (k != xScaleKey || mode == 2) {
                    if (dataLen == 0 && wsc.from == null) {
                        let minMax = wsc.range(self, null, null, k);
                        wsc.min = minMax[0];
                        wsc.max = minMax[1];
                    } else {
                        wsc.min = $3cd00ee63e984772$var$inf;
                        wsc.max = -$3cd00ee63e984772$var$inf;
                    }
                }
            }
        }
        if (dataLen > 0) {
            // pre-range y-scales from y series' data values
            series.forEach((s, i)=>{
                if (mode == 1) {
                    let k = s.scale;
                    let psc = pendScales[k];
                    if (psc == null) return;
                    let wsc = wipScales[k];
                    if (i == 0) {
                        let minMax = wsc.range(self, wsc.min, wsc.max, k);
                        wsc.min = minMax[0];
                        wsc.max = minMax[1];
                        i0 = $3cd00ee63e984772$var$closestIdx(wsc.min, data[0]);
                        i1 = $3cd00ee63e984772$var$closestIdx(wsc.max, data[0]);
                        // don't try to contract same or adjacent idxs
                        if (i1 - i0 > 1) {
                            // closest indices can be outside of view
                            if (data[0][i0] < wsc.min) i0++;
                            if (data[0][i1] > wsc.max) i1--;
                        }
                        s.min = data0[i0];
                        s.max = data0[i1];
                    } else if (s.show && s.auto) accScale(wsc, psc, s, data[i], s.sorted);
                    s.idxs[0] = i0;
                    s.idxs[1] = i1;
                } else {
                    if (i > 0) {
                        if (s.show && s.auto) {
                            // TODO: only handles, assumes and requires facets[0] / 'x' scale, and facets[1] / 'y' scale
                            let [xFacet, yFacet] = s.facets;
                            let xScaleKey = xFacet.scale;
                            let yScaleKey = yFacet.scale;
                            let [xData, yData] = data[i];
                            let wscx = wipScales[xScaleKey];
                            let wscy = wipScales[yScaleKey];
                            // null can happen when only x is zoomed, but y has static range and doesnt get auto-added to pending
                            wscx != null && accScale(wscx, pendScales[xScaleKey], xFacet, xData, xFacet.sorted);
                            wscy != null && accScale(wscy, pendScales[yScaleKey], yFacet, yData, yFacet.sorted);
                            // temp
                            s.min = yFacet.min;
                            s.max = yFacet.max;
                        }
                    }
                }
            });
            // range independent scales
            for(let k in wipScales){
                let wsc = wipScales[k];
                let psc = pendScales[k];
                if (wsc.from == null && (psc == null || psc.min == null)) {
                    let minMax = wsc.range(self, wsc.min == $3cd00ee63e984772$var$inf ? null : wsc.min, wsc.max == -$3cd00ee63e984772$var$inf ? null : wsc.max, k);
                    wsc.min = minMax[0];
                    wsc.max = minMax[1];
                }
            }
        }
        // range dependent scales
        for(let k in wipScales){
            let wsc = wipScales[k];
            if (wsc.from != null) {
                let base = wipScales[wsc.from];
                if (base.min == null) wsc.min = wsc.max = null;
                else {
                    let minMax = wsc.range(self, base.min, base.max, k);
                    wsc.min = minMax[0];
                    wsc.max = minMax[1];
                }
            }
        }
        let changed = {};
        let anyChanged = false;
        for(let k in wipScales){
            let wsc = wipScales[k];
            let sc = scales[k];
            if (sc.min != wsc.min || sc.max != wsc.max) {
                sc.min = wsc.min;
                sc.max = wsc.max;
                let distr = sc.distr;
                sc._min = distr == 3 ? $3cd00ee63e984772$var$log10(sc.min) : distr == 4 ? $3cd00ee63e984772$var$asinh(sc.min, sc.asinh) : distr == 100 ? sc.fwd(sc.min) : sc.min;
                sc._max = distr == 3 ? $3cd00ee63e984772$var$log10(sc.max) : distr == 4 ? $3cd00ee63e984772$var$asinh(sc.max, sc.asinh) : distr == 100 ? sc.fwd(sc.max) : sc.max;
                changed[k] = anyChanged = true;
            }
        }
        if (anyChanged) {
            // invalidate paths of all series on changed scales
            series.forEach((s, i)=>{
                if (mode == 2) {
                    if (i > 0 && changed.y) s._paths = null;
                } else if (changed[s.scale]) s._paths = null;
            });
            for(let k in changed){
                shouldConvergeSize = true;
                fire("setScale", k);
            }
            if (showCursor && cursor.left >= 0) shouldSetCursor = shouldSetLegend = true;
        }
        for(let k in pendScales)pendScales[k] = null;
    }
    // grabs the nearest indices with y data outside of x-scale limits
    function getOuterIdxs(ydata) {
        let _i0 = $3cd00ee63e984772$var$clamp(i0 - 1, 0, dataLen - 1);
        let _i1 = $3cd00ee63e984772$var$clamp(i1 + 1, 0, dataLen - 1);
        while(ydata[_i0] == null && _i0 > 0)_i0--;
        while(ydata[_i1] == null && _i1 < dataLen - 1)_i1++;
        return [
            _i0,
            _i1
        ];
    }
    function drawSeries() {
        if (dataLen > 0) {
            let shouldAlpha = series.some((s)=>s._focus) && ctxAlpha != focus.alpha;
            if (shouldAlpha) ctx.globalAlpha = ctxAlpha = focus.alpha;
            series.forEach((s, i)=>{
                if (i > 0 && s.show) {
                    cacheStrokeFill(i, false);
                    cacheStrokeFill(i, true);
                    if (s._paths == null) {
                        let _ctxAlpha = ctxAlpha;
                        if (ctxAlpha != s.alpha) ctx.globalAlpha = ctxAlpha = s.alpha;
                        let _idxs = mode == 2 ? [
                            0,
                            data[i][0].length - 1
                        ] : getOuterIdxs(data[i]);
                        s._paths = s.paths(self, i, _idxs[0], _idxs[1]);
                        if (ctxAlpha != _ctxAlpha) ctx.globalAlpha = ctxAlpha = _ctxAlpha;
                    }
                }
            });
            series.forEach((s, i)=>{
                if (i > 0 && s.show) {
                    let _ctxAlpha = ctxAlpha;
                    if (ctxAlpha != s.alpha) ctx.globalAlpha = ctxAlpha = s.alpha;
                    s._paths != null && drawPath(i, false);
                    {
                        let _gaps = s._paths != null ? s._paths.gaps : null;
                        let show = s.points.show(self, i, i0, i1, _gaps);
                        let idxs = s.points.filter(self, i, show, _gaps);
                        if (show || idxs) {
                            s.points._paths = s.points.paths(self, i, i0, i1, idxs);
                            drawPath(i, true);
                        }
                    }
                    if (ctxAlpha != _ctxAlpha) ctx.globalAlpha = ctxAlpha = _ctxAlpha;
                    fire("drawSeries", i);
                }
            });
            if (shouldAlpha) ctx.globalAlpha = ctxAlpha = 1;
        }
    }
    function cacheStrokeFill(si, _points) {
        let s = _points ? series[si].points : series[si];
        s._stroke = s.stroke(self, si);
        s._fill = s.fill(self, si);
    }
    function drawPath(si, _points) {
        let s = _points ? series[si].points : series[si];
        let { stroke: stroke, fill: fill, clip: gapsClip, flags: flags, _stroke: strokeStyle = s._stroke, _fill: fillStyle = s._fill, _width: width = s.width } = s._paths;
        width = $3cd00ee63e984772$var$roundDec(width * $3cd00ee63e984772$var$pxRatio, 3);
        let boundsClip = null;
        let offset = width % 2 / 2;
        if (_points && fillStyle == null) fillStyle = width > 0 ? "#fff" : strokeStyle;
        let _pxAlign = s.pxAlign == 1 && offset > 0;
        _pxAlign && ctx.translate(offset, offset);
        if (!_points) {
            let lft = plotLft - width / 2, top = plotTop - width / 2, wid = plotWid + width, hgt = plotHgt + width;
            boundsClip = new Path2D();
            boundsClip.rect(lft, top, wid, hgt);
        }
        // the points pathbuilder's gapsClip is its boundsClip, since points dont need gaps clipping, and bounds depend on point size
        if (_points) strokeFill(strokeStyle, width, s.dash, s.cap, fillStyle, stroke, fill, flags, gapsClip);
        else fillStroke(si, strokeStyle, width, s.dash, s.cap, fillStyle, stroke, fill, flags, boundsClip, gapsClip);
        _pxAlign && ctx.translate(-offset, -offset);
    }
    function fillStroke(si, strokeStyle, lineWidth, lineDash, lineCap, fillStyle, strokePath, fillPath, flags, boundsClip, gapsClip) {
        let didStrokeFill = false;
        // for all bands where this series is the top edge, create upwards clips using the bottom edges
        // and apply clips + fill with band fill or dfltFill
        flags != 0 && bands.forEach((b, bi)=>{
            // isUpperEdge?
            if (b.series[0] == si) {
                let lowerEdge = series[b.series[1]];
                let lowerData = data[b.series[1]];
                let bandClip = (lowerEdge._paths || $3cd00ee63e984772$var$EMPTY_OBJ).band;
                if ($3cd00ee63e984772$var$isArr(bandClip)) bandClip = b.dir == 1 ? bandClip[0] : bandClip[1];
                let gapsClip2;
                let _fillStyle = null;
                // hasLowerEdge?
                if (lowerEdge.show && bandClip && $3cd00ee63e984772$var$hasData(lowerData, i0, i1)) {
                    _fillStyle = b.fill(self, bi) || fillStyle;
                    gapsClip2 = lowerEdge._paths.clip;
                } else bandClip = null;
                strokeFill(strokeStyle, lineWidth, lineDash, lineCap, _fillStyle, strokePath, fillPath, flags, boundsClip, gapsClip, gapsClip2, bandClip);
                didStrokeFill = true;
            }
        });
        if (!didStrokeFill) strokeFill(strokeStyle, lineWidth, lineDash, lineCap, fillStyle, strokePath, fillPath, flags, boundsClip, gapsClip);
    }
    const CLIP_FILL_STROKE = $3cd00ee63e984772$var$BAND_CLIP_FILL | $3cd00ee63e984772$var$BAND_CLIP_STROKE;
    function strokeFill(strokeStyle, lineWidth, lineDash, lineCap, fillStyle, strokePath, fillPath, flags, boundsClip, gapsClip, gapsClip2, bandClip) {
        setCtxStyle(strokeStyle, lineWidth, lineDash, lineCap, fillStyle);
        if (boundsClip || gapsClip || bandClip) {
            ctx.save();
            boundsClip && ctx.clip(boundsClip);
            gapsClip && ctx.clip(gapsClip);
        }
        if (bandClip) {
            if ((flags & CLIP_FILL_STROKE) == CLIP_FILL_STROKE) {
                ctx.clip(bandClip);
                gapsClip2 && ctx.clip(gapsClip2);
                doFill(fillStyle, fillPath);
                doStroke(strokeStyle, strokePath, lineWidth);
            } else if (flags & $3cd00ee63e984772$var$BAND_CLIP_STROKE) {
                doFill(fillStyle, fillPath);
                ctx.clip(bandClip);
                doStroke(strokeStyle, strokePath, lineWidth);
            } else if (flags & $3cd00ee63e984772$var$BAND_CLIP_FILL) {
                ctx.save();
                ctx.clip(bandClip);
                gapsClip2 && ctx.clip(gapsClip2);
                doFill(fillStyle, fillPath);
                ctx.restore();
                doStroke(strokeStyle, strokePath, lineWidth);
            }
        } else {
            doFill(fillStyle, fillPath);
            doStroke(strokeStyle, strokePath, lineWidth);
        }
        if (boundsClip || gapsClip || bandClip) ctx.restore();
    }
    function doStroke(strokeStyle, strokePath, lineWidth) {
        if (lineWidth > 0) {
            if (strokePath instanceof Map) strokePath.forEach((strokePath, strokeStyle)=>{
                ctx.strokeStyle = ctxStroke = strokeStyle;
                ctx.stroke(strokePath);
            });
            else strokePath != null && strokeStyle && ctx.stroke(strokePath);
        }
    }
    function doFill(fillStyle, fillPath) {
        if (fillPath instanceof Map) fillPath.forEach((fillPath, fillStyle)=>{
            ctx.fillStyle = ctxFill = fillStyle;
            ctx.fill(fillPath);
        });
        else fillPath != null && fillStyle && ctx.fill(fillPath);
    }
    function getIncrSpace(axisIdx, min, max, fullDim) {
        let axis = axes[axisIdx];
        let incrSpace;
        if (fullDim <= 0) incrSpace = [
            0,
            0
        ];
        else {
            let minSpace = axis._space = axis.space(self, axisIdx, min, max, fullDim);
            let incrs = axis._incrs = axis.incrs(self, axisIdx, min, max, fullDim, minSpace);
            incrSpace = $3cd00ee63e984772$var$findIncr(min, max, incrs, fullDim, minSpace);
        }
        return axis._found = incrSpace;
    }
    function drawOrthoLines(offs, filts, ori, side, pos0, len, width, stroke, dash, cap) {
        let offset = width % 2 / 2;
        pxAlign == 1 && ctx.translate(offset, offset);
        setCtxStyle(stroke, width, dash, cap, stroke);
        ctx.beginPath();
        let x0, y0, x1, y1, pos1 = pos0 + (side == 0 || side == 3 ? -len : len);
        if (ori == 0) {
            y0 = pos0;
            y1 = pos1;
        } else {
            x0 = pos0;
            x1 = pos1;
        }
        for(let i = 0; i < offs.length; i++)if (filts[i] != null) {
            if (ori == 0) x0 = x1 = offs[i];
            else y0 = y1 = offs[i];
            ctx.moveTo(x0, y0);
            ctx.lineTo(x1, y1);
        }
        ctx.stroke();
        pxAlign == 1 && ctx.translate(-offset, -offset);
    }
    function axesCalc(cycleNum) {
        //	log("axesCalc()", arguments);
        let converged = true;
        axes.forEach((axis, i)=>{
            if (!axis.show) return;
            let scale = scales[axis.scale];
            if (scale.min == null) {
                if (axis._show) {
                    converged = false;
                    axis._show = false;
                    resetYSeries(false);
                }
                return;
            } else if (!axis._show) {
                converged = false;
                axis._show = true;
                resetYSeries(false);
            }
            let side = axis.side;
            let ori = side % 2;
            let { min: min, max: max } = scale; // 		// should this toggle them ._show = false
            let [_incr, _space] = getIncrSpace(i, min, max, ori == 0 ? plotWidCss : plotHgtCss);
            if (_space == 0) return;
            // if we're using index positions, force first tick to match passed index
            let forceMin = scale.distr == 2;
            let _splits = axis._splits = axis.splits(self, i, min, max, _incr, _space, forceMin);
            // tick labels
            // BOO this assumes a specific data/series
            let splits = scale.distr == 2 ? _splits.map((i)=>data0[i]) : _splits;
            let incr = scale.distr == 2 ? data0[_splits[1]] - data0[_splits[0]] : _incr;
            let values = axis._values = axis.values(self, axis.filter(self, splits, i, _space, incr), i, _space, incr);
            // rotating of labels only supported on bottom x axis
            axis._rotate = side == 2 ? axis.rotate(self, values, i, _space) : 0;
            let oldSize = axis._size;
            axis._size = $3cd00ee63e984772$var$ceil(axis.size(self, values, i, cycleNum));
            if (oldSize != null && axis._size != oldSize) converged = false;
        });
        return converged;
    }
    function paddingCalc(cycleNum) {
        let converged = true;
        padding.forEach((p, i)=>{
            let _p = p(self, i, sidesWithAxes, cycleNum);
            if (_p != _padding[i]) converged = false;
            _padding[i] = _p;
        });
        return converged;
    }
    function drawAxesGrid() {
        for(let i = 0; i < axes.length; i++){
            let axis = axes[i];
            if (!axis.show || !axis._show) continue;
            let side = axis.side;
            let ori = side % 2;
            let x, y;
            let fillStyle = axis.stroke(self, i);
            let shiftDir = side == 0 || side == 3 ? -1 : 1;
            let [_incr, _space] = axis._found;
            // axis label
            if (axis.label != null) {
                let shiftAmt = axis.labelGap * shiftDir;
                let baseLpos = $3cd00ee63e984772$var$round((axis._lpos + shiftAmt) * $3cd00ee63e984772$var$pxRatio);
                setFontStyle(axis.labelFont[0], fillStyle, "center", side == 2 ? $3cd00ee63e984772$var$TOP : $3cd00ee63e984772$var$BOTTOM);
                ctx.save();
                if (ori == 1) {
                    x = y = 0;
                    ctx.translate(baseLpos, $3cd00ee63e984772$var$round(plotTop + plotHgt / 2));
                    ctx.rotate((side == 3 ? -$3cd00ee63e984772$var$PI : $3cd00ee63e984772$var$PI) / 2);
                } else {
                    x = $3cd00ee63e984772$var$round(plotLft + plotWid / 2);
                    y = baseLpos;
                }
                let _label = $3cd00ee63e984772$var$isFn(axis.label) ? axis.label(self, i, _incr, _space) : axis.label;
                ctx.fillText(_label, x, y);
                ctx.restore();
            }
            if (_space == 0) continue;
            let scale = scales[axis.scale];
            let plotDim = ori == 0 ? plotWid : plotHgt;
            let plotOff = ori == 0 ? plotLft : plotTop;
            let _splits = axis._splits;
            // tick labels
            // BOO this assumes a specific data/series
            let splits = scale.distr == 2 ? _splits.map((i)=>data0[i]) : _splits;
            let incr = scale.distr == 2 ? data0[_splits[1]] - data0[_splits[0]] : _incr;
            let ticks = axis.ticks;
            let border = axis.border;
            let _tickSize = ticks.show ? ticks.size : 0;
            let tickSize = $3cd00ee63e984772$var$round(_tickSize * $3cd00ee63e984772$var$pxRatio);
            let axisGap = $3cd00ee63e984772$var$round((axis.alignTo == 2 ? axis._size - _tickSize - axis.gap : axis.gap) * $3cd00ee63e984772$var$pxRatio);
            // rotating of labels only supported on bottom x axis
            let angle = axis._rotate * -$3cd00ee63e984772$var$PI / 180;
            let basePos = pxRound(axis._pos * $3cd00ee63e984772$var$pxRatio);
            let shiftAmt = (tickSize + axisGap) * shiftDir;
            let finalPos = basePos + shiftAmt;
            y = ori == 0 ? finalPos : 0;
            x = ori == 1 ? finalPos : 0;
            let font = axis.font[0];
            let textAlign = axis.align == 1 ? $3cd00ee63e984772$var$LEFT : axis.align == 2 ? $3cd00ee63e984772$var$RIGHT : angle > 0 ? $3cd00ee63e984772$var$LEFT : angle < 0 ? $3cd00ee63e984772$var$RIGHT : ori == 0 ? "center" : side == 3 ? $3cd00ee63e984772$var$RIGHT : $3cd00ee63e984772$var$LEFT;
            let textBaseline = angle || ori == 1 ? "middle" : side == 2 ? $3cd00ee63e984772$var$TOP : $3cd00ee63e984772$var$BOTTOM;
            setFontStyle(font, fillStyle, textAlign, textBaseline);
            let lineHeight = axis.font[1] * axis.lineGap;
            let canOffs = _splits.map((val)=>pxRound(getPos(val, scale, plotDim, plotOff)));
            let _values = axis._values;
            for(let i = 0; i < _values.length; i++){
                let val = _values[i];
                if (val != null) {
                    if (ori == 0) x = canOffs[i];
                    else y = canOffs[i];
                    val = "" + val;
                    let _parts = val.indexOf("\n") == -1 ? [
                        val
                    ] : val.split(/\n/gm);
                    for(let j = 0; j < _parts.length; j++){
                        let text = _parts[j];
                        if (angle) {
                            ctx.save();
                            ctx.translate(x, y + j * lineHeight); // can this be replaced with position math?
                            ctx.rotate(angle); // can this be done once?
                            ctx.fillText(text, 0, 0);
                            ctx.restore();
                        } else ctx.fillText(text, x, y + j * lineHeight);
                    }
                }
            }
            // ticks
            if (ticks.show) drawOrthoLines(canOffs, ticks.filter(self, splits, i, _space, incr), ori, side, basePos, tickSize, $3cd00ee63e984772$var$roundDec(ticks.width * $3cd00ee63e984772$var$pxRatio, 3), ticks.stroke(self, i), ticks.dash, ticks.cap);
            // grid
            let grid = axis.grid;
            if (grid.show) drawOrthoLines(canOffs, grid.filter(self, splits, i, _space, incr), ori, ori == 0 ? 2 : 1, ori == 0 ? plotTop : plotLft, ori == 0 ? plotHgt : plotWid, $3cd00ee63e984772$var$roundDec(grid.width * $3cd00ee63e984772$var$pxRatio, 3), grid.stroke(self, i), grid.dash, grid.cap);
            if (border.show) drawOrthoLines([
                basePos
            ], [
                1
            ], ori == 0 ? 1 : 0, ori == 0 ? 1 : 2, ori == 1 ? plotTop : plotLft, ori == 1 ? plotHgt : plotWid, $3cd00ee63e984772$var$roundDec(border.width * $3cd00ee63e984772$var$pxRatio, 3), border.stroke(self, i), border.dash, border.cap);
        }
        fire("drawAxes");
    }
    function resetYSeries(minMax) {
        //	log("resetYSeries()", arguments);
        series.forEach((s, i)=>{
            if (i > 0) {
                s._paths = null;
                if (minMax) {
                    if (mode == 1) {
                        s.min = null;
                        s.max = null;
                    } else s.facets.forEach((f)=>{
                        f.min = null;
                        f.max = null;
                    });
                }
            }
        });
    }
    let queuedCommit = false;
    let deferHooks = false;
    let hooksQueue = [];
    function flushHooks() {
        deferHooks = false;
        for(let i = 0; i < hooksQueue.length; i++)fire(...hooksQueue[i]);
        hooksQueue.length = 0;
    }
    function commit() {
        if (!queuedCommit) {
            $3cd00ee63e984772$var$microTask(_commit);
            queuedCommit = true;
        }
    }
    // manual batching (aka immediate mode), skips microtask queue
    function batch(fn, _deferHooks = false) {
        queuedCommit = true;
        deferHooks = _deferHooks;
        fn(self);
        _commit();
        if (_deferHooks && hooksQueue.length > 0) queueMicrotask(flushHooks);
    }
    self.batch = batch;
    function _commit() {
        //	log("_commit()", arguments);
        if (shouldSetScales) {
            setScales();
            shouldSetScales = false;
        }
        if (shouldConvergeSize) {
            convergeSize();
            shouldConvergeSize = false;
        }
        if (shouldSetSize) {
            $3cd00ee63e984772$var$setStylePx(under, $3cd00ee63e984772$var$LEFT, plotLftCss);
            $3cd00ee63e984772$var$setStylePx(under, $3cd00ee63e984772$var$TOP, plotTopCss);
            $3cd00ee63e984772$var$setStylePx(under, $3cd00ee63e984772$var$WIDTH, plotWidCss);
            $3cd00ee63e984772$var$setStylePx(under, $3cd00ee63e984772$var$HEIGHT, plotHgtCss);
            $3cd00ee63e984772$var$setStylePx(over, $3cd00ee63e984772$var$LEFT, plotLftCss);
            $3cd00ee63e984772$var$setStylePx(over, $3cd00ee63e984772$var$TOP, plotTopCss);
            $3cd00ee63e984772$var$setStylePx(over, $3cd00ee63e984772$var$WIDTH, plotWidCss);
            $3cd00ee63e984772$var$setStylePx(over, $3cd00ee63e984772$var$HEIGHT, plotHgtCss);
            $3cd00ee63e984772$var$setStylePx(wrap, $3cd00ee63e984772$var$WIDTH, fullWidCss);
            $3cd00ee63e984772$var$setStylePx(wrap, $3cd00ee63e984772$var$HEIGHT, fullHgtCss);
            // NOTE: mutating this during print preview in Chrome forces transparent
            // canvas pixels to white, even when followed up with clearRect() below
            can.width = $3cd00ee63e984772$var$round(fullWidCss * $3cd00ee63e984772$var$pxRatio);
            can.height = $3cd00ee63e984772$var$round(fullHgtCss * $3cd00ee63e984772$var$pxRatio);
            axes.forEach(({ _el: _el, _show: _show, _size: _size, _pos: _pos, side: side })=>{
                if (_el != null) {
                    if (_show) {
                        let posOffset = side === 3 || side === 0 ? _size : 0;
                        let isVt = side % 2 == 1;
                        $3cd00ee63e984772$var$setStylePx(_el, isVt ? "left" : "top", _pos - posOffset);
                        $3cd00ee63e984772$var$setStylePx(_el, isVt ? "width" : "height", _size);
                        $3cd00ee63e984772$var$setStylePx(_el, isVt ? "top" : "left", isVt ? plotTopCss : plotLftCss);
                        $3cd00ee63e984772$var$setStylePx(_el, isVt ? "height" : "width", isVt ? plotHgtCss : plotWidCss);
                        $3cd00ee63e984772$var$remClass(_el, $3cd00ee63e984772$var$OFF);
                    } else $3cd00ee63e984772$var$addClass(_el, $3cd00ee63e984772$var$OFF);
                }
            });
            // invalidate ctx style cache
            ctxStroke = ctxFill = ctxWidth = ctxJoin = ctxCap = ctxFont = ctxAlign = ctxBaseline = ctxDash = null;
            ctxAlpha = 1;
            syncRect(true);
            if (plotLftCss != _plotLftCss || plotTopCss != _plotTopCss || plotWidCss != _plotWidCss || plotHgtCss != _plotHgtCss) {
                resetYSeries(false);
                let pctWid = plotWidCss / _plotWidCss;
                let pctHgt = plotHgtCss / _plotHgtCss;
                if (showCursor && !shouldSetCursor && cursor.left >= 0) {
                    cursor.left *= pctWid;
                    cursor.top *= pctHgt;
                    vCursor && $3cd00ee63e984772$var$elTrans(vCursor, $3cd00ee63e984772$var$round(cursor.left), 0, plotWidCss, plotHgtCss);
                    hCursor && $3cd00ee63e984772$var$elTrans(hCursor, 0, $3cd00ee63e984772$var$round(cursor.top), plotWidCss, plotHgtCss);
                    for(let i = 0; i < cursorPts.length; i++){
                        let pt = cursorPts[i];
                        if (pt != null) {
                            cursorPtsLft[i] *= pctWid;
                            cursorPtsTop[i] *= pctHgt;
                            $3cd00ee63e984772$var$elTrans(pt, $3cd00ee63e984772$var$ceil(cursorPtsLft[i]), $3cd00ee63e984772$var$ceil(cursorPtsTop[i]), plotWidCss, plotHgtCss);
                        }
                    }
                }
                if (select.show && !shouldSetSelect && select.left >= 0 && select.width > 0) {
                    select.left *= pctWid;
                    select.width *= pctWid;
                    select.top *= pctHgt;
                    select.height *= pctHgt;
                    for(let prop in _hideProps)$3cd00ee63e984772$var$setStylePx(selectDiv, prop, select[prop]);
                }
                _plotLftCss = plotLftCss;
                _plotTopCss = plotTopCss;
                _plotWidCss = plotWidCss;
                _plotHgtCss = plotHgtCss;
            }
            fire("setSize");
            shouldSetSize = false;
        }
        if (fullWidCss > 0 && fullHgtCss > 0) {
            ctx.clearRect(0, 0, can.width, can.height);
            fire("drawClear");
            drawOrder.forEach((fn)=>fn());
            fire("draw");
        }
        if (select.show && shouldSetSelect) {
            setSelect(select);
            shouldSetSelect = false;
        }
        if (showCursor && shouldSetCursor) {
            updateCursor(null, true, false);
            shouldSetCursor = false;
        }
        if (legend.show && legend.live && shouldSetLegend) {
            setLegend();
            shouldSetLegend = false; // redundant currently
        }
        if (!ready) {
            ready = true;
            self.status = 1;
            fire("ready");
        }
        viaAutoScaleX = false;
        queuedCommit = false;
    }
    self.redraw = (rebuildPaths, recalcAxes)=>{
        shouldConvergeSize = recalcAxes || false;
        if (rebuildPaths !== false) _setScale(xScaleKey, scaleX.min, scaleX.max);
        else commit();
    };
    // redraw() => setScale('x', scales.x.min, scales.x.max);
    // explicit, never re-ranged (is this actually true? for x and y)
    function setScale(key, opts) {
        let sc = scales[key];
        if (sc.from == null) {
            if (dataLen == 0) {
                let minMax = sc.range(self, opts.min, opts.max, key);
                opts.min = minMax[0];
                opts.max = minMax[1];
            }
            if (opts.min > opts.max) {
                let _min = opts.min;
                opts.min = opts.max;
                opts.max = _min;
            }
            if (dataLen > 1 && opts.min != null && opts.max != null && opts.max - opts.min < 1e-16) return;
            if (key == xScaleKey) {
                if (sc.distr == 2 && dataLen > 0) {
                    opts.min = $3cd00ee63e984772$var$closestIdx(opts.min, data[0]);
                    opts.max = $3cd00ee63e984772$var$closestIdx(opts.max, data[0]);
                    if (opts.min == opts.max) opts.max++;
                }
            }
            //	log("setScale()", arguments);
            pendScales[key] = opts;
            shouldSetScales = true;
            commit();
        }
    }
    self.setScale = setScale;
    //	INTERACTION
    let xCursor;
    let yCursor;
    let vCursor;
    let hCursor;
    // starting position before cursor.move
    let rawMouseLeft0;
    let rawMouseTop0;
    // starting position
    let mouseLeft0;
    let mouseTop0;
    // current position before cursor.move
    let rawMouseLeft1;
    let rawMouseTop1;
    // current position
    let mouseLeft1;
    let mouseTop1;
    let dragging = false;
    const drag = cursor.drag;
    let dragX = drag.x;
    let dragY = drag.y;
    if (showCursor) {
        if (cursor.x) xCursor = $3cd00ee63e984772$var$placeDiv($3cd00ee63e984772$var$CURSOR_X, over);
        if (cursor.y) yCursor = $3cd00ee63e984772$var$placeDiv($3cd00ee63e984772$var$CURSOR_Y, over);
        if (scaleX.ori == 0) {
            vCursor = xCursor;
            hCursor = yCursor;
        } else {
            vCursor = yCursor;
            hCursor = xCursor;
        }
        mouseLeft1 = cursor.left;
        mouseTop1 = cursor.top;
    }
    const select = self.select = $3cd00ee63e984772$var$assign({
        show: true,
        over: true,
        left: 0,
        width: 0,
        top: 0,
        height: 0
    }, opts.select);
    const selectDiv = select.show ? $3cd00ee63e984772$var$placeDiv($3cd00ee63e984772$var$SELECT, select.over ? over : under) : null;
    function setSelect(opts, _fire) {
        if (select.show) {
            for(let prop in opts){
                select[prop] = opts[prop];
                if (prop in _hideProps) $3cd00ee63e984772$var$setStylePx(selectDiv, prop, opts[prop]);
            }
            _fire !== false && fire("setSelect");
        }
    }
    self.setSelect = setSelect;
    function toggleDOM(i) {
        let s = series[i];
        if (s.show) showLegend && $3cd00ee63e984772$var$remClass(legendRows[i], $3cd00ee63e984772$var$OFF);
        else {
            showLegend && $3cd00ee63e984772$var$addClass(legendRows[i], $3cd00ee63e984772$var$OFF);
            if (showCursor) {
                let pt = cursorOnePt ? cursorPts[0] : cursorPts[i];
                pt != null && $3cd00ee63e984772$var$elTrans(pt, -10, -10, plotWidCss, plotHgtCss);
            }
        }
    }
    function _setScale(key, min, max) {
        setScale(key, {
            min: min,
            max: max
        });
    }
    function setSeries(i, opts, _fire, _pub) {
        //	log("setSeries()", arguments);
        if (opts.focus != null) setFocus(i);
        if (opts.show != null) series.forEach((s, si)=>{
            if (si > 0 && (i == si || i == null)) {
                s.show = opts.show;
                toggleDOM(si);
                if (mode == 2) {
                    _setScale(s.facets[0].scale, null, null);
                    _setScale(s.facets[1].scale, null, null);
                } else _setScale(s.scale, null, null);
                commit();
            }
        });
        _fire !== false && fire("setSeries", i, opts);
        _pub && pubSync("setSeries", self, i, opts);
    }
    self.setSeries = setSeries;
    function setBand(bi, opts) {
        $3cd00ee63e984772$var$assign(bands[bi], opts);
    }
    function addBand(opts, bi) {
        opts.fill = $3cd00ee63e984772$var$fnOrSelf(opts.fill || null);
        opts.dir = $3cd00ee63e984772$var$ifNull(opts.dir, -1);
        bi = bi == null ? bands.length : bi;
        bands.splice(bi, 0, opts);
    }
    function delBand(bi) {
        if (bi == null) bands.length = 0;
        else bands.splice(bi, 1);
    }
    self.addBand = addBand;
    self.setBand = setBand;
    self.delBand = delBand;
    function setAlpha(i, value) {
        series[i].alpha = value;
        if (showCursor && cursorPts[i] != null) cursorPts[i].style.opacity = value;
        if (showLegend && legendRows[i]) legendRows[i].style.opacity = value;
    }
    // y-distance
    let closestDist;
    let closestSeries;
    let focusedSeries;
    const FOCUS_TRUE = {
        focus: true
    };
    function setFocus(i) {
        if (i != focusedSeries) {
            //	log("setFocus()", arguments);
            let allFocused = i == null;
            let _setAlpha = focus.alpha != 1;
            series.forEach((s, i2)=>{
                if (mode == 1 || i2 > 0) {
                    let isFocused = allFocused || i2 == 0 || i2 == i;
                    s._focus = allFocused ? null : isFocused;
                    _setAlpha && setAlpha(i2, isFocused ? 1 : focus.alpha);
                }
            });
            focusedSeries = i;
            _setAlpha && commit();
        }
    }
    if (showLegend && cursorFocus) onMouse($3cd00ee63e984772$var$mouseleave, legendTable, (e)=>{
        if (cursor._lock) return;
        setCursorEvent(e);
        if (focusedSeries != null) setSeries(null, FOCUS_TRUE, true, syncOpts.setSeries);
    });
    function posToVal(pos, scale, can) {
        let sc = scales[scale];
        if (can) pos = pos / $3cd00ee63e984772$var$pxRatio - (sc.ori == 1 ? plotTopCss : plotLftCss);
        let dim = plotWidCss;
        if (sc.ori == 1) {
            dim = plotHgtCss;
            pos = dim - pos;
        }
        if (sc.dir == -1) pos = dim - pos;
        let _min = sc._min, _max = sc._max, pct = pos / dim;
        let sv = _min + (_max - _min) * pct;
        let distr = sc.distr;
        return distr == 3 ? $3cd00ee63e984772$var$pow(10, sv) : distr == 4 ? $3cd00ee63e984772$var$sinh(sv, sc.asinh) : distr == 100 ? sc.bwd(sv) : sv;
    }
    function closestIdxFromXpos(pos, can) {
        let v = posToVal(pos, xScaleKey, can);
        return $3cd00ee63e984772$var$closestIdx(v, data[0], i0, i1);
    }
    self.valToIdx = (val)=>$3cd00ee63e984772$var$closestIdx(val, data[0]);
    self.posToIdx = closestIdxFromXpos;
    self.posToVal = posToVal;
    self.valToPos = (val, scale, can)=>scales[scale].ori == 0 ? getHPos(val, scales[scale], can ? plotWid : plotWidCss, can ? plotLft : 0) : getVPos(val, scales[scale], can ? plotHgt : plotHgtCss, can ? plotTop : 0);
    self.setCursor = (opts, _fire, _pub)=>{
        mouseLeft1 = opts.left;
        mouseTop1 = opts.top;
        //	assign(cursor, opts);
        updateCursor(null, _fire, _pub);
    };
    function setSelH(off, dim) {
        $3cd00ee63e984772$var$setStylePx(selectDiv, $3cd00ee63e984772$var$LEFT, select.left = off);
        $3cd00ee63e984772$var$setStylePx(selectDiv, $3cd00ee63e984772$var$WIDTH, select.width = dim);
    }
    function setSelV(off, dim) {
        $3cd00ee63e984772$var$setStylePx(selectDiv, $3cd00ee63e984772$var$TOP, select.top = off);
        $3cd00ee63e984772$var$setStylePx(selectDiv, $3cd00ee63e984772$var$HEIGHT, select.height = dim);
    }
    let setSelX = scaleX.ori == 0 ? setSelH : setSelV;
    let setSelY = scaleX.ori == 1 ? setSelH : setSelV;
    function syncLegend() {
        if (showLegend && legend.live) for(let i = mode == 2 ? 1 : 0; i < series.length; i++){
            if (i == 0 && multiValLegend) continue;
            let vals = legend.values[i];
            let j = 0;
            for(let k in vals)legendCells[i][j++].firstChild.nodeValue = vals[k];
        }
    }
    function setLegend(opts, _fire) {
        if (opts != null) {
            if (opts.idxs) opts.idxs.forEach((didx, sidx)=>{
                activeIdxs[sidx] = didx;
            });
            else if (!$3cd00ee63e984772$var$isUndef(opts.idx)) activeIdxs.fill(opts.idx);
            legend.idx = activeIdxs[0];
        }
        if (showLegend && legend.live) {
            for(let sidx = 0; sidx < series.length; sidx++)if (sidx > 0 || mode == 1 && !multiValLegend) setLegendValues(sidx, activeIdxs[sidx]);
            syncLegend();
        }
        shouldSetLegend = false;
        _fire !== false && fire("setLegend");
    }
    self.setLegend = setLegend;
    function setLegendValues(sidx, idx) {
        let s = series[sidx];
        let src = sidx == 0 && xScaleDistr == 2 ? data0 : data[sidx];
        let val;
        if (multiValLegend) val = s.values(self, sidx, idx) ?? NULL_LEGEND_VALUES;
        else {
            val = s.value(self, idx == null ? null : src[idx], sidx, idx);
            val = val == null ? NULL_LEGEND_VALUES : {
                _: val
            };
        }
        legend.values[sidx] = val;
    }
    function updateCursor(src, _fire, _pub) {
        //	ts == null && log("updateCursor()", arguments);
        rawMouseLeft1 = mouseLeft1;
        rawMouseTop1 = mouseTop1;
        [mouseLeft1, mouseTop1] = cursor.move(self, mouseLeft1, mouseTop1);
        cursor.left = mouseLeft1;
        cursor.top = mouseTop1;
        if (showCursor) {
            vCursor && $3cd00ee63e984772$var$elTrans(vCursor, $3cd00ee63e984772$var$round(mouseLeft1), 0, plotWidCss, plotHgtCss);
            hCursor && $3cd00ee63e984772$var$elTrans(hCursor, 0, $3cd00ee63e984772$var$round(mouseTop1), plotWidCss, plotHgtCss);
        }
        let idx;
        // when zooming to an x scale range between datapoints the binary search
        // for nearest min/max indices results in this condition. cheap hack :D
        let noDataInRange = i0 > i1; // works for mode 1 only
        closestDist = $3cd00ee63e984772$var$inf;
        closestSeries = null;
        // TODO: extract
        let xDim = scaleX.ori == 0 ? plotWidCss : plotHgtCss;
        let yDim = scaleX.ori == 1 ? plotWidCss : plotHgtCss;
        // if cursor hidden, hide points & clear legend vals
        if (mouseLeft1 < 0 || dataLen == 0 || noDataInRange) {
            idx = cursor.idx = null;
            for(let i = 0; i < series.length; i++){
                let pt = cursorPts[i];
                pt != null && $3cd00ee63e984772$var$elTrans(pt, -10, -10, plotWidCss, plotHgtCss);
            }
            if (cursorFocus) setSeries(null, FOCUS_TRUE, true, src == null && syncOpts.setSeries);
            if (legend.live) {
                activeIdxs.fill(idx);
                shouldSetLegend = true;
            }
        } else {
            //	let pctY = 1 - (y / rect.height);
            let mouseXPos, valAtPosX, xPos;
            if (mode == 1) {
                mouseXPos = scaleX.ori == 0 ? mouseLeft1 : mouseTop1;
                valAtPosX = posToVal(mouseXPos, xScaleKey);
                idx = cursor.idx = $3cd00ee63e984772$var$closestIdx(valAtPosX, data[0], i0, i1);
                xPos = valToPosX(data[0][idx], scaleX, xDim, 0);
            }
            // closest pt values
            let _ptLft = -10;
            let _ptTop = -10;
            let _ptWid = 0;
            let _ptHgt = 0;
            let _centered = true;
            let _ptFill = '';
            let _ptStroke = '';
            for(let i = mode == 2 ? 1 : 0; i < series.length; i++){
                let s = series[i];
                let idx1 = activeIdxs[i];
                let yVal1 = idx1 == null ? null : mode == 1 ? data[i][idx1] : data[i][1][idx1];
                let idx2 = cursor.dataIdx(self, i, idx, valAtPosX);
                let yVal2 = idx2 == null ? null : mode == 1 ? data[i][idx2] : data[i][1][idx2];
                shouldSetLegend = shouldSetLegend || yVal2 != yVal1 || idx2 != idx1;
                activeIdxs[i] = idx2;
                if (i > 0 && s.show) {
                    let xPos2 = idx2 == null ? -10 : idx2 == idx ? xPos : valToPosX(mode == 1 ? data[0][idx2] : data[i][0][idx2], scaleX, xDim, 0);
                    // this doesnt really work for state timeline, heatmap, status history (where the value maps to color, not y coords)
                    let yPos = yVal2 == null ? -10 : valToPosY(yVal2, mode == 1 ? scales[s.scale] : scales[s.facets[1].scale], yDim, 0);
                    if (cursorFocus && yVal2 != null) {
                        let mouseYPos = scaleX.ori == 1 ? mouseLeft1 : mouseTop1;
                        let dist = $3cd00ee63e984772$var$abs(focus.dist(self, i, idx2, yPos, mouseYPos));
                        if (dist < closestDist) {
                            let bias = focus.bias;
                            if (bias != 0) {
                                let mouseYVal = posToVal(mouseYPos, s.scale);
                                let seriesYValSign = yVal2 >= 0 ? 1 : -1;
                                let mouseYValSign = mouseYVal >= 0 ? 1 : -1;
                                // with a focus bias, we will never cross zero when prox testing
                                // it's either closest towards zero, or closest away from zero
                                if (mouseYValSign == seriesYValSign && (mouseYValSign == 1 ? bias == 1 ? yVal2 >= mouseYVal : yVal2 <= mouseYVal : bias == 1 ? yVal2 <= mouseYVal : yVal2 >= mouseYVal //  < 0
                                )) {
                                    closestDist = dist;
                                    closestSeries = i;
                                }
                            } else {
                                closestDist = dist;
                                closestSeries = i;
                            }
                        }
                    }
                    if (shouldSetLegend || cursorOnePt) {
                        let hPos, vPos;
                        if (scaleX.ori == 0) {
                            hPos = xPos2;
                            vPos = yPos;
                        } else {
                            hPos = yPos;
                            vPos = xPos2;
                        }
                        let ptWid, ptHgt, ptLft, ptTop, ptStroke, ptFill, centered = true, getBBox = points.bbox;
                        if (getBBox != null) {
                            centered = false;
                            let bbox = getBBox(self, i);
                            ptLft = bbox.left;
                            ptTop = bbox.top;
                            ptWid = bbox.width;
                            ptHgt = bbox.height;
                        } else {
                            ptLft = hPos;
                            ptTop = vPos;
                            ptWid = ptHgt = points.size(self, i);
                        }
                        ptFill = points.fill(self, i);
                        ptStroke = points.stroke(self, i);
                        if (cursorOnePt) {
                            if (i == closestSeries && closestDist <= focus.prox) {
                                _ptLft = ptLft;
                                _ptTop = ptTop;
                                _ptWid = ptWid;
                                _ptHgt = ptHgt;
                                _centered = centered;
                                _ptFill = ptFill;
                                _ptStroke = ptStroke;
                            }
                        } else {
                            let pt = cursorPts[i];
                            if (pt != null) {
                                cursorPtsLft[i] = ptLft;
                                cursorPtsTop[i] = ptTop;
                                $3cd00ee63e984772$var$elSize(pt, ptWid, ptHgt, centered);
                                $3cd00ee63e984772$var$elColor(pt, ptFill, ptStroke);
                                $3cd00ee63e984772$var$elTrans(pt, $3cd00ee63e984772$var$ceil(ptLft), $3cd00ee63e984772$var$ceil(ptTop), plotWidCss, plotHgtCss);
                            }
                        }
                    }
                }
            }
            // if only using single hover point (at cursorPts[0])
            // we have trigger styling at last visible series (once closestSeries is settled)
            if (cursorOnePt) {
                // some of this logic is similar to series focus below, since it matches the behavior by design
                let p = focus.prox;
                let focusChanged = focusedSeries == null ? closestDist <= p : closestDist > p || closestSeries != focusedSeries;
                if (shouldSetLegend || focusChanged) {
                    let pt = cursorPts[0];
                    if (pt != null) {
                        cursorPtsLft[0] = _ptLft;
                        cursorPtsTop[0] = _ptTop;
                        $3cd00ee63e984772$var$elSize(pt, _ptWid, _ptHgt, _centered);
                        $3cd00ee63e984772$var$elColor(pt, _ptFill, _ptStroke);
                        $3cd00ee63e984772$var$elTrans(pt, $3cd00ee63e984772$var$ceil(_ptLft), $3cd00ee63e984772$var$ceil(_ptTop), plotWidCss, plotHgtCss);
                    }
                }
            }
        }
        // nit: cursor.drag.setSelect is assumed always true
        if (select.show && dragging) {
            if (src != null) {
                let [xKey, yKey] = syncOpts.scales;
                let [matchXKeys, matchYKeys] = syncOpts.match;
                let [xKeySrc, yKeySrc] = src.cursor.sync.scales;
                // match the dragX/dragY implicitness/explicitness of src
                let sdrag = src.cursor.drag;
                dragX = sdrag._x;
                dragY = sdrag._y;
                if (dragX || dragY) {
                    let { left: left, top: top, width: width, height: height } = src.select;
                    let sori = src.scales[xKeySrc].ori;
                    let sPosToVal = src.posToVal;
                    let sOff, sDim, sc, a, b;
                    let matchingX = xKey != null && matchXKeys(xKey, xKeySrc);
                    let matchingY = yKey != null && matchYKeys(yKey, yKeySrc);
                    if (matchingX && dragX) {
                        if (sori == 0) {
                            sOff = left;
                            sDim = width;
                        } else {
                            sOff = top;
                            sDim = height;
                        }
                        sc = scales[xKey];
                        a = valToPosX(sPosToVal(sOff, xKeySrc), sc, xDim, 0);
                        b = valToPosX(sPosToVal(sOff + sDim, xKeySrc), sc, xDim, 0);
                        setSelX($3cd00ee63e984772$var$min(a, b), $3cd00ee63e984772$var$abs(b - a));
                    } else setSelX(0, xDim);
                    if (matchingY && dragY) {
                        if (sori == 1) {
                            sOff = left;
                            sDim = width;
                        } else {
                            sOff = top;
                            sDim = height;
                        }
                        sc = scales[yKey];
                        a = valToPosY(sPosToVal(sOff, yKeySrc), sc, yDim, 0);
                        b = valToPosY(sPosToVal(sOff + sDim, yKeySrc), sc, yDim, 0);
                        setSelY($3cd00ee63e984772$var$min(a, b), $3cd00ee63e984772$var$abs(b - a));
                    } else setSelY(0, yDim);
                } else hideSelect();
            } else {
                let rawDX = $3cd00ee63e984772$var$abs(rawMouseLeft1 - rawMouseLeft0);
                let rawDY = $3cd00ee63e984772$var$abs(rawMouseTop1 - rawMouseTop0);
                if (scaleX.ori == 1) {
                    let _rawDX = rawDX;
                    rawDX = rawDY;
                    rawDY = _rawDX;
                }
                dragX = drag.x && rawDX >= drag.dist;
                dragY = drag.y && rawDY >= drag.dist;
                let uni = drag.uni;
                if (uni != null) // only calc drag status if they pass the dist thresh
                {
                    if (dragX && dragY) {
                        dragX = rawDX >= uni;
                        dragY = rawDY >= uni;
                        // force unidirectionality when both are under uni limit
                        if (!dragX && !dragY) {
                            if (rawDY > rawDX) dragY = true;
                            else dragX = true;
                        }
                    }
                } else if (drag.x && drag.y && (dragX || dragY)) // if omni with no uni then both dragX / dragY should be true if either is true
                dragX = dragY = true;
                let p0, p1;
                if (dragX) {
                    if (scaleX.ori == 0) {
                        p0 = mouseLeft0;
                        p1 = mouseLeft1;
                    } else {
                        p0 = mouseTop0;
                        p1 = mouseTop1;
                    }
                    setSelX($3cd00ee63e984772$var$min(p0, p1), $3cd00ee63e984772$var$abs(p1 - p0));
                    if (!dragY) setSelY(0, yDim);
                }
                if (dragY) {
                    if (scaleX.ori == 1) {
                        p0 = mouseLeft0;
                        p1 = mouseLeft1;
                    } else {
                        p0 = mouseTop0;
                        p1 = mouseTop1;
                    }
                    setSelY($3cd00ee63e984772$var$min(p0, p1), $3cd00ee63e984772$var$abs(p1 - p0));
                    if (!dragX) setSelX(0, xDim);
                }
                // the drag didn't pass the dist requirement
                if (!dragX && !dragY) {
                    setSelX(0, 0);
                    setSelY(0, 0);
                }
            }
        }
        drag._x = dragX;
        drag._y = dragY;
        if (src == null) {
            if (_pub) {
                if (syncKey != null) {
                    let [xSyncKey, ySyncKey] = syncOpts.scales;
                    syncOpts.values[0] = xSyncKey != null ? posToVal(scaleX.ori == 0 ? mouseLeft1 : mouseTop1, xSyncKey) : null;
                    syncOpts.values[1] = ySyncKey != null ? posToVal(scaleX.ori == 1 ? mouseLeft1 : mouseTop1, ySyncKey) : null;
                }
                pubSync($3cd00ee63e984772$var$mousemove, self, mouseLeft1, mouseTop1, plotWidCss, plotHgtCss, idx);
            }
            if (cursorFocus) {
                let shouldPub = _pub && syncOpts.setSeries;
                let p = focus.prox;
                if (focusedSeries == null) {
                    if (closestDist <= p) setSeries(closestSeries, FOCUS_TRUE, true, shouldPub);
                } else {
                    if (closestDist > p) setSeries(null, FOCUS_TRUE, true, shouldPub);
                    else if (closestSeries != focusedSeries) setSeries(closestSeries, FOCUS_TRUE, true, shouldPub);
                }
            }
        }
        if (shouldSetLegend) {
            legend.idx = idx;
            setLegend();
        }
        _fire !== false && fire("setCursor");
    }
    let rect = null;
    Object.defineProperty(self, 'rect', {
        get () {
            if (rect == null) syncRect(false);
            return rect;
        }
    });
    function syncRect(defer = false) {
        if (defer) rect = null;
        else {
            rect = over.getBoundingClientRect();
            fire("syncRect", rect);
        }
    }
    function mouseMove(e, src, _l, _t, _w, _h, _i) {
        if (cursor._lock) return;
        // Chrome on Windows has a bug which triggers a stray mousemove event after an initial mousedown event
        // when clicking into a plot as part of re-focusing the browser window.
        // we gotta ignore it to avoid triggering a phantom drag / setSelect
        // However, on touch-only devices Chrome-based browsers trigger a 0-distance mousemove before mousedown
        // so we don't ignore it when mousedown has set the dragging flag
        if (dragging && e != null && e.movementX == 0 && e.movementY == 0) return;
        cacheMouse(e, src, _l, _t, _w, _h, _i, false, e != null);
        if (e != null) updateCursor(null, true, true);
        else updateCursor(src, true, false);
    }
    function cacheMouse(e, src, _l, _t, _w, _h, _i, initial, snap) {
        if (rect == null) syncRect(false);
        setCursorEvent(e);
        if (e != null) {
            _l = e.clientX - rect.left;
            _t = e.clientY - rect.top;
        } else {
            if (_l < 0 || _t < 0) {
                mouseLeft1 = -10;
                mouseTop1 = -10;
                return;
            }
            let [xKey, yKey] = syncOpts.scales;
            let syncOptsSrc = src.cursor.sync;
            let [xValSrc, yValSrc] = syncOptsSrc.values;
            let [xKeySrc, yKeySrc] = syncOptsSrc.scales;
            let [matchXKeys, matchYKeys] = syncOpts.match;
            let rotSrc = src.axes[0].side % 2 == 1;
            let xDim = scaleX.ori == 0 ? plotWidCss : plotHgtCss, yDim = scaleX.ori == 1 ? plotWidCss : plotHgtCss, _xDim = rotSrc ? _h : _w, _yDim = rotSrc ? _w : _h, _xPos = rotSrc ? _t : _l, _yPos = rotSrc ? _l : _t;
            if (xKeySrc != null) _l = matchXKeys(xKey, xKeySrc) ? getPos(xValSrc, scales[xKey], xDim, 0) : -10;
            else _l = xDim * (_xPos / _xDim);
            if (yKeySrc != null) _t = matchYKeys(yKey, yKeySrc) ? getPos(yValSrc, scales[yKey], yDim, 0) : -10;
            else _t = yDim * (_yPos / _yDim);
            if (scaleX.ori == 1) {
                let __l = _l;
                _l = _t;
                _t = __l;
            }
        }
        if (snap && (src == null || src.cursor.event.type == $3cd00ee63e984772$var$mousemove)) {
            if (_l <= 1 || _l >= plotWidCss - 1) _l = $3cd00ee63e984772$var$incrRound(_l, plotWidCss);
            if (_t <= 1 || _t >= plotHgtCss - 1) _t = $3cd00ee63e984772$var$incrRound(_t, plotHgtCss);
        }
        if (initial) {
            rawMouseLeft0 = _l;
            rawMouseTop0 = _t;
            [mouseLeft0, mouseTop0] = cursor.move(self, _l, _t);
        } else {
            mouseLeft1 = _l;
            mouseTop1 = _t;
        }
    }
    const _hideProps = {
        width: 0,
        height: 0,
        left: 0,
        top: 0
    };
    function hideSelect() {
        setSelect(_hideProps, false);
    }
    let downSelectLeft;
    let downSelectTop;
    let downSelectWidth;
    let downSelectHeight;
    function mouseDown(e, src, _l, _t, _w, _h, _i) {
        dragging = true;
        dragX = dragY = drag._x = drag._y = false;
        cacheMouse(e, src, _l, _t, _w, _h, _i, true, false);
        if (e != null) {
            onMouse($3cd00ee63e984772$var$mouseup, $3cd00ee63e984772$var$doc, mouseUp, false);
            pubSync($3cd00ee63e984772$var$mousedown, self, mouseLeft0, mouseTop0, plotWidCss, plotHgtCss, null);
        }
        let { left: left, top: top, width: width, height: height } = select;
        downSelectLeft = left;
        downSelectTop = top;
        downSelectWidth = width;
        downSelectHeight = height;
    //	hideSelect();
    }
    function mouseUp(e, src, _l, _t, _w, _h, _i) {
        dragging = drag._x = drag._y = false;
        cacheMouse(e, src, _l, _t, _w, _h, _i, false, true);
        let { left: left, top: top, width: width, height: height } = select;
        let hasSelect = width > 0 || height > 0;
        let chgSelect = downSelectLeft != left || downSelectTop != top || downSelectWidth != width || downSelectHeight != height;
        hasSelect && chgSelect && setSelect(select);
        if (drag.setScale && hasSelect && chgSelect) {
            //	if (syncKey != null) {
            //		dragX = drag.x;
            //		dragY = drag.y;
            //	}
            let xOff = left, xDim = width, yOff = top, yDim = height;
            if (scaleX.ori == 1) xOff = top, xDim = height, yOff = left, yDim = width;
            if (dragX) _setScale(xScaleKey, posToVal(xOff, xScaleKey), posToVal(xOff + xDim, xScaleKey));
            if (dragY) for(let k in scales){
                let sc = scales[k];
                if (k != xScaleKey && sc.from == null && sc.min != $3cd00ee63e984772$var$inf) _setScale(k, posToVal(yOff + yDim, k), posToVal(yOff, k));
            }
            hideSelect();
        } else if (cursor.lock) {
            cursor._lock = !cursor._lock;
            updateCursor(src, true, e != null);
        }
        if (e != null) {
            offMouse($3cd00ee63e984772$var$mouseup, $3cd00ee63e984772$var$doc);
            pubSync($3cd00ee63e984772$var$mouseup, self, mouseLeft1, mouseTop1, plotWidCss, plotHgtCss, null);
        }
    }
    function mouseLeave(e, src, _l, _t, _w, _h, _i) {
        if (cursor._lock) return;
        setCursorEvent(e);
        let _dragging = dragging;
        if (dragging) {
            // handle case when mousemove aren't fired all the way to edges by browser
            let snapH = true;
            let snapV = true;
            let snapProx = 10;
            let dragH, dragV;
            if (scaleX.ori == 0) {
                dragH = dragX;
                dragV = dragY;
            } else {
                dragH = dragY;
                dragV = dragX;
            }
            if (dragH && dragV) {
                // maybe omni corner snap
                snapH = mouseLeft1 <= snapProx || mouseLeft1 >= plotWidCss - snapProx;
                snapV = mouseTop1 <= snapProx || mouseTop1 >= plotHgtCss - snapProx;
            }
            if (dragH && snapH) mouseLeft1 = mouseLeft1 < mouseLeft0 ? 0 : plotWidCss;
            if (dragV && snapV) mouseTop1 = mouseTop1 < mouseTop0 ? 0 : plotHgtCss;
            updateCursor(null, true, true);
            dragging = false;
        }
        mouseLeft1 = -10;
        mouseTop1 = -10;
        activeIdxs.fill(null);
        // passing a non-null timestamp to force sync/mousemove event
        updateCursor(null, true, true);
        if (_dragging) dragging = _dragging;
    }
    function dblClick(e, src, _l, _t, _w, _h, _i) {
        if (cursor._lock) return;
        setCursorEvent(e);
        autoScaleX();
        hideSelect();
        if (e != null) pubSync($3cd00ee63e984772$var$dblclick, self, mouseLeft1, mouseTop1, plotWidCss, plotHgtCss, null);
    }
    function syncPxRatio() {
        axes.forEach($3cd00ee63e984772$var$syncFontSize);
        _setSize(self.width, self.height, true);
    }
    $3cd00ee63e984772$var$on($3cd00ee63e984772$var$dppxchange, $3cd00ee63e984772$var$win, syncPxRatio);
    // internal pub/sub
    const events = {};
    events.mousedown = mouseDown;
    events.mousemove = mouseMove;
    events.mouseup = mouseUp;
    events.dblclick = dblClick;
    events["setSeries"] = (e, src, idx, opts)=>{
        let seriesIdxMatcher = syncOpts.match[2];
        idx = seriesIdxMatcher(self, src, idx);
        idx != -1 && setSeries(idx, opts, true, false);
    };
    if (showCursor) {
        onMouse($3cd00ee63e984772$var$mousedown, over, mouseDown);
        onMouse($3cd00ee63e984772$var$mousemove, over, mouseMove);
        onMouse($3cd00ee63e984772$var$mouseenter, over, (e)=>{
            setCursorEvent(e);
            syncRect(false);
        });
        onMouse($3cd00ee63e984772$var$mouseleave, over, mouseLeave);
        onMouse($3cd00ee63e984772$var$dblclick, over, dblClick);
        $3cd00ee63e984772$var$cursorPlots.add(self);
        self.syncRect = syncRect;
    }
    // external on/off
    const hooks = self.hooks = opts.hooks || {};
    function fire(evName, a1, a2) {
        if (deferHooks) hooksQueue.push([
            evName,
            a1,
            a2
        ]);
        else if (evName in hooks) hooks[evName].forEach((fn)=>{
            fn.call(null, self, a1, a2);
        });
    }
    (opts.plugins || []).forEach((p)=>{
        for(let evName in p.hooks)hooks[evName] = (hooks[evName] || []).concat(p.hooks[evName]);
    });
    const seriesIdxMatcher = (self, src, srcSeriesIdx)=>srcSeriesIdx;
    const syncOpts = $3cd00ee63e984772$var$assign({
        key: null,
        setSeries: false,
        filters: {
            pub: $3cd00ee63e984772$var$retTrue,
            sub: $3cd00ee63e984772$var$retTrue
        },
        scales: [
            xScaleKey,
            series[1] ? series[1].scale : null
        ],
        match: [
            $3cd00ee63e984772$var$retEq,
            $3cd00ee63e984772$var$retEq,
            seriesIdxMatcher
        ],
        values: [
            null,
            null
        ]
    }, cursor.sync);
    if (syncOpts.match.length == 2) syncOpts.match.push(seriesIdxMatcher);
    cursor.sync = syncOpts;
    const syncKey = syncOpts.key;
    const sync = $3cd00ee63e984772$var$_sync(syncKey);
    function pubSync(type, src, x, y, w, h, i) {
        if (syncOpts.filters.pub(type, src, x, y, w, h, i)) sync.pub(type, src, x, y, w, h, i);
    }
    sync.sub(self);
    function pub(type, src, x, y, w, h, i) {
        if (syncOpts.filters.sub(type, src, x, y, w, h, i)) events[type](null, src, x, y, w, h, i);
    }
    self.pub = pub;
    function destroy() {
        sync.unsub(self);
        $3cd00ee63e984772$var$cursorPlots.delete(self);
        mouseListeners.clear();
        $3cd00ee63e984772$var$off($3cd00ee63e984772$var$dppxchange, $3cd00ee63e984772$var$win, syncPxRatio);
        root.remove();
        legendTable?.remove(); // in case mounted outside of root
        fire("destroy");
    }
    self.destroy = destroy;
    function _init() {
        fire("init", opts, data);
        setData(data || opts.data, false);
        if (pendScales[xScaleKey]) setScale(xScaleKey, pendScales[xScaleKey]);
        else autoScaleX();
        shouldSetSelect = select.show && (select.width > 0 || select.height > 0);
        shouldSetCursor = shouldSetLegend = true;
        _setSize(opts.width, opts.height);
    }
    series.forEach(initSeries);
    axes.forEach(initAxis);
    if (then) {
        if (then instanceof HTMLElement) {
            then.appendChild(root);
            _init();
        } else then(self, _init);
    } else _init();
    return self;
}
$3cd00ee63e984772$export$2e2bcd8739ae039.assign = $3cd00ee63e984772$var$assign;
$3cd00ee63e984772$export$2e2bcd8739ae039.fmtNum = $3cd00ee63e984772$var$fmtNum;
$3cd00ee63e984772$export$2e2bcd8739ae039.rangeNum = $3cd00ee63e984772$var$rangeNum;
$3cd00ee63e984772$export$2e2bcd8739ae039.rangeLog = $3cd00ee63e984772$var$rangeLog;
$3cd00ee63e984772$export$2e2bcd8739ae039.rangeAsinh = $3cd00ee63e984772$var$rangeAsinh;
$3cd00ee63e984772$export$2e2bcd8739ae039.orient = $3cd00ee63e984772$var$orient;
$3cd00ee63e984772$export$2e2bcd8739ae039.pxRatio = $3cd00ee63e984772$var$pxRatio;
$3cd00ee63e984772$export$2e2bcd8739ae039.join = $3cd00ee63e984772$var$join;
$3cd00ee63e984772$export$2e2bcd8739ae039.fmtDate = $3cd00ee63e984772$var$fmtDate;
$3cd00ee63e984772$export$2e2bcd8739ae039.tzDate = $3cd00ee63e984772$var$tzDate;
$3cd00ee63e984772$export$2e2bcd8739ae039.sync = $3cd00ee63e984772$var$_sync;
{
    $3cd00ee63e984772$export$2e2bcd8739ae039.addGap = $3cd00ee63e984772$var$addGap;
    $3cd00ee63e984772$export$2e2bcd8739ae039.clipGaps = $3cd00ee63e984772$var$clipGaps;
    let paths = $3cd00ee63e984772$export$2e2bcd8739ae039.paths = {
        points: $3cd00ee63e984772$var$points
    };
    paths.linear = $3cd00ee63e984772$var$linear;
    paths.stepped = $3cd00ee63e984772$var$stepped;
    paths.bars = $3cd00ee63e984772$var$bars;
    paths.spline = $3cd00ee63e984772$var$monotoneCubic;
}

class $1de7bacd0e15f4f1$export$4ab14d3905033d17 {
    static scale(data, tickCount, maxFactor) {
        const { min: min, max: max } = $1de7bacd0e15f4f1$export$4ab14d3905033d17.calculateBounds(data);
        let factor = 1;
        while(true){
            const scale = Math.pow(10, factor);
            const scaledMin = min - min % scale;
            let scaledMax = max + (max % scale === 0 ? 0 : scale - max % scale);
            // Prevent min/max from being equal (and generating 0 ticks)
            // This happens when all data points are products of scale value
            if (scaledMin === scaledMax) scaledMax += scale;
            const ticks = (scaledMax - scaledMin) / scale;
            if (ticks <= tickCount || typeof maxFactor === 'number' && factor === maxFactor) return {
                scaledMin: scaledMin,
                scaledMax: scaledMax,
                scale: scale
            };
            else // Too many steps between min/max, increase factor and try again
            factor++;
        }
    }
    static scaleMatrix(data, tickCount, maxFactor) {
        const nonNullData = data.flat().filter((val)=>val !== null);
        // when used with the spread operator large nonNullData/data arrays can reach the max call stack size
        // use reduce calls to safely determine min/max values for any size of array
        // https://stackoverflow.com/questions/63705432/maximum-call-stack-size-exceeded-when-using-the-dots-operator/63706516#63706516
        const max = nonNullData.reduce((a, b)=>{
            return Math.max(a, b);
        }, Number.NEGATIVE_INFINITY);
        return $1de7bacd0e15f4f1$export$4ab14d3905033d17.scale([
            0,
            $1de7bacd0e15f4f1$export$4ab14d3905033d17.isFiniteOrZero(max)
        ], tickCount, maxFactor);
    }
    static generateTicks(min, max, step) {
        const ticks = [];
        for(let i = min; i <= max; i += step)ticks.push(i);
        return ticks;
    }
    static calculateBounds(data) {
        if (data.length === 0) return {
            min: 0,
            max: 0
        };
        else {
            const nonNullData = data.filter((val)=>val !== null);
            // when used with the spread operator large nonNullData/data arrays can reach the max call stack size
            // use reduce calls to safely determine min/max values for any size of array
            // https://stackoverflow.com/questions/63705432/maximum-call-stack-size-exceeded-when-using-the-dots-operator/63706516#63706516
            const min = nonNullData.reduce((a, b)=>{
                return Math.min(a, b);
            }, Number.POSITIVE_INFINITY);
            const max = nonNullData.reduce((a, b)=>{
                return Math.max(a, b);
            }, Number.NEGATIVE_INFINITY);
            return {
                min: $1de7bacd0e15f4f1$export$4ab14d3905033d17.isFiniteOrZero(min),
                max: $1de7bacd0e15f4f1$export$4ab14d3905033d17.isFiniteOrZero(max)
            };
        }
    }
    static isFiniteOrZero(val) {
        return Number.isFinite(val) ? val : 0;
    }
}


function $56c847d075380db4$var$_defineProperty(e, r, t) {
    return (r = $56c847d075380db4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $56c847d075380db4$var$_toPropertyKey(t) {
    var i = $56c847d075380db4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $56c847d075380db4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $56c847d075380db4$export$28c660c63b792dea {
    constructor(){
        $56c847d075380db4$var$_defineProperty(this, "hide", ()=>{
            this._div.style.display = 'none';
        });
        this._div = document.getElementById('tooltip');
    }
    set(x, y, offsetX, offsetY, html) {
        this._div.innerHTML = html;
        // Assign display: block so that the offsetWidth is valid
        this._div.style.display = 'block';
        // Prevent the div from overflowing the page width
        const tooltipWidth = this._div.offsetWidth;
        // 1.2 is a magic number used to pad the offset to ensure the tooltip
        // never gets close or surpasses the page's X width
        if (x + offsetX + tooltipWidth * 1.2 > window.innerWidth) {
            x -= tooltipWidth;
            offsetX *= -1;
        }
        this._div.style.top = `${y + offsetY}px`;
        this._div.style.left = `${x + offsetX}px`;
    }
}
class $56c847d075380db4$export$32fbfacc5d962e0c {
    constructor(){
        this._div = document.getElementById('status-text');
    }
    set(text) {
        this._div.innerText = text;
        this._div.style.display = 'block';
    }
    hide() {
        this._div.style.display = 'none';
    }
}
class $56c847d075380db4$export$ff541c634b6ae8ec {
    constructor(){
        this._div = document.getElementById('copy-toast');
    }
    show(targetElement, text) {
        this._div.innerText = text;
        this._div.style.display = 'block';
        this._div.style.top = '0';
        this._div.style.left = '0';
        if (!targetElement) return;
        const targetBounds = targetElement.getBoundingClientRect();
        const toastWidth = this._div.offsetWidth;
        const top = window.scrollY + targetBounds.bottom + 8;
        const idealLeft = window.scrollX + targetBounds.left + (targetBounds.width - toastWidth) / 2;
        const maxLeft = window.scrollX + window.innerWidth - toastWidth - 12;
        const left = Math.max(window.scrollX + 12, Math.min(idealLeft, maxLeft));
        this._div.style.top = `${top}px`;
        this._div.style.left = `${left}px`;
        if (this._timeoutId) clearTimeout(this._timeoutId);
        this._timeoutId = setTimeout(()=>{
            this._div.style.display = 'none';
            this._timeoutId = undefined;
        }, 1600);
    }
}
// Minecraft Java Edition default server port: 25565
// Minecraft Bedrock Edition default server port: 19132
const $56c847d075380db4$var$MINECRAFT_DEFAULT_PORTS = [
    25565,
    19132
];
function $56c847d075380db4$export$b9d29ed6ecff7b9d(ip, port) {
    if (port && !$56c847d075380db4$var$MINECRAFT_DEFAULT_PORTS.includes(port)) return `${ip}:${port}`;
    return ip;
}
function $56c847d075380db4$export$aadb186058d814a7(versions, knownVersions) {
    if (!versions || !versions.length || !knownVersions || !knownVersions.length) return;
    let currentVersionGroup = [];
    const versionGroups = [];
    for(let i = 0; i < versions.length; i++){
        // Look for value mismatch between the previous index
        // Require i > 0 since lastVersionIndex is undefined for i === 0
        if (i > 0 && versions[i] - versions[i - 1] !== 1) {
            versionGroups.push(currentVersionGroup);
            currentVersionGroup = [];
        }
        currentVersionGroup.push(versions[i]);
    }
    // Ensure the last versionGroup is always pushed
    if (currentVersionGroup.length > 0) versionGroups.push(currentVersionGroup);
    if (versionGroups.length === 0) return;
    // Remap individual versionGroups values into named versions
    return versionGroups.map((versionGroup)=>{
        const startVersion = knownVersions[versionGroup[0]];
        if (versionGroup.length === 1) // A versionGroup may contain a single version, only return its name
        // This is a cosmetic catch to avoid version labels like 1.0-1.0
        return startVersion;
        else {
            const endVersion = knownVersions[versionGroup[versionGroup.length - 1]];
            return `${startVersion}-${endVersion}`;
        }
    }).join(', ');
}
function $56c847d075380db4$export$b144b3a88a3e7934(secs, locale = 'en-GB') {
    const date = new Date(0);
    date.setUTCSeconds(secs);
    return date.toLocaleTimeString(locale, {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
}
function $56c847d075380db4$export$3ae94a2503e890a1(secs, locale = 'en-GB') {
    const date = new Date(0);
    date.setUTCSeconds(secs);
    return date.toLocaleDateString(locale);
}
function $56c847d075380db4$export$32e6b1ae352e94d6(x, over, locale = 'en-GB') {
    const val = Math.round(x / over * 1000) / 10;
    return `${val}${locale === 'sv-SE' ? ' ' : ''}%`;
}
function $56c847d075380db4$export$f5dd818bff069720(x) {
    if (typeof x !== 'number') return '-';
    else return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}


function $04cccc5b90d17ac6$export$2f2e390e2470b67e(onHover) {
    let element;
    return {
        hooks: {
            init: (u)=>{
                element = u.root.querySelector('.u-over') || u.root.querySelector('.over');
                if (!element) return;
                element.onmouseenter = ()=>onHover();
                element.onmouseleave = ()=>onHover();
            },
            setCursor: (u)=>{
                if (!element) return;
                const { left: left, top: top, idx: idx } = u.cursor;
                if (idx === null) onHover(undefined, undefined, u);
                else {
                    const bounds = element.getBoundingClientRect();
                    onHover({
                        left: bounds.left + left + window.pageXOffset,
                        top: bounds.top + top + window.pageYOffset
                    }, idx, u);
                }
            }
        }
    };
}


var $6b0880f2f43c1b37$exports = {};
$6b0880f2f43c1b37$exports = $parcel$resolve("9VN3G");


function $55c6659bb18364ca$var$_defineProperty(e, r, t) {
    return (r = $55c6659bb18364ca$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $55c6659bb18364ca$var$_toPropertyKey(t) {
    var i = $55c6659bb18364ca$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $55c6659bb18364ca$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $55c6659bb18364ca$export$1115b10cc9bb0fa8 {
    constructor(app){
        $55c6659bb18364ca$var$_defineProperty(this, "getServerRegistrations", ()=>Object.values(this._registeredServers));
        this._app = app;
        this._serverIdsByName = [];
        this._serverDataById = [];
        this._registeredServers = [];
    }
    assignServers(servers) {
        for(let i = 0; i < servers.length; i++){
            const data = servers[i];
            this._serverIdsByName[data.name] = i;
            this._serverDataById[i] = data;
        }
    }
    createServerRegistration(serverId) {
        const serverData = this._serverDataById[serverId];
        const serverRegistration = new $55c6659bb18364ca$export$c6f081893021db7f(this._app, serverId, serverData);
        this._registeredServers[serverId] = serverRegistration;
        return serverRegistration;
    }
    getServerRegistration(serverKey) {
        if (typeof serverKey === 'string') {
            const serverId = this._serverIdsByName[serverKey];
            return this._registeredServers[serverId];
        } else if (typeof serverKey === 'number') return this._registeredServers[serverKey];
    }
    resizeAll() {
        this.getServerRegistrations().forEach((serverRegistration)=>serverRegistration.resize());
    }
    reset() {
        this._serverIdsByName = [];
        this._serverDataById = [];
        this._registeredServers = [];
        // Reset modified DOM structures
        document.getElementById('server-list').innerHTML = '';
    }
}
class $55c6659bb18364ca$export$c6f081893021db7f {
    constructor(app, serverId, data){
        $55c6659bb18364ca$var$_defineProperty(this, "playerCount", 0);
        $55c6659bb18364ca$var$_defineProperty(this, "isVisible", true);
        $55c6659bb18364ca$var$_defineProperty(this, "isFavorite", false);
        $55c6659bb18364ca$var$_defineProperty(this, "rankIndex", void 0);
        $55c6659bb18364ca$var$_defineProperty(this, "lastRecordData", void 0);
        $55c6659bb18364ca$var$_defineProperty(this, "lastPeakData", void 0);
        $55c6659bb18364ca$var$_defineProperty(this, "resize", ()=>{
            if (!this._plotInstance) return;
            const container = document.getElementById(`chart_${this.serverId}`);
            this._plotInstance.setSize({
                width: container.clientWidth,
                height: 100
            });
        });
        $55c6659bb18364ca$var$_defineProperty(this, "handleServerClick", async (event)=>{
            const targetElement = event.currentTarget;
            const serverAddress = (0, $56c847d075380db4$export$b9d29ed6ecff7b9d)(this.data.ip, this.data.port);
            const isCopied = await $55c6659bb18364ca$var$copyTextToClipboard(serverAddress);
            this._app.copyToast.show(targetElement, this._app.t(isCopied ? 'copied' : 'couldNotCopy', {
                address: serverAddress
            }));
        });
        this._app = app;
        this.serverId = serverId;
        this.data = data;
        this._graphData = [
            [],
            []
        ];
        this._failedSequentialPings = 0;
    }
    getGraphDataIndex() {
        return this.serverId + 1;
    }
    addGraphPoints(points, timestampPoints) {
        this._graphData = [
            timestampPoints.slice(),
            points
        ];
    }
    getScaledGraphRange() {
        return (0, $1de7bacd0e15f4f1$export$4ab14d3905033d17).scale(this._graphData[1], 4);
    }
    buildPlotInstance() {
        const container = document.getElementById(`chart_${this.serverId}`);
        // eslint-disable-next-line new-cap
        this._plotInstance = new (0, $3cd00ee63e984772$export$2e2bcd8739ae039)({
            plugins: [
                (0, $04cccc5b90d17ac6$export$2f2e390e2470b67e)((pos, id)=>{
                    if (pos) {
                        const playerCount = this._graphData[1][id];
                        if (typeof playerCount !== 'number') this._app.tooltip.hide();
                        else this._app.tooltip.set(pos.left, pos.top, 10, 10, `${this._app.t('playersCount', {
                            count: (0, $56c847d075380db4$export$f5dd818bff069720)(playerCount)
                        })}<br>${(0, $56c847d075380db4$export$b144b3a88a3e7934)(this._graphData[0][id], this._app.intlLocale)}`);
                    } else this._app.tooltip.hide();
                })
            ],
            height: 100,
            width: container.clientWidth || 400,
            cursor: {
                y: false,
                drag: {
                    setScale: false,
                    x: false,
                    y: false
                },
                sync: {
                    key: 'minetrack-server',
                    setSeries: true
                }
            },
            series: [
                {},
                {
                    displayStroke: this.data.color,
                    stroke () {
                        return this.displayStroke;
                    },
                    width: 2,
                    value: (_, raw)=>this._app.t('playersCount', {
                            count: (0, $56c847d075380db4$export$f5dd818bff069720)(raw)
                        }),
                    spanGaps: true,
                    points: {
                        show: false
                    }
                }
            ],
            axes: [
                {
                    show: false
                },
                {
                    ticks: {
                        show: false
                    },
                    font: '14px "Open Sans", sans-serif',
                    stroke: '#A3A3A3',
                    size: 55,
                    grid: {
                        stroke: '#333',
                        width: 1
                    },
                    split: ()=>{
                        const { scaledMin: scaledMin, scaledMax: scaledMax, scale: scale } = this.getScaledGraphRange();
                        return (0, $1de7bacd0e15f4f1$export$4ab14d3905033d17).generateTicks(scaledMin, scaledMax, scale);
                    }
                }
            ],
            scales: {
                y: {
                    auto: false,
                    range: ()=>{
                        const { scaledMin: scaledMin, scaledMax: scaledMax } = this.getScaledGraphRange();
                        return [
                            scaledMin,
                            scaledMax
                        ];
                    }
                }
            },
            legend: {
                show: false
            }
        }, this._graphData, container);
    }
    handleColorUpdate(color) {
        if (!color || this.data.color === color) return false;
        this.data.color = color;
        const colorSwatchElement = document.getElementById(`graph-color-swatch_${this.serverId}`);
        if (colorSwatchElement) colorSwatchElement.style.background = color;
        if (this._plotInstance) {
            this._plotInstance.series[1].displayStroke = color;
            this._plotInstance.redraw();
        }
        return true;
    }
    handlePing(payload, timestamp) {
        if (typeof payload.playerCount === 'number') {
            this.playerCount = payload.playerCount;
            // Reset failed ping counter to ensure the next connection error
            // doesn't instantly retrigger a layout change
            this._failedSequentialPings = 0;
        } else // Attempt to retain a copy of the cached playerCount for up to N failed pings
        // This prevents minor connection issues from constantly reshuffling the layout
        if (++this._failedSequentialPings > 5) this.playerCount = 0;
        // Use payload.playerCount so nulls WILL be pushed into the graphing data
        this._graphData[0].push(timestamp);
        this._graphData[1].push(payload.playerCount);
        // Trim graphData to within the max length by shifting out the leading elements
        for (const series of this._graphData)if (series.length > this._app.publicConfig.serverGraphMaxLength) series.shift();
        // Redraw the plot instance
        try {
            this._plotInstance.setData(this._graphData);
            const { scaledMin: scaledMin, scaledMax: scaledMax } = this.getScaledGraphRange();
            this._plotInstance.setScale('y', {
                min: scaledMin,
                max: scaledMax
            });
        } catch (err) {
            console.error(`Failed to update small graph for ${this.data.name}, rebuilding`, err);
            if (this._plotInstance) this._plotInstance.destroy();
            this.buildPlotInstance();
        }
    }
    updateServerRankIndex(rankIndex) {
        this.rankIndex = rankIndex;
        document.getElementById(`ranking_${this.serverId}`).innerText = `#${rankIndex + 1}`;
    }
    _renderValue(prefix, handler) {
        const labelElement = document.getElementById(`${prefix}_${this.serverId}`);
        labelElement.style.display = 'block';
        const valueElement = document.getElementById(`${prefix}-value_${this.serverId}`);
        const targetElement = valueElement || labelElement;
        if (targetElement) {
            if (typeof handler === 'function') handler(targetElement);
            else targetElement.innerText = handler;
        }
    }
    _hideValue(prefix) {
        const element = document.getElementById(`${prefix}_${this.serverId}`);
        element.style.display = 'none';
    }
    updateServerStatus(ping, minecraftVersions) {
        if (ping.versions) this._renderValue('version', (0, $56c847d075380db4$export$aadb186058d814a7)(ping.versions, minecraftVersions[this.data.type]) || '');
        if (ping.recordData) {
            this._renderValue('record', (element)=>{
                if (ping.recordData.timestamp > 0) {
                    element.innerText = `${(0, $56c847d075380db4$export$f5dd818bff069720)(ping.recordData.playerCount)} (${(0, $56c847d075380db4$export$3ae94a2503e890a1)(ping.recordData.timestamp, this._app.intlLocale)})`;
                    element.title = this._app.t('atDateTime', {
                        date: (0, $56c847d075380db4$export$3ae94a2503e890a1)(ping.recordData.timestamp, this._app.intlLocale),
                        time: (0, $56c847d075380db4$export$b144b3a88a3e7934)(ping.recordData.timestamp, this._app.intlLocale)
                    });
                } else element.innerText = (0, $56c847d075380db4$export$f5dd818bff069720)(ping.recordData.playerCount);
            });
            this.lastRecordData = ping.recordData;
        }
        if (ping.graphPeakData) {
            this._renderValue('peak', (element)=>{
                element.innerText = (0, $56c847d075380db4$export$f5dd818bff069720)(ping.graphPeakData.playerCount);
                element.title = this._app.t('atTime', {
                    time: (0, $56c847d075380db4$export$b144b3a88a3e7934)(ping.graphPeakData.timestamp, this._app.intlLocale)
                });
            });
            this.lastPeakData = ping.graphPeakData;
        }
        if (ping.error) {
            this._hideValue('player-count');
            this._renderValue('error', ping.error.message);
        } else if (typeof ping.playerCount !== 'number') {
            this._hideValue('player-count');
            // If the frontend has freshly connection, and the server's last ping was in error, it may not contain an error object
            // In this case playerCount will safely be null, so provide a generic error message instead
            this._renderValue('error', this._app.t('failedToPing'));
        } else if (typeof ping.playerCount === 'number') {
            this._hideValue('error');
            this._renderValue('player-count', (0, $56c847d075380db4$export$f5dd818bff069720)(ping.playerCount));
        }
        // An updated favicon has been sent, update the src
        if (ping.favicon) {
            const faviconElement = document.getElementById(`favicon_${this.serverId}`);
            // Since favicons may be URLs, only update the attribute when it has changed
            // Otherwise the browser may send multiple requests to the same URL
            if (faviconElement.getAttribute('src') !== ping.favicon) faviconElement.setAttribute('src', ping.favicon);
        }
    }
    initServerStatus(latestPing) {
        const serverElement = document.createElement('div');
        const copyAreaId = `copy-area_${this.serverId}`;
        const serverAddress = (0, $56c847d075380db4$export$b9d29ed6ecff7b9d)(this.data.ip, this.data.port);
        serverElement.id = `container_${this.serverId}`;
        serverElement.innerHTML = `<div class="server-copy-area" id="${copyAreaId}" title="${this._app.t('clickToCopy', {
            address: serverAddress
        })}">
        <div class="column column-favicon">
          <img class="server-favicon" src="${latestPing.favicon || (0, (/*@__PURE__*/$parcel$interopDefault($6b0880f2f43c1b37$exports)))}" id="favicon_${this.serverId}" title="${this.data.name}\n${serverAddress}">
          <span class="server-rank" id="ranking_${this.serverId}"></span>
        </div>
        <div class="column column-status">
          <h3 class="server-name"><span class="${this._app.favoritesManager.getIconClass(this.isFavorite)}" id="favorite-toggle_${this.serverId}"></span> ${this.data.name}</h3>
          <span class="server-error" id="error_${this.serverId}"></span>
          <span class="server-label" id="player-count_${this.serverId}">${this._app.t('playersLabel')}: <span class="server-value" id="player-count-value_${this.serverId}"></span></span>
          <span class="server-label" id="peak_${this.serverId}">${this._app.t('peakLabel', {
            duration: this._app.publicConfig.graphDurationLabel
        })}: <span class="server-value" id="peak-value_${this.serverId}">-</span></span>
          <span class="server-label" id="record_${this.serverId}">${this._app.t('recordLabel')}: <span class="server-value" id="record-value_${this.serverId}">-</span></span>
          <span class="server-label" id="version_${this.serverId}"></span>
        </div>
      </div>
      <div class="column column-graph" id="chart_${this.serverId}"></div>`;
        serverElement.setAttribute('class', 'server');
        document.getElementById('server-list').appendChild(serverElement);
    }
    updateHighlightedValue(selectedCategory) {
        [
            'player-count',
            'peak',
            'record'
        ].forEach((category)=>{
            const labelElement = document.getElementById(`${category}_${this.serverId}`);
            const valueElement = document.getElementById(`${category}-value_${this.serverId}`);
            if (selectedCategory && category === selectedCategory) {
                labelElement.setAttribute('class', 'server-highlighted-label');
                valueElement.setAttribute('class', 'server-highlighted-value');
            } else {
                labelElement.setAttribute('class', 'server-label');
                valueElement.setAttribute('class', 'server-value');
            }
        });
    }
    initEventListeners() {
        document.getElementById(`copy-area_${this.serverId}`).addEventListener('click', this.handleServerClick, false);
        document.getElementById(`favorite-toggle_${this.serverId}`).addEventListener('click', (event)=>{
            event.stopPropagation();
            this._app.favoritesManager.handleFavoriteButtonClick(this);
        }, false);
    }
}
async function $55c6659bb18364ca$var$copyTextToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (err) {}
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    let isCopied = false;
    try {
        isCopied = document.execCommand('copy');
    } catch (err) {}
    document.body.removeChild(textArea);
    return isCopied;
}


class $e0890a2aab451ef8$export$c91428cbd4f5850d {
    constructor(app){
        this._app = app;
        this._hasRequestedHistoryGraph = false;
        this._reconnectDelayBase = 0;
    }
    reset() {
        this._hasRequestedHistoryGraph = false;
    }
    createWebSocket() {
        let webSocketProtocol = 'ws:';
        if (location.protocol === 'https:') webSocketProtocol = 'wss:';
        this._webSocket = new WebSocket(`${webSocketProtocol}//${location.host}`);
        // The backend will automatically push data once connected
        this._webSocket.onopen = ()=>{
            this._app.caption.set(this._app.t('captionLoading'));
            // Reset reconnection scheduling since the WebSocket has been established
            this._reconnectDelayBase = 0;
        };
        this._webSocket.onclose = (event)=>{
            this._app.handleDisconnect();
            // Modify page state to display loading overlay
            // Code 1006 denotes "Abnormal closure", most likely from the server or client losing connection
            // See https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent
            // Treat other codes as active errors (besides connectivity errors) when displaying the message
            if (event.code === 1006) this._app.caption.set(this._app.t('captionLostConnection'));
            else this._app.caption.set(this._app.t('captionDisconnected'));
            // Schedule socket reconnection attempt
            this.scheduleReconnect();
        };
        this._webSocket.onmessage = (message)=>{
            try {
                const payload = JSON.parse(message.data);
                switch(payload.message){
                    case 'init':
                        this._app.setPublicConfig(payload.config);
                        // Display the main page component
                        // Called here instead of syncComplete so the DOM can be drawn prior to the graphs being drawn
                        this._app.setPageReady(true);
                        // Allow the graphDisplayManager to control whether or not the historical graph is loaded
                        // Defer to isGraphVisible from the publicConfig to understand if the frontend will ever receive a graph payload
                        if (this._app.publicConfig.isGraphVisible) this.sendHistoryGraphRequest();
                        payload.servers.forEach((serverPayload, serverId)=>{
                            this._app.addServer(serverId, serverPayload, payload.timestampPoints);
                        });
                        // Init payload contains all data needed to render the page
                        // Alert the app it is ready
                        this._app.handleSyncComplete();
                        break;
                    case 'updateServers':
                        {
                            let hasColorUpdate = false;
                            for (const [serverName, serverUpdate] of Object.entries(payload.updates)){
                                // The backend may send "update" events prior to receiving all "add" events
                                // A server has only been added once it's ServerRegistration is defined
                                // Checking undefined protects from this race condition
                                const serverRegistration = this._app.serverRegistry.getServerRegistration(serverName);
                                if (serverRegistration) try {
                                    if (serverUpdate.color && serverRegistration.handleColorUpdate(serverUpdate.color)) {
                                        this._app.graphDisplayManager.handleServerColorUpdate(serverRegistration);
                                        hasColorUpdate = true;
                                    }
                                    serverRegistration.handlePing(serverUpdate, payload.timestamp);
                                    serverRegistration.updateServerStatus(serverUpdate, this._app.publicConfig.minecraftVersions);
                                } catch (err) {
                                    console.error(`Failed to apply server update for ${serverName}`, err);
                                }
                            }
                            // Bulk add playerCounts into graph during #updateHistoryGraph
                            if (payload.updateHistoryGraph) {
                                // Map player counts in the same order as the server registrations (filtered list order)
                                const playerCounts = this._app.serverRegistry.getServerRegistrations().map((reg)=>{
                                    const update = payload.updates[reg.data.name];
                                    return update ? update.playerCount : null;
                                });
                                try {
                                    this._app.graphDisplayManager.addGraphPoint(payload.timestamp, playerCounts);
                                    // Run redraw tasks after handling bulk updates
                                    this._app.graphDisplayManager.redraw(false);
                                } catch (err) {
                                    console.error('Failed to update main graph', err);
                                }
                            } else if (hasColorUpdate) try {
                                this._app.graphDisplayManager.redraw();
                            } catch (err) {
                                console.error('Failed to redraw main graph after color update', err);
                            }
                            try {
                                this._app.percentageBar.redraw();
                            } catch (err) {
                                console.error('Failed to redraw percentage bar', err);
                            }
                            try {
                                this._app.updateGlobalStats();
                            } catch (err) {
                                console.error('Failed to update global stats', err);
                            }
                            break;
                        }
                    case 'minecraftVersions':
                        this._app.publicConfig.minecraftVersions = payload.minecraftVersions;
                        break;
                    case 'historyGraph':
                        {
                            this._app.graphDisplayManager.buildPlotInstance(payload.timestamps, payload.graphData);
                            // Build checkbox elements for graph controls
                            const controlsHTML = this._app.serverRegistry.getServerRegistrations().map((serverRegistration)=>serverRegistration.data.name).sort().map((serverName)=>{
                                const serverRegistration = this._app.serverRegistry.getServerRegistration(serverName);
                                return `<label class="graph-control-item">
                  <span class="graph-color-swatch" id="graph-color-swatch_${serverRegistration.serverId}" style="background: ${serverRegistration.data.color}"></span>
                  <input type="checkbox" class="graph-control" minetrack-server-id="${serverRegistration.serverId}" ${serverRegistration.isVisible ? 'checked' : ''}>
                  ${serverName}
                  </label>`;
                            }).join('');
                            // Apply generated HTML and show controls
                            document.getElementById('big-graph-checkboxes').innerHTML = controlsHTML;
                            document.getElementById('big-graph-controls').style.display = 'block';
                            // Bind click event for updating graph data
                            this._app.graphDisplayManager.initEventListeners();
                            break;
                        }
                }
            } catch (err) {
                console.error('Failed to process WebSocket message', err, message.data);
            }
        };
    }
    scheduleReconnect() {
        // Release any active WebSocket references
        this._webSocket = undefined;
        this._reconnectDelayBase++;
        // Exponential backoff for reconnection attempts
        // Clamp ceiling value to 30 seconds
        this._reconnectDelaySeconds = Math.min(this._reconnectDelayBase * this._reconnectDelayBase, 30);
        const reconnectInterval = setInterval(()=>{
            this._reconnectDelaySeconds--;
            if (this._reconnectDelaySeconds === 0) {
                // Explicitly clear interval, this avoids race conditions
                // #clearInterval first to avoid potential errors causing pre-mature returns
                clearInterval(reconnectInterval);
                // Update displayed text
                this._app.caption.set(this._app.t('captionReconnecting'));
                // Attempt reconnection
                // Only attempt when reconnectDelaySeconds === 0 and not <= 0, otherwise multiple attempts may be started
                this.createWebSocket();
            } else if (this._reconnectDelaySeconds > 0) // Update displayed text
            this._app.caption.set(this._app.t('captionReconnectingIn', {
                seconds: this._reconnectDelaySeconds
            }));
        }, 1000);
    }
    sendHistoryGraphRequest() {
        if (!this._hasRequestedHistoryGraph) {
            this._hasRequestedHistoryGraph = true;
            // Send request as a plain text string to avoid the server needing to parse JSON
            // This is mostly to simplify the backend server's need for error handling
            this._webSocket.send('requestHistoryGraph');
        }
    }
}


function $07537187749245e4$var$_defineProperty(e, r, t) {
    return (r = $07537187749245e4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $07537187749245e4$var$_toPropertyKey(t) {
    var i = $07537187749245e4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $07537187749245e4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $07537187749245e4$var$SORT_OPTIONS = [
    {
        getName: (app)=>app.t('playersLabel'),
        sortFunc: (a, b)=>b.playerCount - a.playerCount,
        highlightedValue: 'player-count'
    },
    {
        getName: (app)=>{
            return app.t('peakLabel', {
                duration: app.publicConfig.graphDurationLabel
            });
        },
        sortFunc: (a, b)=>{
            if (!a.lastPeakData && !b.lastPeakData) return 0;
            else if (a.lastPeakData && !b.lastPeakData) return -1;
            else if (b.lastPeakData && !a.lastPeakData) return 1;
            return b.lastPeakData.playerCount - a.lastPeakData.playerCount;
        },
        testFunc: (app)=>{
            // Require at least one ServerRegistration to have a lastPeakData value defined
            for (const serverRegistration of app.serverRegistry.getServerRegistrations()){
                if (serverRegistration.lastPeakData) return true;
            }
            return false;
        },
        highlightedValue: 'peak'
    },
    {
        getName: (app)=>app.t('recordLabel'),
        sortFunc: (a, b)=>{
            if (!a.lastRecordData && !b.lastRecordData) return 0;
            else if (a.lastRecordData && !b.lastRecordData) return -1;
            else if (b.lastRecordData && !a.lastRecordData) return 1;
            return b.lastRecordData.playerCount - a.lastRecordData.playerCount;
        },
        testFunc: (app)=>{
            // Require at least one ServerRegistration to have a lastRecordData value defined
            for (const serverRegistration of app.serverRegistry.getServerRegistrations()){
                if (serverRegistration.lastRecordData) return true;
            }
            return false;
        },
        highlightedValue: 'record'
    }
];
const $07537187749245e4$var$SORT_OPTION_INDEX_DEFAULT = 0;
const $07537187749245e4$var$SORT_OPTION_INDEX_STORAGE_KEY = 'minetrack_sort_option_index';
class $07537187749245e4$export$765594e5be71a851 {
    constructor(app){
        $07537187749245e4$var$_defineProperty(this, "handleSortByButtonClick", ()=>{
            while(true){
                // Increment to the next sort option, wrap around if needed
                this._sortOptionIndex = (this._sortOptionIndex + 1) % $07537187749245e4$var$SORT_OPTIONS.length;
                // Only break if the sortOption is supported
                // This can technically cause an infinite loop, but never should assuming
                // at least one sortOption does not implement the test OR always returns true
                const sortOption = $07537187749245e4$var$SORT_OPTIONS[this._sortOptionIndex];
                if (!sortOption.testFunc || sortOption.testFunc(this._app)) break;
            }
            // Redraw the button and sort the servers
            this.updateSortOption();
            // Save the updated option selection
            this.updateLocalStorage();
        });
        $07537187749245e4$var$_defineProperty(this, "updateSortOption", ()=>{
            const sortOption = $07537187749245e4$var$SORT_OPTIONS[this._sortOptionIndex];
            // Pass app instance so sortOption names can be dynamically generated
            this._textElement.innerText = sortOption.getName(this._app);
            // Update all servers highlighted values
            for (const serverRegistration of this._app.serverRegistry.getServerRegistrations())serverRegistration.updateHighlightedValue(sortOption.highlightedValue);
            this.sortServers();
        });
        $07537187749245e4$var$_defineProperty(this, "sortServers", ()=>{
            const sortOption = $07537187749245e4$var$SORT_OPTIONS[this._sortOptionIndex];
            const sortedServers = this._app.serverRegistry.getServerRegistrations().sort((a, b)=>{
                if (a.isFavorite && !b.isFavorite) return -1;
                else if (b.isFavorite && !a.isFavorite) return 1;
                return sortOption.sortFunc(a, b);
            });
            // Test if sortedServers has changed from the previous listing
            // This avoids DOM updates and graphs being redrawn
            const sortedServerIds = sortedServers.map((server)=>server.serverId);
            if (this._lastSortedServers) {
                let allMatch = true;
                // Test if the arrays have actually changed
                // No need to length check, they are the same source data each time
                for(let i = 0; i < sortedServerIds.length; i++)if (sortedServerIds[i] !== this._lastSortedServers[i]) {
                    allMatch = false;
                    break;
                }
                if (allMatch) return;
            }
            this._lastSortedServers = sortedServerIds;
            // Sort a ServerRegistration list by the sortOption ONLY
            // This is used to determine the ServerRegistration's rankIndex without #isFavorite skewing values
            const rankIndexSort = this._app.serverRegistry.getServerRegistrations().sort(sortOption.sortFunc);
            // Update the DOM structure
            sortedServers.forEach(function(serverRegistration) {
                const parentElement = document.getElementById('server-list');
                const serverElement = document.getElementById(`container_${serverRegistration.serverId}`);
                parentElement.appendChild(serverElement);
                // Set the ServerRegistration's rankIndex to its indexOf the normal sort
                serverRegistration.updateServerRankIndex(rankIndexSort.indexOf(serverRegistration));
            });
        });
        this._app = app;
        this._buttonElement = document.getElementById('sort-by');
        this._textElement = document.getElementById('sort-by-text');
        this._sortOptionIndex = $07537187749245e4$var$SORT_OPTION_INDEX_DEFAULT;
    }
    reset() {
        this._lastSortedServers = undefined;
        // Reset modified DOM structures
        this._buttonElement.style.display = 'none';
        this._textElement.innerText = '...';
        // Remove bound DOM event listeners
        this._buttonElement.removeEventListener('click', this.handleSortByButtonClick);
    }
    loadLocalStorage() {
        if (typeof localStorage !== 'undefined') {
            const sortOptionIndex = localStorage.getItem($07537187749245e4$var$SORT_OPTION_INDEX_STORAGE_KEY);
            if (sortOptionIndex) this._sortOptionIndex = parseInt(sortOptionIndex);
        }
    }
    updateLocalStorage() {
        if (typeof localStorage !== 'undefined') {
            if (this._sortOptionIndex !== $07537187749245e4$var$SORT_OPTION_INDEX_DEFAULT) localStorage.setItem($07537187749245e4$var$SORT_OPTION_INDEX_STORAGE_KEY, this._sortOptionIndex);
            else localStorage.removeItem($07537187749245e4$var$SORT_OPTION_INDEX_STORAGE_KEY);
        }
    }
    show() {
        // Load the saved option selection, if any
        this.loadLocalStorage();
        this.updateSortOption();
        // Bind DOM event listeners
        // This is removed by #reset to avoid multiple listeners
        this._buttonElement.addEventListener('click', this.handleSortByButtonClick);
        // Show #sort-by element
        this._buttonElement.style.display = 'inline-block';
    }
}






function $1e7ce28416c55f9b$var$_defineProperty(e, r, t) {
    return (r = $1e7ce28416c55f9b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1e7ce28416c55f9b$var$_toPropertyKey(t) {
    var i = $1e7ce28416c55f9b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1e7ce28416c55f9b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $1e7ce28416c55f9b$export$2c19dd479e63aadf = 'minetrack_favorite_servers';
class $1e7ce28416c55f9b$export$bf46da6bfe361ab1 {
    constructor(app){
        $1e7ce28416c55f9b$var$_defineProperty(this, "handleFavoriteButtonClick", (serverRegistration)=>{
            serverRegistration.isFavorite = !serverRegistration.isFavorite;
            // Update the displayed favorite icon
            document.getElementById(`favorite-toggle_${serverRegistration.serverId}`).setAttribute('class', this.getIconClass(serverRegistration.isFavorite));
            // Request the app controller instantly re-sort the server listing
            // This handles the favorite sorting logic internally
            this._app.sortController.sortServers();
            this._app.graphDisplayManager.handleServerIsFavoriteUpdate(serverRegistration);
            // Write an updated settings payload
            this.updateLocalStorage();
        });
        this._app = app;
    }
    loadLocalStorage() {
        if (typeof localStorage !== 'undefined') {
            let serverNames = localStorage.getItem($1e7ce28416c55f9b$export$2c19dd479e63aadf);
            if (serverNames) {
                serverNames = JSON.parse(serverNames);
                for(let i = 0; i < serverNames.length; i++){
                    const serverRegistration = this._app.serverRegistry.getServerRegistration(serverNames[i]);
                    // The serverName may not exist in the backend configuration anymore
                    // Ensure serverRegistration is defined before mutating data or considering valid
                    if (serverRegistration) {
                        serverRegistration.isFavorite = true;
                        // Update icon since by default it is unfavorited
                        document.getElementById(`favorite-toggle_${serverRegistration.serverId}`).setAttribute('class', this.getIconClass(serverRegistration.isFavorite));
                    }
                }
            }
        }
    }
    updateLocalStorage() {
        if (typeof localStorage !== 'undefined') {
            // Mutate the serverIds array into server names for storage use
            const serverNames = this._app.serverRegistry.getServerRegistrations().filter((serverRegistration)=>serverRegistration.isFavorite).map((serverRegistration)=>serverRegistration.data.name);
            if (serverNames.length > 0) // Only save if the array contains data, otherwise clear the item
            localStorage.setItem($1e7ce28416c55f9b$export$2c19dd479e63aadf, JSON.stringify(serverNames));
            else localStorage.removeItem($1e7ce28416c55f9b$export$2c19dd479e63aadf);
        }
    }
    getIconClass(isFavorite) {
        if (isFavorite) return 'icon-star server-is-favorite';
        else return 'icon-star-o server-is-not-favorite';
    }
}


function $7db29b7aa35273ae$var$_defineProperty(e, r, t) {
    return (r = $7db29b7aa35273ae$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7db29b7aa35273ae$var$_toPropertyKey(t) {
    var i = $7db29b7aa35273ae$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7db29b7aa35273ae$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $7db29b7aa35273ae$var$HIDDEN_SERVERS_STORAGE_KEY = 'minetrack_hidden_servers';
const $7db29b7aa35273ae$var$SHOW_FAVORITES_STORAGE_KEY = 'minetrack_show_favorites';
const $7db29b7aa35273ae$var$GRAPH_TICK_COUNT = 10;
const $7db29b7aa35273ae$var$GRAPH_MAX_FACTOR = 4;
class $7db29b7aa35273ae$export$2fa5fa2e8b5ec38b {
    constructor(app){
        $7db29b7aa35273ae$var$_defineProperty(this, "redraw", (forceRescale = true)=>{
            if (!this._plotInstance) return;
            // Use drawing as a hint to update settings
            // This may cause unnessecary localStorage updates, but its a rare and harmless outcome
            this.updateLocalStorage();
            // Copy application state into the series data used by uPlot
            for (const serverRegistration of this._app.serverRegistry.getServerRegistrations())this._plotInstance.series[serverRegistration.getGraphDataIndex()].show = serverRegistration.isVisible;
            this._plotInstance.redraw(forceRescale);
        });
        $7db29b7aa35273ae$var$_defineProperty(this, "resize", ()=>{
            this._plotInstance.setSize(this.getPlotSize());
            // undefine value so #clearTimeout is not called
            // This is safe even if #resize is manually called since it removes the pending work
            if (this._resizeRequestTimeout) clearTimeout(this._resizeRequestTimeout);
            this._resizeRequestTimeout = undefined;
        });
        $7db29b7aa35273ae$var$_defineProperty(this, "handleServerButtonClick", (event)=>{
            const serverId = parseInt(event.target.getAttribute('minetrack-server-id'));
            const serverRegistration = this._app.serverRegistry.getServerRegistration(serverId);
            if (serverRegistration.isVisible !== event.target.checked) {
                serverRegistration.isVisible = event.target.checked;
                // Any manual changes automatically disables "Only Favorites" mode
                // Otherwise the auto management might overwrite their manual changes
                this._showOnlyFavorites = false;
                this.redraw();
            }
        });
        $7db29b7aa35273ae$var$_defineProperty(this, "handleShowButtonClick", (event)=>{
            const showType = event.target.getAttribute('minetrack-show-type');
            // If set to "Only Favorites", set internal state so that
            // visible graphData is automatically updating when a ServerRegistration's #isVisible changes
            // This is also saved and loaded by #loadLocalStorage & #updateLocalStorage
            this._showOnlyFavorites = showType === 'favorites';
            let redraw = false;
            this._app.serverRegistry.getServerRegistrations().forEach(function(serverRegistration) {
                let isVisible;
                if (showType === 'all') isVisible = true;
                else if (showType === 'none') isVisible = false;
                else if (showType === 'favorites') isVisible = serverRegistration.isFavorite;
                if (serverRegistration.isVisible !== isVisible) {
                    serverRegistration.isVisible = isVisible;
                    redraw = true;
                }
            });
            if (redraw) {
                this.redraw();
                this.updateCheckboxes();
            }
        });
        $7db29b7aa35273ae$var$_defineProperty(this, "handleSettingsToggle", ()=>{
            const element = document.getElementById('big-graph-controls-drawer');
            if (element.style.display !== 'block') element.style.display = 'block';
            else element.style.display = 'none';
        });
        $7db29b7aa35273ae$var$_defineProperty(this, "handleServerIsFavoriteUpdate", (serverRegistration)=>{
            // When in "Only Favorites" mode, visibility is dependent on favorite status
            // Redraw and update elements as needed
            if (this._showOnlyFavorites && serverRegistration.isVisible !== serverRegistration.isFavorite) {
                serverRegistration.isVisible = serverRegistration.isFavorite;
                this.redraw();
                this.updateCheckboxes();
            }
        });
        this._app = app;
        this._graphData = [];
        this._graphTimestamps = [];
        this._hasLoadedSettings = false;
        this._initEventListenersOnce = false;
        this._showOnlyFavorites = false;
        this._hoveredSeriesIndex = -1;
    }
    addGraphPoint(timestamp, playerCounts) {
        if (!this._hasLoadedSettings) // _hasLoadedSettings is controlled by #setGraphData
        // It will only be true once the context has been loaded and initial payload received
        // #addGraphPoint should not be called prior to that since it means the data is racing
        // and the application has received updates prior to the initial state
        return;
        try {
            // Calculate isZoomed before mutating graphData otherwise the indexed values
            // are out of date and will always fail when compared to plotScaleX.min/max
            const plotScaleX = this._plotInstance.scales.x;
            const zoomMin = plotScaleX.min;
            const zoomMax = plotScaleX.max;
            const previousMinTimestamp = this._graphTimestamps[0];
            const previousMaxTimestamp = this._graphTimestamps[this._graphTimestamps.length - 1];
            const isZoomed = plotScaleX.min > previousMinTimestamp || plotScaleX.max < previousMaxTimestamp;
            this._graphTimestamps.push(timestamp);
            for(let i = 0; i < playerCounts.length; i++)this._graphData[i].push(playerCounts[i]);
            // Trim all data arrays to only the relevant portion
            // This keeps it in sync with backend data structures
            const graphMaxLength = this._app.publicConfig.graphMaxLength;
            if (this._graphTimestamps.length > graphMaxLength) this._graphTimestamps.splice(0, this._graphTimestamps.length - graphMaxLength);
            for (const series of this._graphData)if (series.length > graphMaxLength) series.splice(0, series.length - graphMaxLength);
            const currentMinTimestamp = this._graphTimestamps[0];
            const currentMaxTimestamp = this._graphTimestamps[this._graphTimestamps.length - 1];
            this._plotInstance.setData(this.getGraphData(), false);
            this._plotInstance.setScale('x', isZoomed ? {
                min: Math.max(zoomMin, currentMinTimestamp),
                max: Math.min(zoomMax, currentMaxTimestamp)
            } : {
                min: currentMinTimestamp,
                max: currentMaxTimestamp
            });
            const { scaledMin: scaledMin, scaledMax: scaledMax } = (0, $1de7bacd0e15f4f1$export$4ab14d3905033d17).scaleMatrix(this.getVisibleGraphData(), $7db29b7aa35273ae$var$GRAPH_TICK_COUNT, $7db29b7aa35273ae$var$GRAPH_MAX_FACTOR);
            this._plotInstance.setScale('y', {
                min: scaledMin,
                max: scaledMax
            });
        } catch (err) {
            console.error('Failed to update main graph, rebuilding', err);
            this.rebuildPlotInstance();
        }
    }
    loadLocalStorage() {
        if (typeof localStorage !== 'undefined') {
            const showOnlyFavorites = localStorage.getItem($7db29b7aa35273ae$var$SHOW_FAVORITES_STORAGE_KEY);
            if (showOnlyFavorites) this._showOnlyFavorites = true;
            // If only favorites mode is active, use the stored favorite servers data instead
            let serverNames;
            if (this._showOnlyFavorites) serverNames = localStorage.getItem((0, $1e7ce28416c55f9b$export$2c19dd479e63aadf));
            else serverNames = localStorage.getItem($7db29b7aa35273ae$var$HIDDEN_SERVERS_STORAGE_KEY);
            if (serverNames) {
                serverNames = JSON.parse(serverNames);
                // Iterate over all active serverRegistrations
                // This merges saved state with current state to prevent desyncs
                for (const serverRegistration of this._app.serverRegistry.getServerRegistrations())// isVisible will be true if showOnlyFavorites && contained in FAVORITE_SERVERS_STORAGE_KEY
                // OR, if it is NOT contains within HIDDEN_SERVERS_STORAGE_KEY
                // Checks between FAVORITE/HIDDEN keys are mutually exclusive
                if (this._showOnlyFavorites) serverRegistration.isVisible = serverNames.indexOf(serverRegistration.data.name) >= 0;
                else serverRegistration.isVisible = serverNames.indexOf(serverRegistration.data.name) < 0;
            }
        }
    }
    updateLocalStorage() {
        if (typeof localStorage !== 'undefined') {
            // Mutate the serverIds array into server names for storage use
            const serverNames = this._app.serverRegistry.getServerRegistrations().filter((serverRegistration)=>!serverRegistration.isVisible).map((serverRegistration)=>serverRegistration.data.name);
            // Only store if the array contains data, otherwise clear the item
            // If showOnlyFavorites is true, do NOT store serverNames since the state will be auto managed instead
            if (serverNames.length > 0 && !this._showOnlyFavorites) localStorage.setItem($7db29b7aa35273ae$var$HIDDEN_SERVERS_STORAGE_KEY, JSON.stringify(serverNames));
            else localStorage.removeItem($7db29b7aa35273ae$var$HIDDEN_SERVERS_STORAGE_KEY);
            // Only store SHOW_FAVORITES_STORAGE_KEY if true
            if (this._showOnlyFavorites) localStorage.setItem($7db29b7aa35273ae$var$SHOW_FAVORITES_STORAGE_KEY, true);
            else localStorage.removeItem($7db29b7aa35273ae$var$SHOW_FAVORITES_STORAGE_KEY);
        }
    }
    getVisibleGraphData() {
        return this._app.serverRegistry.getServerRegistrations().filter((serverRegistration)=>serverRegistration.isVisible).map((serverRegistration)=>this._graphData[serverRegistration.serverId]);
    }
    getPlotSize() {
        return {
            width: window.innerWidth * 0.9,
            height: window.innerWidth <= 820 ? 220 : 400
        };
    }
    getGraphData() {
        return [
            this._graphTimestamps,
            ...this._graphData
        ];
    }
    getGraphDataPoint(serverId, index) {
        const graphData = this._graphData[serverId];
        if (graphData && index < graphData.length && typeof graphData[index] === 'number') return graphData[index];
    }
    getClosestPlotSeriesIndex(idx, plotInstance = this._plotInstance) {
        if (!plotInstance) return -1;
        let closestSeriesIndex = -1;
        let closestSeriesDist = Number.MAX_VALUE;
        const plotHeight = plotInstance.bbox.height / devicePixelRatio;
        for(let i = 1; i < plotInstance.series.length; i++){
            const series = plotInstance.series[i];
            if (!series.show) continue;
            const point = plotInstance.data[i][idx];
            if (typeof point === 'number') {
                const scale = plotInstance.scales[series.scale];
                const posY = (1 - (point - scale.min) / (scale.max - scale.min)) * plotHeight;
                const dist = Math.abs(posY - plotInstance.cursor.top);
                if (dist < closestSeriesDist) {
                    closestSeriesIndex = i;
                    closestSeriesDist = dist;
                }
            }
        }
        return closestSeriesIndex;
    }
    buildPlotInstance(timestamps, data) {
        // Lazy load settings from localStorage, if any and if enabled
        if (!this._hasLoadedSettings) {
            this._hasLoadedSettings = true;
            this.loadLocalStorage();
        }
        for (const playerCounts of data){
            // Each playerCounts value corresponds to a ServerRegistration
            // Require each array is the length of timestamps, if not, pad at the start with null values to fit to length
            // This ensures newer ServerRegistrations do not left align due to a lower length
            const lengthDiff = timestamps.length - playerCounts.length;
            if (lengthDiff > 0) {
                const padding = Array(lengthDiff).fill(null);
                playerCounts.unshift(...padding);
            }
        }
        this._graphTimestamps = timestamps;
        this._graphData = data;
        const series = this._app.serverRegistry.getServerRegistrations().map((serverRegistration)=>{
            return {
                baseStroke: serverRegistration.data.color,
                displayStroke: serverRegistration.data.color,
                stroke () {
                    return this.displayStroke;
                },
                width: 2,
                value: (_, raw)=>this._app.t('playersCount', {
                        count: (0, $56c847d075380db4$export$f5dd818bff069720)(raw)
                    }),
                show: serverRegistration.isVisible,
                spanGaps: true,
                points: {
                    show: false
                }
            };
        });
        // eslint-disable-next-line new-cap
        this._plotInstance = new (0, $3cd00ee63e984772$export$2e2bcd8739ae039)({
            plugins: [
                (0, $04cccc5b90d17ac6$export$2f2e390e2470b67e)((pos, idx, plotInstance)=>{
                    if (pos) {
                        const closestSeriesIndex = this.getClosestPlotSeriesIndex(idx, plotInstance);
                        this.setHoveredSeriesIndex(closestSeriesIndex);
                        const text = this._app.serverRegistry.getServerRegistrations().filter((serverRegistration)=>serverRegistration.isVisible).sort((a, b)=>{
                            const pointA = this.getGraphDataPoint(a.serverId, idx);
                            const pointB = this.getGraphDataPoint(b.serverId, idx);
                            if (pointA !== pointB) return (pointB || 0) - (pointA || 0);
                            if (a.isFavorite !== b.isFavorite) return a.isFavorite ? -1 : 1;
                            return a.data.name.localeCompare(b.data.name);
                        }).map((serverRegistration)=>{
                            const point = this.getGraphDataPoint(serverRegistration.serverId, idx);
                            let serverName = serverRegistration.data.name;
                            if (closestSeriesIndex === serverRegistration.getGraphDataIndex()) serverName = `<strong>${serverName}</strong>`;
                            if (serverRegistration.isFavorite) serverName = `<span class="${this._app.favoritesManager.getIconClass(true)}"></span> ${serverName}`;
                            return `${serverName}: ${(0, $56c847d075380db4$export$f5dd818bff069720)(point)}`;
                        }).join('<br>') + `<br><br><strong>${(0, $56c847d075380db4$export$b144b3a88a3e7934)(this._graphTimestamps[idx], this._app.intlLocale)}</strong>`;
                        this._app.tooltip.set(pos.left, pos.top, 10, 10, text);
                    } else {
                        this.setHoveredSeriesIndex(-1);
                        this._app.tooltip.hide();
                    }
                })
            ],
            ...this.getPlotSize(),
            cursor: {
                y: false
            },
            series: [
                {},
                ...series
            ],
            axes: [
                {
                    font: '13px "Open Sans", sans-serif',
                    stroke: '#FFF',
                    grid: {
                        show: false
                    },
                    space: 60,
                    values: (_, ticks)=>ticks.map((timestamp, index)=>{
                            const date = new Date(timestamp * 1000);
                            const formattedTime = date.toLocaleTimeString(this._app.intlLocale, {
                                hour12: false,
                                hour: '2-digit',
                                minute: '2-digit'
                            });
                            if (index === 0) {
                                const formattedDate = date.toLocaleDateString(this._app.intlLocale);
                                return `${formattedTime}\n${formattedDate}`;
                            }
                            return formattedTime;
                        })
                },
                {
                    font: '14px "Open Sans", sans-serif',
                    stroke: '#FFF',
                    size: 65,
                    grid: {
                        stroke: '#333',
                        width: 1
                    },
                    split: ()=>{
                        const visibleGraphData = this.getVisibleGraphData();
                        const { scaledMax: scaledMax, scale: scale } = (0, $1de7bacd0e15f4f1$export$4ab14d3905033d17).scaleMatrix(visibleGraphData, $7db29b7aa35273ae$var$GRAPH_TICK_COUNT, $7db29b7aa35273ae$var$GRAPH_MAX_FACTOR);
                        return (0, $1de7bacd0e15f4f1$export$4ab14d3905033d17).generateTicks(0, scaledMax, scale);
                    }
                }
            ],
            scales: {
                y: {
                    auto: false,
                    range: ()=>{
                        const visibleGraphData = this.getVisibleGraphData();
                        const { scaledMin: scaledMin, scaledMax: scaledMax } = (0, $1de7bacd0e15f4f1$export$4ab14d3905033d17).scaleMatrix(visibleGraphData, $7db29b7aa35273ae$var$GRAPH_TICK_COUNT, $7db29b7aa35273ae$var$GRAPH_MAX_FACTOR);
                        return [
                            scaledMin,
                            scaledMax
                        ];
                    }
                }
            },
            legend: {
                show: false
            }
        }, this.getGraphData(), document.getElementById('big-graph'));
        // Show the settings-toggle element
        document.getElementById('settings-toggle').style.display = 'inline-block';
    }
    rebuildPlotInstance() {
        const timestamps = this._graphTimestamps.slice();
        const data = this._graphData.map((series)=>series.slice());
        if (this._plotInstance) {
            this._plotInstance.destroy();
            this._plotInstance = undefined;
        }
        this.buildPlotInstance(timestamps, data);
        this.redraw();
    }
    handleServerColorUpdate(serverRegistration) {
        if (!this._plotInstance) return;
        const plotSeries = this._plotInstance.series[serverRegistration.getGraphDataIndex()];
        plotSeries.baseStroke = serverRegistration.data.color;
        plotSeries.displayStroke = serverRegistration.data.color;
        this.applySeriesStyling();
    }
    setHoveredSeriesIndex(seriesIndex) {
        if (this._hoveredSeriesIndex !== seriesIndex) {
            this._hoveredSeriesIndex = seriesIndex;
            this.applySeriesStyling();
        }
    }
    applySeriesStyling() {
        if (!this._plotInstance) return;
        for(let i = 1; i < this._plotInstance.series.length; i++){
            const series = this._plotInstance.series[i];
            if (this._hoveredSeriesIndex > 0) {
                series.displayStroke = i === this._hoveredSeriesIndex ? series.baseStroke : $7db29b7aa35273ae$var$hexToRgba(series.baseStroke, 0.28);
                series.width = i === this._hoveredSeriesIndex ? 4 : 2;
            } else {
                series.displayStroke = series.baseStroke;
                series.width = 2;
            }
        }
        this._plotInstance.redraw();
    }
    requestResize() {
        // Only resize when _plotInstance is defined
        // Set a timeout to resize after resize events have not been fired for some duration of time
        // This prevents burning CPU time for multiple, rapid resize events
        if (this._plotInstance) {
            if (this._resizeRequestTimeout) clearTimeout(this._resizeRequestTimeout);
            // Schedule new delayed resize call
            // This can be cancelled by #requestResize, #resize and #reset
            this._resizeRequestTimeout = setTimeout(this.resize, 200);
        }
    }
    initEventListeners() {
        if (!this._initEventListenersOnce) {
            this._initEventListenersOnce = true;
            // These listeners should only be init once since they attach to persistent elements
            document.getElementById('settings-toggle').addEventListener('click', this.handleSettingsToggle, false);
            document.querySelectorAll('.graph-controls-show').forEach((element)=>{
                element.addEventListener('click', this.handleShowButtonClick, false);
            });
        }
        // These listeners should be bound each #initEventListeners call since they are for newly created elements
        document.querySelectorAll('.graph-control').forEach((element)=>{
            element.addEventListener('click', this.handleServerButtonClick, false);
        });
    }
    updateCheckboxes() {
        document.querySelectorAll('.graph-control').forEach((checkbox)=>{
            const serverId = parseInt(checkbox.getAttribute('minetrack-server-id'));
            const serverRegistration = this._app.serverRegistry.getServerRegistration(serverId);
            checkbox.checked = serverRegistration.isVisible;
        });
    }
    reset() {
        // Destroy graphs and unload references
        // uPlot#destroy handles listener de-registration, DOM reset, etc
        if (this._plotInstance) {
            this._plotInstance.destroy();
            this._plotInstance = undefined;
        }
        this._graphTimestamps = [];
        this._graphData = [];
        this._hasLoadedSettings = false;
        this._hoveredSeriesIndex = -1;
        // Fire #clearTimeout if the timeout is currently defined
        if (this._resizeRequestTimeout) {
            clearTimeout(this._resizeRequestTimeout);
            this._resizeRequestTimeout = undefined;
        }
        // Reset modified DOM structures
        document.getElementById('big-graph-checkboxes').innerHTML = '';
        document.getElementById('big-graph-controls').style.display = 'none';
        document.getElementById('settings-toggle').style.display = 'none';
    }
}
function $7db29b7aa35273ae$var$hexToRgba(hexColor, alpha) {
    const normalizedColor = hexColor.replace('#', '');
    const r = parseInt(normalizedColor.slice(0, 2), 16);
    const g = parseInt(normalizedColor.slice(2, 4), 16);
    const b = parseInt(normalizedColor.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}



function $35c467b7b63a8b20$var$_defineProperty(e, r, t) {
    return (r = $35c467b7b63a8b20$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $35c467b7b63a8b20$var$_toPropertyKey(t) {
    var i = $35c467b7b63a8b20$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $35c467b7b63a8b20$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $35c467b7b63a8b20$export$20413a6f534d0a80 {
    constructor(app){
        $35c467b7b63a8b20$var$_defineProperty(this, "redraw", ()=>{
            const serverRegistrations = this._app.serverRegistry.getServerRegistrations().sort(function(a, b) {
                return a.playerCount - b.playerCount;
            });
            const totalPlayers = this._app.getTotalPlayerCount();
            let leftPadding = 0;
            for (const serverRegistration of serverRegistrations){
                const width = Math.round(serverRegistration.playerCount / totalPlayers * this._parent.offsetWidth);
                // Update position/width
                // leftPadding is a sum of previous iterations width value
                const div = document.getElementById(`perc-bar-part_${serverRegistration.serverId}`) || this.createPart(serverRegistration);
                const widthPixels = `${width}px`;
                const leftPaddingPixels = `${leftPadding}px`;
                // Only redraw if needed
                if (div.style.width !== widthPixels || div.style.left !== leftPaddingPixels) {
                    div.style.width = widthPixels;
                    div.style.left = leftPaddingPixels;
                }
                if (div.style.background !== serverRegistration.data.color) div.style.background = serverRegistration.data.color;
                leftPadding += width;
            }
        });
        $35c467b7b63a8b20$var$_defineProperty(this, "handleMouseOver", (event)=>{
            const serverId = parseInt(event.target.getAttribute('minetrack-server-id'));
            const serverRegistration = this._app.serverRegistry.getServerRegistration(serverId);
            this._app.tooltip.set(event.target.offsetLeft, event.target.offsetTop, 10, this._parent.offsetTop + this._parent.offsetHeight + 10, `${typeof serverRegistration.rankIndex !== 'undefined' ? `#${serverRegistration.rankIndex + 1} ` : ''}
      ${serverRegistration.data.name}<br>
      ${this._app.t('playersCount', {
                count: (0, $56c847d075380db4$export$f5dd818bff069720)(serverRegistration.playerCount)
            })}<br>
      <strong>${(0, $56c847d075380db4$export$32e6b1ae352e94d6)(serverRegistration.playerCount, this._app.getTotalPlayerCount(), this._app.intlLocale)}</strong>`);
        });
        $35c467b7b63a8b20$var$_defineProperty(this, "handleMouseOut", ()=>{
            this._app.tooltip.hide();
        });
        this._app = app;
        this._parent = document.getElementById('perc-bar');
    }
    createPart(serverRegistration) {
        const div = document.createElement('div');
        div.id = `perc-bar-part_${serverRegistration.serverId}`;
        div.style.background = serverRegistration.data.color;
        div.setAttribute('class', 'perc-bar-part');
        div.setAttribute('minetrack-server-id', serverRegistration.serverId);
        this._parent.appendChild(div);
        // Define events once during creation
        div.addEventListener('mouseover', this.handleMouseOver, false);
        div.addEventListener('mouseout', this.handleMouseOut, false);
        return div;
    }
    reset() {
        // Reset modified DOM elements
        this._parent.innerHTML = '';
    }
}




var $8a077421dab87d30$exports = {};
$8a077421dab87d30$exports = JSON.parse('{"en":{"title":"Minetrack Sweden","metaDescription":"Minetrack Sweden is a live Minecraft server tracker aiming to track player statistics for all major servers in Sweden","statusConnecting":"Connecting...","subtitle":"Tracking {statNetworks} Minecraft servers with {statTotalPlayers} players across Sweden","sortByLabel":"Sort By","graphControlsLabel":"Graph Controls","showAll":"Show All","hideAll":"Hide All","onlyFavorites":"Only Favorites","footerPoweredBy":"Powered by {link} (open-source)","switchLanguageLabel":"Set locale:","languageToggleLabel":"Svenska","serverProposalButton":"Suggest a server","serverProposalTitle":"Suggest a Minecraft server","serverProposalIntro":"Know a Swedish server that should be tracked?","serverProposalName":"Server name","serverProposalAddress":"Server address","serverProposalWebsite":"Website (optional)","serverProposalNotes":"Notes (optional)","serverProposalSubmit":"Send proposal","serverProposalCancel":"Cancel","serverProposalSuccess":"Thanks! Your proposal has been sent.","serverProposalError":"The proposal could not be sent. Please try again later.","captionLoading":"Loading...","captionLostConnection":"Lost connection!","captionDisconnected":"Disconnected due to error.","captionReconnecting":"Reconnecting...","captionReconnectingIn":"Reconnecting in {seconds}s...","playersLabel":"Players","peakLabel":"{duration} Peak","recordLabel":"Record","atDateTime":"At {date} {time}","atTime":"At {time}","failedToPing":"Failed to ping","clickToCopy":"Click to copy {address}","copied":"Copied {address}","couldNotCopy":"Could not copy {address}","playersCount":"{count} Players"},"sv":{"title":"Minetrack Sweden","metaDescription":"Minetrack Sweden \xe4r en sida med m\xe5l att sp\xe5ra spelarstatistik f\xf6r alla st\xf6rre servrar i Sverige","statusConnecting":"Ansluter...","subtitle":"Sp\xe5rar {statNetworks} Minecraft-servrar med {statTotalPlayers} spelare i Sverige","sortByLabel":"Sortera efter","graphControlsLabel":"Graf- inst\xe4llningar","showAll":"Visa alla","hideAll":"D\xf6lj alla","onlyFavorites":"Endast favoriter","footerPoweredBy":"Drivs av {link} (\xf6ppen k\xe4llkod)","switchLanguageLabel":"Byt spr\xe5k:","languageToggleLabel":"English","serverProposalButton":"F\xf6resl\xe5 en server","serverProposalTitle":"F\xf6resl\xe5 en Minecraft-server","serverProposalIntro":"K\xe4nner du till en svensk server som borde sp\xe5ras?","serverProposalName":"Servernamn","serverProposalAddress":"Serveradress","serverProposalWebsite":"Webbplats (valfritt)","serverProposalNotes":"\xd6vriga uppgifter (valfritt)","serverProposalSubmit":"Skicka f\xf6rslag","serverProposalCancel":"Avbryt","serverProposalSuccess":"Tack! Ditt f\xf6rslag har skickats.","serverProposalError":"F\xf6rslaget kunde inte skickas. F\xf6rs\xf6k igen senare.","captionLoading":"Laddar...","captionLostConnection":"Anslutningen tappades!","captionDisconnected":"Fr\xe5nkopplad p\xe5 grund av ett fel...","captionReconnecting":"Ansluter igen...","captionReconnectingIn":"Ansluter igen om {seconds}s...","playersLabel":"Spelare","peakLabel":"{duration} topp","recordLabel":"Rekord","atDateTime":"Vid {date} {time}","atTime":"Vid {time}","failedToPing":"Pingning misslyckades","clickToCopy":"Klicka f\xf6r att kopiera {address}","copied":"{address} kopierad","couldNotCopy":"Kunde inte kopiera {address}","playersCount":"{count} spelare"}}');


function $164e9869f1cc195b$export$625550452a3fa3ec(locale, key, vars) {
    const template = ((0, (/*@__PURE__*/$parcel$interopDefault($8a077421dab87d30$exports)))[locale] || (0, (/*@__PURE__*/$parcel$interopDefault($8a077421dab87d30$exports))).en)[key];
    if (vars) return template.replace(/{(\w+)}/g, (match, name)=>Object.prototype.hasOwnProperty.call(vars, name) ? vars[name] : match);
    return template;
}


function $1099308de2e4bfe7$var$_defineProperty(e, r, t) {
    return (r = $1099308de2e4bfe7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1099308de2e4bfe7$var$_toPropertyKey(t) {
    var i = $1099308de2e4bfe7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1099308de2e4bfe7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $1099308de2e4bfe7$var$LOCALE_STORAGE_KEY = 'minetrack_locale';
class $1099308de2e4bfe7$export$86fbec116b87613f {
    constructor(){
        $1099308de2e4bfe7$var$_defineProperty(this, "publicConfig", void 0);
        $1099308de2e4bfe7$var$_defineProperty(this, "addServer", (serverId, payload, timestampPoints)=>{
            // Even if the backend has never pinged the server, the frontend is promised a placeholder object.
            // result = undefined
            // error = defined with "Waiting" description
            // info = safely defined with configured data
            const serverRegistration = this.serverRegistry.createServerRegistration(serverId);
            serverRegistration.initServerStatus(payload);
            // playerCountHistory is only defined when the backend has previous ping data
            // undefined playerCountHistory means this is a placeholder ping generated by the backend
            if (typeof payload.playerCountHistory !== 'undefined') {
                // Push the historical data into the graph
                // This will trim and format the data so it is ready for the graph to render once init
                serverRegistration.addGraphPoints(payload.playerCountHistory, timestampPoints);
                // Set initial playerCount to the payload's value
                // This will always exist since it is explicitly generated by the backend
                // This is used for any post-add rendering of things like the percentageBar
                serverRegistration.playerCount = payload.playerCount;
            }
            // Create the plot instance internally with the restructured and cleaned data
            serverRegistration.buildPlotInstance();
            // Handle the last known state (if any) as an incoming update
            // This triggers the main update pipeline and enables centralized update handling
            serverRegistration.updateServerStatus(payload, this.publicConfig.minecraftVersions);
            // Allow the ServerRegistration to bind any DOM events with app instance context
            serverRegistration.initEventListeners();
        });
        $1099308de2e4bfe7$var$_defineProperty(this, "updateGlobalStats", ()=>{
            // Only redraw when needed
            // These operations are relatively cheap, but the site already does too much rendering
            const totalPlayerCount = this.getTotalPlayerCount();
            if (totalPlayerCount !== this._lastTotalPlayerCount) {
                this._lastTotalPlayerCount = totalPlayerCount;
                document.getElementById('stat_totalPlayers').innerText = (0, $56c847d075380db4$export$f5dd818bff069720)(totalPlayerCount);
            }
            // Only redraw when needed
            // These operations are relatively cheap, but the site already does too much rendering
            const serverRegistrationCount = this.serverRegistry.getServerRegistrations().length;
            if (serverRegistrationCount !== this._lastServerRegistrationCount) {
                this._lastServerRegistrationCount = serverRegistrationCount;
                document.getElementById('stat_networks').innerText = serverRegistrationCount;
            }
        });
        this.locale = document.documentElement.lang === 'sv' ? 'sv' : 'en';
        this.intlLocale = this.locale === 'sv' ? 'sv-SE' : 'en-GB';
        this.t = (key, vars)=>(0, $164e9869f1cc195b$export$625550452a3fa3ec)(this.locale, key, vars);
        this.tooltip = new (0, $56c847d075380db4$export$28c660c63b792dea)();
        this.caption = new (0, $56c847d075380db4$export$32fbfacc5d962e0c)();
        this.copyToast = new (0, $56c847d075380db4$export$ff541c634b6ae8ec)();
        this.serverRegistry = new (0, $55c6659bb18364ca$export$1115b10cc9bb0fa8)(this);
        this.socketManager = new (0, $e0890a2aab451ef8$export$c91428cbd4f5850d)(this);
        this.sortController = new (0, $07537187749245e4$export$765594e5be71a851)(this);
        this.graphDisplayManager = new (0, $7db29b7aa35273ae$export$2fa5fa2e8b5ec38b)(this);
        this.percentageBar = new (0, $35c467b7b63a8b20$export$20413a6f534d0a80)(this);
        this.favoritesManager = new (0, $1e7ce28416c55f9b$export$bf46da6bfe361ab1)(this);
        this._taskIds = [];
    }
    // Called once the DOM is ready and the app can begin setup
    init() {
        // Only explicit locale URLs represent a visitor's choice. The root route
        // remains the English fallback when no preference has been stored.
        if (window.location.pathname === '/en' || window.location.pathname === '/sv') localStorage.setItem($1099308de2e4bfe7$var$LOCALE_STORAGE_KEY, this.locale);
        this.socketManager.createWebSocket();
    }
    setPageReady(isReady) {
        document.getElementById('push').style.display = isReady ? 'block' : 'none';
        document.getElementById('footer').style.display = isReady ? 'block' : 'none';
        document.getElementById('status-overlay').style.display = isReady ? 'none' : 'block';
    }
    setPublicConfig(publicConfig) {
        this.publicConfig = publicConfig;
        this.serverRegistry.assignServers(publicConfig.servers);
        // Start repeating frontend tasks once it has received enough data to be considered active
        // This simplifies management logic at the cost of each task needing to safely handle empty data
        this.initTasks();
    }
    handleSyncComplete() {
        this.caption.hide();
        // Load favorites since all servers are registered
        this.favoritesManager.loadLocalStorage();
        // Run a single bulk server sort instead of per-add event since there may be multiple
        this.sortController.show();
        this.percentageBar.redraw();
        // The data may not be there to correctly compute values, but run an attempt
        // Otherwise they will be updated by #initTasks
        this.updateGlobalStats();
    }
    initTasks() {
        this._taskIds.push(setInterval(this.sortController.sortServers, 5000));
    }
    handleDisconnect() {
        this.tooltip.hide();
        // Reset individual tracker elements to flush any held data
        this.serverRegistry.reset();
        this.socketManager.reset();
        this.sortController.reset();
        this.graphDisplayManager.reset();
        this.percentageBar.reset();
        // Undefine publicConfig, resynced during the connection handshake
        this.publicConfig = undefined;
        // Clear all task ids, if any
        this._taskIds.forEach(clearInterval);
        this._taskIds = [];
        // Reset hidden values created by #updateGlobalStats
        this._lastTotalPlayerCount = undefined;
        this._lastServerRegistrationCount = undefined;
        // Reset modified DOM structures
        document.getElementById('stat_totalPlayers').innerText = 0;
        document.getElementById('stat_networks').innerText = 0;
        this.setPageReady(false);
    }
    getTotalPlayerCount() {
        return this.serverRegistry.getServerRegistrations().map((serverRegistration)=>serverRegistration.playerCount).reduce((sum, current)=>sum + current, 0);
    }
}


function $d6c298ceffc2ac37$export$4bdf610130959f04() {
    const toggle = document.getElementById('server-proposal-toggle');
    const form = document.getElementById('server-proposal-form');
    // The proposal UI is rendered only when a webhook has been configured.
    if (!toggle || !form) return;
    const panel = document.getElementById('server-proposal');
    const backdrop = document.getElementById('server-proposal-backdrop');
    const cancel = document.getElementById('server-proposal-cancel');
    const status = document.getElementById('server-proposal-status');
    const submit = document.getElementById('server-proposal-submit');
    const setPanelOpen = (isOpen)=>{
        panel.hidden = !isOpen;
        backdrop.hidden = !isOpen;
        if (isOpen) document.getElementById('server-proposal-name').focus();
    };
    toggle.addEventListener('click', ()=>{
        setPanelOpen(panel.hidden);
    });
    cancel.addEventListener('click', ()=>{
        setPanelOpen(false);
        status.textContent = '';
    });
    backdrop.addEventListener('click', ()=>setPanelOpen(false));
    form.addEventListener('submit', async (event)=>{
        event.preventDefault();
        const formData = new FormData(form);
        const payload = Object.fromEntries(formData.entries());
        submit.disabled = true;
        status.textContent = '';
        try {
            const response = await fetch('/api/server-proposals', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) throw new Error(`Request failed with ${response.status}`);
            form.reset();
            status.textContent = status.dataset.success;
            status.className = 'server-proposal-status is-success';
        } catch (err) {
            console.error('Failed to submit server proposal', err);
            status.textContent = status.dataset.error;
            status.className = 'server-proposal-status is-error';
        } finally{
            submit.disabled = false;
        }
    });
}


const $050787e545403cda$var$app = new (0, $1099308de2e4bfe7$export$86fbec116b87613f)();
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $d6c298ceffc2ac37$export$4bdf610130959f04)();
    $050787e545403cda$var$app.init();
    window.addEventListener('resize', function() {
        $050787e545403cda$var$app.percentageBar.redraw();
        // Delegate to GraphDisplayManager which can check if the resize is necessary
        $050787e545403cda$var$app.graphDisplayManager.requestResize();
        // Per-server graphs are cheap to resize and have no existing debounce mechanism
        $050787e545403cda$var$app.serverRegistry.resizeAll();
    }, false);
}, false);


//# sourceMappingURL=html.224bdede.js.map
